/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Big number integer */
  BigInt: { input: any; output: any };
  /** A date-time string in simplified extended ISO 8601 format (YYYY-MM-DDTHH:mm:ss.sssZ) */
  DateTime: { input: any; output: any };
};

export type Account = {
  __typename?: 'Account';
  avnLifts: Array<AvnLift>;
  avnLowers: Array<AvnLower>;
  earnedRewards: Array<EarnedRewards>;
  /** Account address */
  id: Scalars['String']['output'];
  operator?: Maybe<OperatorAccount>;
  registrar?: Maybe<RegistrarAccount>;
  worker?: Maybe<WorkerAccount>;
};

export type AccountAvnLiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLiftOrderByInput>>;
  where?: InputMaybe<AvnLiftWhereInput>;
};

export type AccountAvnLowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLowerOrderByInput>>;
  where?: InputMaybe<AvnLowerWhereInput>;
};

export type AccountEarnedRewardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EarnedRewardsOrderByInput>>;
  where?: InputMaybe<EarnedRewardsWhereInput>;
};

export type AccountEdge = {
  __typename?: 'AccountEdge';
  cursor: Scalars['String']['output'];
  node: Account;
};

export enum AccountOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  RegistrarFriendlyNameAsc = 'registrar_friendlyName_ASC',
  RegistrarFriendlyNameAscNullsFirst = 'registrar_friendlyName_ASC_NULLS_FIRST',
  RegistrarFriendlyNameAscNullsLast = 'registrar_friendlyName_ASC_NULLS_LAST',
  RegistrarFriendlyNameDesc = 'registrar_friendlyName_DESC',
  RegistrarFriendlyNameDescNullsFirst = 'registrar_friendlyName_DESC_NULLS_FIRST',
  RegistrarFriendlyNameDescNullsLast = 'registrar_friendlyName_DESC_NULLS_LAST',
  RegistrarIdAsc = 'registrar_id_ASC',
  RegistrarIdAscNullsFirst = 'registrar_id_ASC_NULLS_FIRST',
  RegistrarIdAscNullsLast = 'registrar_id_ASC_NULLS_LAST',
  RegistrarIdDesc = 'registrar_id_DESC',
  RegistrarIdDescNullsFirst = 'registrar_id_DESC_NULLS_FIRST',
  RegistrarIdDescNullsLast = 'registrar_id_DESC_NULLS_LAST',
  RegistrarIsAllowedAsc = 'registrar_isAllowed_ASC',
  RegistrarIsAllowedAscNullsFirst = 'registrar_isAllowed_ASC_NULLS_FIRST',
  RegistrarIsAllowedAscNullsLast = 'registrar_isAllowed_ASC_NULLS_LAST',
  RegistrarIsAllowedDesc = 'registrar_isAllowed_DESC',
  RegistrarIsAllowedDescNullsFirst = 'registrar_isAllowed_DESC_NULLS_FIRST',
  RegistrarIsAllowedDescNullsLast = 'registrar_isAllowed_DESC_NULLS_LAST',
  RegistrarLegalLocationAsc = 'registrar_legalLocation_ASC',
  RegistrarLegalLocationAscNullsFirst = 'registrar_legalLocation_ASC_NULLS_FIRST',
  RegistrarLegalLocationAscNullsLast = 'registrar_legalLocation_ASC_NULLS_LAST',
  RegistrarLegalLocationDesc = 'registrar_legalLocation_DESC',
  RegistrarLegalLocationDescNullsFirst = 'registrar_legalLocation_DESC_NULLS_FIRST',
  RegistrarLegalLocationDescNullsLast = 'registrar_legalLocation_DESC_NULLS_LAST',
  WorkerAddressAsc = 'worker_address_ASC',
  WorkerAddressAscNullsFirst = 'worker_address_ASC_NULLS_FIRST',
  WorkerAddressAscNullsLast = 'worker_address_ASC_NULLS_LAST',
  WorkerAddressDesc = 'worker_address_DESC',
  WorkerAddressDescNullsFirst = 'worker_address_DESC_NULLS_FIRST',
  WorkerAddressDescNullsLast = 'worker_address_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST',
}

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  avnLifts_every?: InputMaybe<AvnLiftWhereInput>;
  avnLifts_none?: InputMaybe<AvnLiftWhereInput>;
  avnLifts_some?: InputMaybe<AvnLiftWhereInput>;
  avnLowers_every?: InputMaybe<AvnLowerWhereInput>;
  avnLowers_none?: InputMaybe<AvnLowerWhereInput>;
  avnLowers_some?: InputMaybe<AvnLowerWhereInput>;
  earnedRewards_every?: InputMaybe<EarnedRewardsWhereInput>;
  earnedRewards_none?: InputMaybe<EarnedRewardsWhereInput>;
  earnedRewards_some?: InputMaybe<EarnedRewardsWhereInput>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  registrar?: InputMaybe<RegistrarAccountWhereInput>;
  registrar_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerAccountWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActiveRewardPeriodInfo = {
  __typename?: 'ActiveRewardPeriodInfo';
  blockNumber: Scalars['Int']['output'];
  firstBlock: Scalars['Int']['output'];
  /** Index */
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
};

export type ActiveRewardPeriodInfoEdge = {
  __typename?: 'ActiveRewardPeriodInfoEdge';
  cursor: Scalars['String']['output'];
  node: ActiveRewardPeriodInfo;
};

export enum ActiveRewardPeriodInfoOrderByInput {
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  FirstBlockAsc = 'firstBlock_ASC',
  FirstBlockAscNullsFirst = 'firstBlock_ASC_NULLS_FIRST',
  FirstBlockAscNullsLast = 'firstBlock_ASC_NULLS_LAST',
  FirstBlockDesc = 'firstBlock_DESC',
  FirstBlockDescNullsFirst = 'firstBlock_DESC_NULLS_FIRST',
  FirstBlockDescNullsLast = 'firstBlock_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IndexAsc = 'index_ASC',
  IndexAscNullsFirst = 'index_ASC_NULLS_FIRST',
  IndexAscNullsLast = 'index_ASC_NULLS_LAST',
  IndexDesc = 'index_DESC',
  IndexDescNullsFirst = 'index_DESC_NULLS_FIRST',
  IndexDescNullsLast = 'index_DESC_NULLS_LAST',
  LengthAsc = 'length_ASC',
  LengthAscNullsFirst = 'length_ASC_NULLS_FIRST',
  LengthAscNullsLast = 'length_ASC_NULLS_LAST',
  LengthDesc = 'length_DESC',
  LengthDescNullsFirst = 'length_DESC_NULLS_FIRST',
  LengthDescNullsLast = 'length_DESC_NULLS_LAST',
}

export type ActiveRewardPeriodInfoWhereInput = {
  AND?: InputMaybe<Array<ActiveRewardPeriodInfoWhereInput>>;
  OR?: InputMaybe<Array<ActiveRewardPeriodInfoWhereInput>>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  firstBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  firstBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  firstBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  firstBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  index_eq?: InputMaybe<Scalars['Int']['input']>;
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  index_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  index_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  index_not_eq?: InputMaybe<Scalars['Int']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  length_eq?: InputMaybe<Scalars['Int']['input']>;
  length_gt?: InputMaybe<Scalars['Int']['input']>;
  length_gte?: InputMaybe<Scalars['Int']['input']>;
  length_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  length_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  length_lt?: InputMaybe<Scalars['Int']['input']>;
  length_lte?: InputMaybe<Scalars['Int']['input']>;
  length_not_eq?: InputMaybe<Scalars['Int']['input']>;
  length_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ActiveRewardPeriodInfosConnection = {
  __typename?: 'ActiveRewardPeriodInfosConnection';
  edges: Array<ActiveRewardPeriodInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetDetails = {
  __typename?: 'AssetDetails';
  accounts: Scalars['Int']['output'];
  admin: Account;
  approvals: Scalars['Int']['output'];
  deposit: Scalars['BigInt']['output'];
  freezer: Account;
  id: Scalars['String']['output'];
  isSufficient: Scalars['Boolean']['output'];
  issuer: Account;
  minBalance: Scalars['BigInt']['output'];
  owner: Account;
  status: AssetStatus;
  sufficients: Scalars['Int']['output'];
  supply: Scalars['BigInt']['output'];
  v3MultiLocation: Scalars['String']['output'];
};

export type AssetDetailsConnection = {
  __typename?: 'AssetDetailsConnection';
  edges: Array<AssetDetailsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetDetailsEdge = {
  __typename?: 'AssetDetailsEdge';
  cursor: Scalars['String']['output'];
  node: AssetDetails;
};

export enum AssetDetailsOrderByInput {
  AccountsAsc = 'accounts_ASC',
  AccountsAscNullsFirst = 'accounts_ASC_NULLS_FIRST',
  AccountsAscNullsLast = 'accounts_ASC_NULLS_LAST',
  AccountsDesc = 'accounts_DESC',
  AccountsDescNullsFirst = 'accounts_DESC_NULLS_FIRST',
  AccountsDescNullsLast = 'accounts_DESC_NULLS_LAST',
  AdminIdAsc = 'admin_id_ASC',
  AdminIdAscNullsFirst = 'admin_id_ASC_NULLS_FIRST',
  AdminIdAscNullsLast = 'admin_id_ASC_NULLS_LAST',
  AdminIdDesc = 'admin_id_DESC',
  AdminIdDescNullsFirst = 'admin_id_DESC_NULLS_FIRST',
  AdminIdDescNullsLast = 'admin_id_DESC_NULLS_LAST',
  ApprovalsAsc = 'approvals_ASC',
  ApprovalsAscNullsFirst = 'approvals_ASC_NULLS_FIRST',
  ApprovalsAscNullsLast = 'approvals_ASC_NULLS_LAST',
  ApprovalsDesc = 'approvals_DESC',
  ApprovalsDescNullsFirst = 'approvals_DESC_NULLS_FIRST',
  ApprovalsDescNullsLast = 'approvals_DESC_NULLS_LAST',
  DepositAsc = 'deposit_ASC',
  DepositAscNullsFirst = 'deposit_ASC_NULLS_FIRST',
  DepositAscNullsLast = 'deposit_ASC_NULLS_LAST',
  DepositDesc = 'deposit_DESC',
  DepositDescNullsFirst = 'deposit_DESC_NULLS_FIRST',
  DepositDescNullsLast = 'deposit_DESC_NULLS_LAST',
  FreezerIdAsc = 'freezer_id_ASC',
  FreezerIdAscNullsFirst = 'freezer_id_ASC_NULLS_FIRST',
  FreezerIdAscNullsLast = 'freezer_id_ASC_NULLS_LAST',
  FreezerIdDesc = 'freezer_id_DESC',
  FreezerIdDescNullsFirst = 'freezer_id_DESC_NULLS_FIRST',
  FreezerIdDescNullsLast = 'freezer_id_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IsSufficientAsc = 'isSufficient_ASC',
  IsSufficientAscNullsFirst = 'isSufficient_ASC_NULLS_FIRST',
  IsSufficientAscNullsLast = 'isSufficient_ASC_NULLS_LAST',
  IsSufficientDesc = 'isSufficient_DESC',
  IsSufficientDescNullsFirst = 'isSufficient_DESC_NULLS_FIRST',
  IsSufficientDescNullsLast = 'isSufficient_DESC_NULLS_LAST',
  IssuerIdAsc = 'issuer_id_ASC',
  IssuerIdAscNullsFirst = 'issuer_id_ASC_NULLS_FIRST',
  IssuerIdAscNullsLast = 'issuer_id_ASC_NULLS_LAST',
  IssuerIdDesc = 'issuer_id_DESC',
  IssuerIdDescNullsFirst = 'issuer_id_DESC_NULLS_FIRST',
  IssuerIdDescNullsLast = 'issuer_id_DESC_NULLS_LAST',
  MinBalanceAsc = 'minBalance_ASC',
  MinBalanceAscNullsFirst = 'minBalance_ASC_NULLS_FIRST',
  MinBalanceAscNullsLast = 'minBalance_ASC_NULLS_LAST',
  MinBalanceDesc = 'minBalance_DESC',
  MinBalanceDescNullsFirst = 'minBalance_DESC_NULLS_FIRST',
  MinBalanceDescNullsLast = 'minBalance_DESC_NULLS_LAST',
  OwnerIdAsc = 'owner_id_ASC',
  OwnerIdAscNullsFirst = 'owner_id_ASC_NULLS_FIRST',
  OwnerIdAscNullsLast = 'owner_id_ASC_NULLS_LAST',
  OwnerIdDesc = 'owner_id_DESC',
  OwnerIdDescNullsFirst = 'owner_id_DESC_NULLS_FIRST',
  OwnerIdDescNullsLast = 'owner_id_DESC_NULLS_LAST',
  StatusAsc = 'status_ASC',
  StatusAscNullsFirst = 'status_ASC_NULLS_FIRST',
  StatusAscNullsLast = 'status_ASC_NULLS_LAST',
  StatusDesc = 'status_DESC',
  StatusDescNullsFirst = 'status_DESC_NULLS_FIRST',
  StatusDescNullsLast = 'status_DESC_NULLS_LAST',
  SufficientsAsc = 'sufficients_ASC',
  SufficientsAscNullsFirst = 'sufficients_ASC_NULLS_FIRST',
  SufficientsAscNullsLast = 'sufficients_ASC_NULLS_LAST',
  SufficientsDesc = 'sufficients_DESC',
  SufficientsDescNullsFirst = 'sufficients_DESC_NULLS_FIRST',
  SufficientsDescNullsLast = 'sufficients_DESC_NULLS_LAST',
  SupplyAsc = 'supply_ASC',
  SupplyAscNullsFirst = 'supply_ASC_NULLS_FIRST',
  SupplyAscNullsLast = 'supply_ASC_NULLS_LAST',
  SupplyDesc = 'supply_DESC',
  SupplyDescNullsFirst = 'supply_DESC_NULLS_FIRST',
  SupplyDescNullsLast = 'supply_DESC_NULLS_LAST',
  V3MultiLocationAsc = 'v3MultiLocation_ASC',
  V3MultiLocationAscNullsFirst = 'v3MultiLocation_ASC_NULLS_FIRST',
  V3MultiLocationAscNullsLast = 'v3MultiLocation_ASC_NULLS_LAST',
  V3MultiLocationDesc = 'v3MultiLocation_DESC',
  V3MultiLocationDescNullsFirst = 'v3MultiLocation_DESC_NULLS_FIRST',
  V3MultiLocationDescNullsLast = 'v3MultiLocation_DESC_NULLS_LAST',
}

export type AssetDetailsWhereInput = {
  AND?: InputMaybe<Array<AssetDetailsWhereInput>>;
  OR?: InputMaybe<Array<AssetDetailsWhereInput>>;
  accounts_eq?: InputMaybe<Scalars['Int']['input']>;
  accounts_gt?: InputMaybe<Scalars['Int']['input']>;
  accounts_gte?: InputMaybe<Scalars['Int']['input']>;
  accounts_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  accounts_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  accounts_lt?: InputMaybe<Scalars['Int']['input']>;
  accounts_lte?: InputMaybe<Scalars['Int']['input']>;
  accounts_not_eq?: InputMaybe<Scalars['Int']['input']>;
  accounts_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  admin?: InputMaybe<AccountWhereInput>;
  admin_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  approvals_eq?: InputMaybe<Scalars['Int']['input']>;
  approvals_gt?: InputMaybe<Scalars['Int']['input']>;
  approvals_gte?: InputMaybe<Scalars['Int']['input']>;
  approvals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  approvals_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  approvals_lt?: InputMaybe<Scalars['Int']['input']>;
  approvals_lte?: InputMaybe<Scalars['Int']['input']>;
  approvals_not_eq?: InputMaybe<Scalars['Int']['input']>;
  approvals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  deposit_eq?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deposit_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  deposit_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  freezer?: InputMaybe<AccountWhereInput>;
  freezer_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  isSufficient_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isSufficient_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isSufficient_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  issuer?: InputMaybe<AccountWhereInput>;
  issuer_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  minBalance_eq?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minBalance_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  minBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  minBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  owner?: InputMaybe<AccountWhereInput>;
  owner_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  status_eq?: InputMaybe<AssetStatus>;
  status_in?: InputMaybe<Array<AssetStatus>>;
  status_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  status_not_eq?: InputMaybe<AssetStatus>;
  status_not_in?: InputMaybe<Array<AssetStatus>>;
  sufficients_eq?: InputMaybe<Scalars['Int']['input']>;
  sufficients_gt?: InputMaybe<Scalars['Int']['input']>;
  sufficients_gte?: InputMaybe<Scalars['Int']['input']>;
  sufficients_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  sufficients_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  sufficients_lt?: InputMaybe<Scalars['Int']['input']>;
  sufficients_lte?: InputMaybe<Scalars['Int']['input']>;
  sufficients_not_eq?: InputMaybe<Scalars['Int']['input']>;
  sufficients_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  supply_eq?: InputMaybe<Scalars['BigInt']['input']>;
  supply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  supply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  supply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  supply_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  supply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  supply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  supply_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  supply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  v3MultiLocation_contains?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_endsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_eq?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_gt?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_gte?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  v3MultiLocation_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  v3MultiLocation_lt?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_lte?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_eq?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  v3MultiLocation_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type AssetMetadata = {
  __typename?: 'AssetMetadata';
  decimals: Scalars['Int']['output'];
  deposit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  isFrozen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  v3MultiLocation: Scalars['String']['output'];
};

export type AssetMetadataConnection = {
  __typename?: 'AssetMetadataConnection';
  edges: Array<AssetMetadataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetMetadataEdge = {
  __typename?: 'AssetMetadataEdge';
  cursor: Scalars['String']['output'];
  node: AssetMetadata;
};

export enum AssetMetadataOrderByInput {
  DecimalsAsc = 'decimals_ASC',
  DecimalsAscNullsFirst = 'decimals_ASC_NULLS_FIRST',
  DecimalsAscNullsLast = 'decimals_ASC_NULLS_LAST',
  DecimalsDesc = 'decimals_DESC',
  DecimalsDescNullsFirst = 'decimals_DESC_NULLS_FIRST',
  DecimalsDescNullsLast = 'decimals_DESC_NULLS_LAST',
  DepositAsc = 'deposit_ASC',
  DepositAscNullsFirst = 'deposit_ASC_NULLS_FIRST',
  DepositAscNullsLast = 'deposit_ASC_NULLS_LAST',
  DepositDesc = 'deposit_DESC',
  DepositDescNullsFirst = 'deposit_DESC_NULLS_FIRST',
  DepositDescNullsLast = 'deposit_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IsFrozenAsc = 'isFrozen_ASC',
  IsFrozenAscNullsFirst = 'isFrozen_ASC_NULLS_FIRST',
  IsFrozenAscNullsLast = 'isFrozen_ASC_NULLS_LAST',
  IsFrozenDesc = 'isFrozen_DESC',
  IsFrozenDescNullsFirst = 'isFrozen_DESC_NULLS_FIRST',
  IsFrozenDescNullsLast = 'isFrozen_DESC_NULLS_LAST',
  NameAsc = 'name_ASC',
  NameAscNullsFirst = 'name_ASC_NULLS_FIRST',
  NameAscNullsLast = 'name_ASC_NULLS_LAST',
  NameDesc = 'name_DESC',
  NameDescNullsFirst = 'name_DESC_NULLS_FIRST',
  NameDescNullsLast = 'name_DESC_NULLS_LAST',
  SymbolAsc = 'symbol_ASC',
  SymbolAscNullsFirst = 'symbol_ASC_NULLS_FIRST',
  SymbolAscNullsLast = 'symbol_ASC_NULLS_LAST',
  SymbolDesc = 'symbol_DESC',
  SymbolDescNullsFirst = 'symbol_DESC_NULLS_FIRST',
  SymbolDescNullsLast = 'symbol_DESC_NULLS_LAST',
  V3MultiLocationAsc = 'v3MultiLocation_ASC',
  V3MultiLocationAscNullsFirst = 'v3MultiLocation_ASC_NULLS_FIRST',
  V3MultiLocationAscNullsLast = 'v3MultiLocation_ASC_NULLS_LAST',
  V3MultiLocationDesc = 'v3MultiLocation_DESC',
  V3MultiLocationDescNullsFirst = 'v3MultiLocation_DESC_NULLS_FIRST',
  V3MultiLocationDescNullsLast = 'v3MultiLocation_DESC_NULLS_LAST',
}

export type AssetMetadataWhereInput = {
  AND?: InputMaybe<Array<AssetMetadataWhereInput>>;
  OR?: InputMaybe<Array<AssetMetadataWhereInput>>;
  decimals_eq?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_eq?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  deposit_eq?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deposit_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  deposit_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  deposit_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  isFrozen_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isFrozen_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isFrozen_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_eq?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_not_eq?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  name_startsWith?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  symbol_endsWith?: InputMaybe<Scalars['String']['input']>;
  symbol_eq?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  symbol_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  symbol_not_eq?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  symbol_startsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_contains?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_endsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_eq?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_gt?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_gte?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  v3MultiLocation_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  v3MultiLocation_lt?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_lte?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_eq?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  v3MultiLocation_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  v3MultiLocation_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetStatus {
  Destroying = 'DESTROYING',
  Frozen = 'FROZEN',
  Live = 'LIVE',
}

export type AvnLift = {
  __typename?: 'AvnLift';
  amount: Scalars['BigInt']['output'];
  blockNumber: Scalars['BigInt']['output'];
  ewcTxHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  receiver?: Maybe<Account>;
  sender?: Maybe<Scalars['String']['output']>;
  when: Scalars['BigInt']['output'];
};

export type AvnLiftEdge = {
  __typename?: 'AvnLiftEdge';
  cursor: Scalars['String']['output'];
  node: AvnLift;
};

export enum AvnLiftOrderByInput {
  AmountAsc = 'amount_ASC',
  AmountAscNullsFirst = 'amount_ASC_NULLS_FIRST',
  AmountAscNullsLast = 'amount_ASC_NULLS_LAST',
  AmountDesc = 'amount_DESC',
  AmountDescNullsFirst = 'amount_DESC_NULLS_FIRST',
  AmountDescNullsLast = 'amount_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  EwcTxHashAsc = 'ewcTxHash_ASC',
  EwcTxHashAscNullsFirst = 'ewcTxHash_ASC_NULLS_FIRST',
  EwcTxHashAscNullsLast = 'ewcTxHash_ASC_NULLS_LAST',
  EwcTxHashDesc = 'ewcTxHash_DESC',
  EwcTxHashDescNullsFirst = 'ewcTxHash_DESC_NULLS_FIRST',
  EwcTxHashDescNullsLast = 'ewcTxHash_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OriginAsc = 'origin_ASC',
  OriginAscNullsFirst = 'origin_ASC_NULLS_FIRST',
  OriginAscNullsLast = 'origin_ASC_NULLS_LAST',
  OriginDesc = 'origin_DESC',
  OriginDescNullsFirst = 'origin_DESC_NULLS_FIRST',
  OriginDescNullsLast = 'origin_DESC_NULLS_LAST',
  ReceiverIdAsc = 'receiver_id_ASC',
  ReceiverIdAscNullsFirst = 'receiver_id_ASC_NULLS_FIRST',
  ReceiverIdAscNullsLast = 'receiver_id_ASC_NULLS_LAST',
  ReceiverIdDesc = 'receiver_id_DESC',
  ReceiverIdDescNullsFirst = 'receiver_id_DESC_NULLS_FIRST',
  ReceiverIdDescNullsLast = 'receiver_id_DESC_NULLS_LAST',
  SenderAsc = 'sender_ASC',
  SenderAscNullsFirst = 'sender_ASC_NULLS_FIRST',
  SenderAscNullsLast = 'sender_ASC_NULLS_LAST',
  SenderDesc = 'sender_DESC',
  SenderDescNullsFirst = 'sender_DESC_NULLS_FIRST',
  SenderDescNullsLast = 'sender_DESC_NULLS_LAST',
  WhenAsc = 'when_ASC',
  WhenAscNullsFirst = 'when_ASC_NULLS_FIRST',
  WhenAscNullsLast = 'when_ASC_NULLS_LAST',
  WhenDesc = 'when_DESC',
  WhenDescNullsFirst = 'when_DESC_NULLS_FIRST',
  WhenDescNullsLast = 'when_DESC_NULLS_LAST',
}

export type AvnLiftWhereInput = {
  AND?: InputMaybe<Array<AvnLiftWhereInput>>;
  OR?: InputMaybe<Array<AvnLiftWhereInput>>;
  amount_eq?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ewcTxHash_contains?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_eq?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_gt?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_gte?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ewcTxHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  ewcTxHash_lt?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_lte?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ewcTxHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  ewcTxHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  origin_contains?: InputMaybe<Scalars['String']['input']>;
  origin_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  origin_endsWith?: InputMaybe<Scalars['String']['input']>;
  origin_eq?: InputMaybe<Scalars['String']['input']>;
  origin_gt?: InputMaybe<Scalars['String']['input']>;
  origin_gte?: InputMaybe<Scalars['String']['input']>;
  origin_in?: InputMaybe<Array<Scalars['String']['input']>>;
  origin_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  origin_lt?: InputMaybe<Scalars['String']['input']>;
  origin_lte?: InputMaybe<Scalars['String']['input']>;
  origin_not_contains?: InputMaybe<Scalars['String']['input']>;
  origin_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  origin_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  origin_not_eq?: InputMaybe<Scalars['String']['input']>;
  origin_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  origin_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  origin_startsWith?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<AccountWhereInput>;
  receiver_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  sender_contains?: InputMaybe<Scalars['String']['input']>;
  sender_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  sender_endsWith?: InputMaybe<Scalars['String']['input']>;
  sender_eq?: InputMaybe<Scalars['String']['input']>;
  sender_gt?: InputMaybe<Scalars['String']['input']>;
  sender_gte?: InputMaybe<Scalars['String']['input']>;
  sender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sender_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  sender_lt?: InputMaybe<Scalars['String']['input']>;
  sender_lte?: InputMaybe<Scalars['String']['input']>;
  sender_not_contains?: InputMaybe<Scalars['String']['input']>;
  sender_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  sender_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  sender_not_eq?: InputMaybe<Scalars['String']['input']>;
  sender_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sender_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  sender_startsWith?: InputMaybe<Scalars['String']['input']>;
  when_eq?: InputMaybe<Scalars['BigInt']['input']>;
  when_gt?: InputMaybe<Scalars['BigInt']['input']>;
  when_gte?: InputMaybe<Scalars['BigInt']['input']>;
  when_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  when_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  when_lt?: InputMaybe<Scalars['BigInt']['input']>;
  when_lte?: InputMaybe<Scalars['BigInt']['input']>;
  when_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  when_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type AvnLiftsConnection = {
  __typename?: 'AvnLiftsConnection';
  edges: Array<AvnLiftEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AvnLower = {
  __typename?: 'AvnLower';
  amount: Scalars['BigInt']['output'];
  blockNumber: Scalars['BigInt']['output'];
  claimBlockNumber?: Maybe<Scalars['BigInt']['output']>;
  claimed?: Maybe<Scalars['Boolean']['output']>;
  encodedLowerProof?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFinalized?: Maybe<Scalars['Boolean']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
  lowerEvents: Array<AvnLowerEvent>;
  lowerId?: Maybe<Scalars['Int']['output']>;
  lowerPendingProof?: Maybe<Scalars['String']['output']>;
  readyToBeClaimed?: Maybe<Scalars['Boolean']['output']>;
  receiver: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  schedulerDispatch?: Maybe<SchedulerDispatch>;
  sender: Account;
  target?: Maybe<Scalars['String']['output']>;
  when: Scalars['BigInt']['output'];
};

export type AvnLowerLowerEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLowerEventOrderByInput>>;
  where?: InputMaybe<AvnLowerEventWhereInput>;
};

export type AvnLowerEdge = {
  __typename?: 'AvnLowerEdge';
  cursor: Scalars['String']['output'];
  node: AvnLower;
};

export type AvnLowerEvent = {
  __typename?: 'AvnLowerEvent';
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['Int']['output'];
  blockTimestamp: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lower?: Maybe<AvnLower>;
  name: AvnLowerEventType;
};

export type AvnLowerEventEdge = {
  __typename?: 'AvnLowerEventEdge';
  cursor: Scalars['String']['output'];
  node: AvnLowerEvent;
};

export enum AvnLowerEventOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  BlockTimestampAsc = 'blockTimestamp_ASC',
  BlockTimestampAscNullsFirst = 'blockTimestamp_ASC_NULLS_FIRST',
  BlockTimestampAscNullsLast = 'blockTimestamp_ASC_NULLS_LAST',
  BlockTimestampDesc = 'blockTimestamp_DESC',
  BlockTimestampDescNullsFirst = 'blockTimestamp_DESC_NULLS_FIRST',
  BlockTimestampDescNullsLast = 'blockTimestamp_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  LowerAmountAsc = 'lower_amount_ASC',
  LowerAmountAscNullsFirst = 'lower_amount_ASC_NULLS_FIRST',
  LowerAmountAscNullsLast = 'lower_amount_ASC_NULLS_LAST',
  LowerAmountDesc = 'lower_amount_DESC',
  LowerAmountDescNullsFirst = 'lower_amount_DESC_NULLS_FIRST',
  LowerAmountDescNullsLast = 'lower_amount_DESC_NULLS_LAST',
  LowerBlockNumberAsc = 'lower_blockNumber_ASC',
  LowerBlockNumberAscNullsFirst = 'lower_blockNumber_ASC_NULLS_FIRST',
  LowerBlockNumberAscNullsLast = 'lower_blockNumber_ASC_NULLS_LAST',
  LowerBlockNumberDesc = 'lower_blockNumber_DESC',
  LowerBlockNumberDescNullsFirst = 'lower_blockNumber_DESC_NULLS_FIRST',
  LowerBlockNumberDescNullsLast = 'lower_blockNumber_DESC_NULLS_LAST',
  LowerClaimBlockNumberAsc = 'lower_claimBlockNumber_ASC',
  LowerClaimBlockNumberAscNullsFirst = 'lower_claimBlockNumber_ASC_NULLS_FIRST',
  LowerClaimBlockNumberAscNullsLast = 'lower_claimBlockNumber_ASC_NULLS_LAST',
  LowerClaimBlockNumberDesc = 'lower_claimBlockNumber_DESC',
  LowerClaimBlockNumberDescNullsFirst = 'lower_claimBlockNumber_DESC_NULLS_FIRST',
  LowerClaimBlockNumberDescNullsLast = 'lower_claimBlockNumber_DESC_NULLS_LAST',
  LowerClaimedAsc = 'lower_claimed_ASC',
  LowerClaimedAscNullsFirst = 'lower_claimed_ASC_NULLS_FIRST',
  LowerClaimedAscNullsLast = 'lower_claimed_ASC_NULLS_LAST',
  LowerClaimedDesc = 'lower_claimed_DESC',
  LowerClaimedDescNullsFirst = 'lower_claimed_DESC_NULLS_FIRST',
  LowerClaimedDescNullsLast = 'lower_claimed_DESC_NULLS_LAST',
  LowerEncodedLowerProofAsc = 'lower_encodedLowerProof_ASC',
  LowerEncodedLowerProofAscNullsFirst = 'lower_encodedLowerProof_ASC_NULLS_FIRST',
  LowerEncodedLowerProofAscNullsLast = 'lower_encodedLowerProof_ASC_NULLS_LAST',
  LowerEncodedLowerProofDesc = 'lower_encodedLowerProof_DESC',
  LowerEncodedLowerProofDescNullsFirst = 'lower_encodedLowerProof_DESC_NULLS_FIRST',
  LowerEncodedLowerProofDescNullsLast = 'lower_encodedLowerProof_DESC_NULLS_LAST',
  LowerIdAsc = 'lower_id_ASC',
  LowerIdAscNullsFirst = 'lower_id_ASC_NULLS_FIRST',
  LowerIdAscNullsLast = 'lower_id_ASC_NULLS_LAST',
  LowerIdDesc = 'lower_id_DESC',
  LowerIdDescNullsFirst = 'lower_id_DESC_NULLS_FIRST',
  LowerIdDescNullsLast = 'lower_id_DESC_NULLS_LAST',
  LowerIsFinalizedAsc = 'lower_isFinalized_ASC',
  LowerIsFinalizedAscNullsFirst = 'lower_isFinalized_ASC_NULLS_FIRST',
  LowerIsFinalizedAscNullsLast = 'lower_isFinalized_ASC_NULLS_LAST',
  LowerIsFinalizedDesc = 'lower_isFinalized_DESC',
  LowerIsFinalizedDescNullsFirst = 'lower_isFinalized_DESC_NULLS_FIRST',
  LowerIsFinalizedDescNullsLast = 'lower_isFinalized_DESC_NULLS_LAST',
  LowerIsPendingAsc = 'lower_isPending_ASC',
  LowerIsPendingAscNullsFirst = 'lower_isPending_ASC_NULLS_FIRST',
  LowerIsPendingAscNullsLast = 'lower_isPending_ASC_NULLS_LAST',
  LowerIsPendingDesc = 'lower_isPending_DESC',
  LowerIsPendingDescNullsFirst = 'lower_isPending_DESC_NULLS_FIRST',
  LowerIsPendingDescNullsLast = 'lower_isPending_DESC_NULLS_LAST',
  LowerLowerIdAsc = 'lower_lowerId_ASC',
  LowerLowerIdAscNullsFirst = 'lower_lowerId_ASC_NULLS_FIRST',
  LowerLowerIdAscNullsLast = 'lower_lowerId_ASC_NULLS_LAST',
  LowerLowerIdDesc = 'lower_lowerId_DESC',
  LowerLowerIdDescNullsFirst = 'lower_lowerId_DESC_NULLS_FIRST',
  LowerLowerIdDescNullsLast = 'lower_lowerId_DESC_NULLS_LAST',
  LowerLowerPendingProofAsc = 'lower_lowerPendingProof_ASC',
  LowerLowerPendingProofAscNullsFirst = 'lower_lowerPendingProof_ASC_NULLS_FIRST',
  LowerLowerPendingProofAscNullsLast = 'lower_lowerPendingProof_ASC_NULLS_LAST',
  LowerLowerPendingProofDesc = 'lower_lowerPendingProof_DESC',
  LowerLowerPendingProofDescNullsFirst = 'lower_lowerPendingProof_DESC_NULLS_FIRST',
  LowerLowerPendingProofDescNullsLast = 'lower_lowerPendingProof_DESC_NULLS_LAST',
  LowerReadyToBeClaimedAsc = 'lower_readyToBeClaimed_ASC',
  LowerReadyToBeClaimedAscNullsFirst = 'lower_readyToBeClaimed_ASC_NULLS_FIRST',
  LowerReadyToBeClaimedAscNullsLast = 'lower_readyToBeClaimed_ASC_NULLS_LAST',
  LowerReadyToBeClaimedDesc = 'lower_readyToBeClaimed_DESC',
  LowerReadyToBeClaimedDescNullsFirst = 'lower_readyToBeClaimed_DESC_NULLS_FIRST',
  LowerReadyToBeClaimedDescNullsLast = 'lower_readyToBeClaimed_DESC_NULLS_LAST',
  LowerReceiverAsc = 'lower_receiver_ASC',
  LowerReceiverAscNullsFirst = 'lower_receiver_ASC_NULLS_FIRST',
  LowerReceiverAscNullsLast = 'lower_receiver_ASC_NULLS_LAST',
  LowerReceiverDesc = 'lower_receiver_DESC',
  LowerReceiverDescNullsFirst = 'lower_receiver_DESC_NULLS_FIRST',
  LowerReceiverDescNullsLast = 'lower_receiver_DESC_NULLS_LAST',
  LowerRecipientAsc = 'lower_recipient_ASC',
  LowerRecipientAscNullsFirst = 'lower_recipient_ASC_NULLS_FIRST',
  LowerRecipientAscNullsLast = 'lower_recipient_ASC_NULLS_LAST',
  LowerRecipientDesc = 'lower_recipient_DESC',
  LowerRecipientDescNullsFirst = 'lower_recipient_DESC_NULLS_FIRST',
  LowerRecipientDescNullsLast = 'lower_recipient_DESC_NULLS_LAST',
  LowerScheduleIdAsc = 'lower_scheduleId_ASC',
  LowerScheduleIdAscNullsFirst = 'lower_scheduleId_ASC_NULLS_FIRST',
  LowerScheduleIdAscNullsLast = 'lower_scheduleId_ASC_NULLS_LAST',
  LowerScheduleIdDesc = 'lower_scheduleId_DESC',
  LowerScheduleIdDescNullsFirst = 'lower_scheduleId_DESC_NULLS_FIRST',
  LowerScheduleIdDescNullsLast = 'lower_scheduleId_DESC_NULLS_LAST',
  LowerTargetAsc = 'lower_target_ASC',
  LowerTargetAscNullsFirst = 'lower_target_ASC_NULLS_FIRST',
  LowerTargetAscNullsLast = 'lower_target_ASC_NULLS_LAST',
  LowerTargetDesc = 'lower_target_DESC',
  LowerTargetDescNullsFirst = 'lower_target_DESC_NULLS_FIRST',
  LowerTargetDescNullsLast = 'lower_target_DESC_NULLS_LAST',
  LowerWhenAsc = 'lower_when_ASC',
  LowerWhenAscNullsFirst = 'lower_when_ASC_NULLS_FIRST',
  LowerWhenAscNullsLast = 'lower_when_ASC_NULLS_LAST',
  LowerWhenDesc = 'lower_when_DESC',
  LowerWhenDescNullsFirst = 'lower_when_DESC_NULLS_FIRST',
  LowerWhenDescNullsLast = 'lower_when_DESC_NULLS_LAST',
  NameAsc = 'name_ASC',
  NameAscNullsFirst = 'name_ASC_NULLS_FIRST',
  NameAscNullsLast = 'name_ASC_NULLS_LAST',
  NameDesc = 'name_DESC',
  NameDescNullsFirst = 'name_DESC_NULLS_FIRST',
  NameDescNullsLast = 'name_DESC_NULLS_LAST',
}

export enum AvnLowerEventType {
  Claimed = 'Claimed',
  Lowered = 'Lowered',
  ReadyToBeClaimed = 'ReadyToBeClaimed',
  Requested = 'Requested',
}

export type AvnLowerEventWhereInput = {
  AND?: InputMaybe<Array<AvnLowerEventWhereInput>>;
  OR?: InputMaybe<Array<AvnLowerEventWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockTimestamp_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  blockTimestamp_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockTimestamp_lt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  lower?: InputMaybe<AvnLowerWhereInput>;
  lower_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  name_eq?: InputMaybe<AvnLowerEventType>;
  name_in?: InputMaybe<Array<AvnLowerEventType>>;
  name_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  name_not_eq?: InputMaybe<AvnLowerEventType>;
  name_not_in?: InputMaybe<Array<AvnLowerEventType>>;
};

export type AvnLowerEventsConnection = {
  __typename?: 'AvnLowerEventsConnection';
  edges: Array<AvnLowerEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AvnLowerOrderByInput {
  AmountAsc = 'amount_ASC',
  AmountAscNullsFirst = 'amount_ASC_NULLS_FIRST',
  AmountAscNullsLast = 'amount_ASC_NULLS_LAST',
  AmountDesc = 'amount_DESC',
  AmountDescNullsFirst = 'amount_DESC_NULLS_FIRST',
  AmountDescNullsLast = 'amount_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  ClaimBlockNumberAsc = 'claimBlockNumber_ASC',
  ClaimBlockNumberAscNullsFirst = 'claimBlockNumber_ASC_NULLS_FIRST',
  ClaimBlockNumberAscNullsLast = 'claimBlockNumber_ASC_NULLS_LAST',
  ClaimBlockNumberDesc = 'claimBlockNumber_DESC',
  ClaimBlockNumberDescNullsFirst = 'claimBlockNumber_DESC_NULLS_FIRST',
  ClaimBlockNumberDescNullsLast = 'claimBlockNumber_DESC_NULLS_LAST',
  ClaimedAsc = 'claimed_ASC',
  ClaimedAscNullsFirst = 'claimed_ASC_NULLS_FIRST',
  ClaimedAscNullsLast = 'claimed_ASC_NULLS_LAST',
  ClaimedDesc = 'claimed_DESC',
  ClaimedDescNullsFirst = 'claimed_DESC_NULLS_FIRST',
  ClaimedDescNullsLast = 'claimed_DESC_NULLS_LAST',
  EncodedLowerProofAsc = 'encodedLowerProof_ASC',
  EncodedLowerProofAscNullsFirst = 'encodedLowerProof_ASC_NULLS_FIRST',
  EncodedLowerProofAscNullsLast = 'encodedLowerProof_ASC_NULLS_LAST',
  EncodedLowerProofDesc = 'encodedLowerProof_DESC',
  EncodedLowerProofDescNullsFirst = 'encodedLowerProof_DESC_NULLS_FIRST',
  EncodedLowerProofDescNullsLast = 'encodedLowerProof_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IsFinalizedAsc = 'isFinalized_ASC',
  IsFinalizedAscNullsFirst = 'isFinalized_ASC_NULLS_FIRST',
  IsFinalizedAscNullsLast = 'isFinalized_ASC_NULLS_LAST',
  IsFinalizedDesc = 'isFinalized_DESC',
  IsFinalizedDescNullsFirst = 'isFinalized_DESC_NULLS_FIRST',
  IsFinalizedDescNullsLast = 'isFinalized_DESC_NULLS_LAST',
  IsPendingAsc = 'isPending_ASC',
  IsPendingAscNullsFirst = 'isPending_ASC_NULLS_FIRST',
  IsPendingAscNullsLast = 'isPending_ASC_NULLS_LAST',
  IsPendingDesc = 'isPending_DESC',
  IsPendingDescNullsFirst = 'isPending_DESC_NULLS_FIRST',
  IsPendingDescNullsLast = 'isPending_DESC_NULLS_LAST',
  LowerIdAsc = 'lowerId_ASC',
  LowerIdAscNullsFirst = 'lowerId_ASC_NULLS_FIRST',
  LowerIdAscNullsLast = 'lowerId_ASC_NULLS_LAST',
  LowerIdDesc = 'lowerId_DESC',
  LowerIdDescNullsFirst = 'lowerId_DESC_NULLS_FIRST',
  LowerIdDescNullsLast = 'lowerId_DESC_NULLS_LAST',
  LowerPendingProofAsc = 'lowerPendingProof_ASC',
  LowerPendingProofAscNullsFirst = 'lowerPendingProof_ASC_NULLS_FIRST',
  LowerPendingProofAscNullsLast = 'lowerPendingProof_ASC_NULLS_LAST',
  LowerPendingProofDesc = 'lowerPendingProof_DESC',
  LowerPendingProofDescNullsFirst = 'lowerPendingProof_DESC_NULLS_FIRST',
  LowerPendingProofDescNullsLast = 'lowerPendingProof_DESC_NULLS_LAST',
  ReadyToBeClaimedAsc = 'readyToBeClaimed_ASC',
  ReadyToBeClaimedAscNullsFirst = 'readyToBeClaimed_ASC_NULLS_FIRST',
  ReadyToBeClaimedAscNullsLast = 'readyToBeClaimed_ASC_NULLS_LAST',
  ReadyToBeClaimedDesc = 'readyToBeClaimed_DESC',
  ReadyToBeClaimedDescNullsFirst = 'readyToBeClaimed_DESC_NULLS_FIRST',
  ReadyToBeClaimedDescNullsLast = 'readyToBeClaimed_DESC_NULLS_LAST',
  ReceiverAsc = 'receiver_ASC',
  ReceiverAscNullsFirst = 'receiver_ASC_NULLS_FIRST',
  ReceiverAscNullsLast = 'receiver_ASC_NULLS_LAST',
  ReceiverDesc = 'receiver_DESC',
  ReceiverDescNullsFirst = 'receiver_DESC_NULLS_FIRST',
  ReceiverDescNullsLast = 'receiver_DESC_NULLS_LAST',
  RecipientAsc = 'recipient_ASC',
  RecipientAscNullsFirst = 'recipient_ASC_NULLS_FIRST',
  RecipientAscNullsLast = 'recipient_ASC_NULLS_LAST',
  RecipientDesc = 'recipient_DESC',
  RecipientDescNullsFirst = 'recipient_DESC_NULLS_FIRST',
  RecipientDescNullsLast = 'recipient_DESC_NULLS_LAST',
  ScheduleIdAsc = 'scheduleId_ASC',
  ScheduleIdAscNullsFirst = 'scheduleId_ASC_NULLS_FIRST',
  ScheduleIdAscNullsLast = 'scheduleId_ASC_NULLS_LAST',
  ScheduleIdDesc = 'scheduleId_DESC',
  ScheduleIdDescNullsFirst = 'scheduleId_DESC_NULLS_FIRST',
  ScheduleIdDescNullsLast = 'scheduleId_DESC_NULLS_LAST',
  SchedulerDispatchBlockHashAsc = 'schedulerDispatch_blockHash_ASC',
  SchedulerDispatchBlockHashAscNullsFirst = 'schedulerDispatch_blockHash_ASC_NULLS_FIRST',
  SchedulerDispatchBlockHashAscNullsLast = 'schedulerDispatch_blockHash_ASC_NULLS_LAST',
  SchedulerDispatchBlockHashDesc = 'schedulerDispatch_blockHash_DESC',
  SchedulerDispatchBlockHashDescNullsFirst = 'schedulerDispatch_blockHash_DESC_NULLS_FIRST',
  SchedulerDispatchBlockHashDescNullsLast = 'schedulerDispatch_blockHash_DESC_NULLS_LAST',
  SchedulerDispatchBlockNumberAsc = 'schedulerDispatch_blockNumber_ASC',
  SchedulerDispatchBlockNumberAscNullsFirst = 'schedulerDispatch_blockNumber_ASC_NULLS_FIRST',
  SchedulerDispatchBlockNumberAscNullsLast = 'schedulerDispatch_blockNumber_ASC_NULLS_LAST',
  SchedulerDispatchBlockNumberDesc = 'schedulerDispatch_blockNumber_DESC',
  SchedulerDispatchBlockNumberDescNullsFirst = 'schedulerDispatch_blockNumber_DESC_NULLS_FIRST',
  SchedulerDispatchBlockNumberDescNullsLast = 'schedulerDispatch_blockNumber_DESC_NULLS_LAST',
  SchedulerDispatchBlockTimestampAsc = 'schedulerDispatch_blockTimestamp_ASC',
  SchedulerDispatchBlockTimestampAscNullsFirst = 'schedulerDispatch_blockTimestamp_ASC_NULLS_FIRST',
  SchedulerDispatchBlockTimestampAscNullsLast = 'schedulerDispatch_blockTimestamp_ASC_NULLS_LAST',
  SchedulerDispatchBlockTimestampDesc = 'schedulerDispatch_blockTimestamp_DESC',
  SchedulerDispatchBlockTimestampDescNullsFirst = 'schedulerDispatch_blockTimestamp_DESC_NULLS_FIRST',
  SchedulerDispatchBlockTimestampDescNullsLast = 'schedulerDispatch_blockTimestamp_DESC_NULLS_LAST',
  SchedulerDispatchErrorMethodAsc = 'schedulerDispatch_errorMethod_ASC',
  SchedulerDispatchErrorMethodAscNullsFirst = 'schedulerDispatch_errorMethod_ASC_NULLS_FIRST',
  SchedulerDispatchErrorMethodAscNullsLast = 'schedulerDispatch_errorMethod_ASC_NULLS_LAST',
  SchedulerDispatchErrorMethodDesc = 'schedulerDispatch_errorMethod_DESC',
  SchedulerDispatchErrorMethodDescNullsFirst = 'schedulerDispatch_errorMethod_DESC_NULLS_FIRST',
  SchedulerDispatchErrorMethodDescNullsLast = 'schedulerDispatch_errorMethod_DESC_NULLS_LAST',
  SchedulerDispatchErrorNameAsc = 'schedulerDispatch_errorName_ASC',
  SchedulerDispatchErrorNameAscNullsFirst = 'schedulerDispatch_errorName_ASC_NULLS_FIRST',
  SchedulerDispatchErrorNameAscNullsLast = 'schedulerDispatch_errorName_ASC_NULLS_LAST',
  SchedulerDispatchErrorNameDesc = 'schedulerDispatch_errorName_DESC',
  SchedulerDispatchErrorNameDescNullsFirst = 'schedulerDispatch_errorName_DESC_NULLS_FIRST',
  SchedulerDispatchErrorNameDescNullsLast = 'schedulerDispatch_errorName_DESC_NULLS_LAST',
  SchedulerDispatchErrorPalletAsc = 'schedulerDispatch_errorPallet_ASC',
  SchedulerDispatchErrorPalletAscNullsFirst = 'schedulerDispatch_errorPallet_ASC_NULLS_FIRST',
  SchedulerDispatchErrorPalletAscNullsLast = 'schedulerDispatch_errorPallet_ASC_NULLS_LAST',
  SchedulerDispatchErrorPalletDesc = 'schedulerDispatch_errorPallet_DESC',
  SchedulerDispatchErrorPalletDescNullsFirst = 'schedulerDispatch_errorPallet_DESC_NULLS_FIRST',
  SchedulerDispatchErrorPalletDescNullsLast = 'schedulerDispatch_errorPallet_DESC_NULLS_LAST',
  SchedulerDispatchIdAsc = 'schedulerDispatch_id_ASC',
  SchedulerDispatchIdAscNullsFirst = 'schedulerDispatch_id_ASC_NULLS_FIRST',
  SchedulerDispatchIdAscNullsLast = 'schedulerDispatch_id_ASC_NULLS_LAST',
  SchedulerDispatchIdDesc = 'schedulerDispatch_id_DESC',
  SchedulerDispatchIdDescNullsFirst = 'schedulerDispatch_id_DESC_NULLS_FIRST',
  SchedulerDispatchIdDescNullsLast = 'schedulerDispatch_id_DESC_NULLS_LAST',
  SchedulerDispatchScheduleExecutionResultAsc = 'schedulerDispatch_scheduleExecutionResult_ASC',
  SchedulerDispatchScheduleExecutionResultAscNullsFirst = 'schedulerDispatch_scheduleExecutionResult_ASC_NULLS_FIRST',
  SchedulerDispatchScheduleExecutionResultAscNullsLast = 'schedulerDispatch_scheduleExecutionResult_ASC_NULLS_LAST',
  SchedulerDispatchScheduleExecutionResultDesc = 'schedulerDispatch_scheduleExecutionResult_DESC',
  SchedulerDispatchScheduleExecutionResultDescNullsFirst = 'schedulerDispatch_scheduleExecutionResult_DESC_NULLS_FIRST',
  SchedulerDispatchScheduleExecutionResultDescNullsLast = 'schedulerDispatch_scheduleExecutionResult_DESC_NULLS_LAST',
  SchedulerDispatchScheduleIdAsc = 'schedulerDispatch_scheduleId_ASC',
  SchedulerDispatchScheduleIdAscNullsFirst = 'schedulerDispatch_scheduleId_ASC_NULLS_FIRST',
  SchedulerDispatchScheduleIdAscNullsLast = 'schedulerDispatch_scheduleId_ASC_NULLS_LAST',
  SchedulerDispatchScheduleIdDesc = 'schedulerDispatch_scheduleId_DESC',
  SchedulerDispatchScheduleIdDescNullsFirst = 'schedulerDispatch_scheduleId_DESC_NULLS_FIRST',
  SchedulerDispatchScheduleIdDescNullsLast = 'schedulerDispatch_scheduleId_DESC_NULLS_LAST',
  SchedulerDispatchTask0Asc = 'schedulerDispatch_task0_ASC',
  SchedulerDispatchTask0AscNullsFirst = 'schedulerDispatch_task0_ASC_NULLS_FIRST',
  SchedulerDispatchTask0AscNullsLast = 'schedulerDispatch_task0_ASC_NULLS_LAST',
  SchedulerDispatchTask0Desc = 'schedulerDispatch_task0_DESC',
  SchedulerDispatchTask0DescNullsFirst = 'schedulerDispatch_task0_DESC_NULLS_FIRST',
  SchedulerDispatchTask0DescNullsLast = 'schedulerDispatch_task0_DESC_NULLS_LAST',
  SchedulerDispatchTask1Asc = 'schedulerDispatch_task1_ASC',
  SchedulerDispatchTask1AscNullsFirst = 'schedulerDispatch_task1_ASC_NULLS_FIRST',
  SchedulerDispatchTask1AscNullsLast = 'schedulerDispatch_task1_ASC_NULLS_LAST',
  SchedulerDispatchTask1Desc = 'schedulerDispatch_task1_DESC',
  SchedulerDispatchTask1DescNullsFirst = 'schedulerDispatch_task1_DESC_NULLS_FIRST',
  SchedulerDispatchTask1DescNullsLast = 'schedulerDispatch_task1_DESC_NULLS_LAST',
  SenderIdAsc = 'sender_id_ASC',
  SenderIdAscNullsFirst = 'sender_id_ASC_NULLS_FIRST',
  SenderIdAscNullsLast = 'sender_id_ASC_NULLS_LAST',
  SenderIdDesc = 'sender_id_DESC',
  SenderIdDescNullsFirst = 'sender_id_DESC_NULLS_FIRST',
  SenderIdDescNullsLast = 'sender_id_DESC_NULLS_LAST',
  TargetAsc = 'target_ASC',
  TargetAscNullsFirst = 'target_ASC_NULLS_FIRST',
  TargetAscNullsLast = 'target_ASC_NULLS_LAST',
  TargetDesc = 'target_DESC',
  TargetDescNullsFirst = 'target_DESC_NULLS_FIRST',
  TargetDescNullsLast = 'target_DESC_NULLS_LAST',
  WhenAsc = 'when_ASC',
  WhenAscNullsFirst = 'when_ASC_NULLS_FIRST',
  WhenAscNullsLast = 'when_ASC_NULLS_LAST',
  WhenDesc = 'when_DESC',
  WhenDescNullsFirst = 'when_DESC_NULLS_FIRST',
  WhenDescNullsLast = 'when_DESC_NULLS_LAST',
}

export type AvnLowerWhereInput = {
  AND?: InputMaybe<Array<AvnLowerWhereInput>>;
  OR?: InputMaybe<Array<AvnLowerWhereInput>>;
  amount_eq?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimBlockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimBlockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  claimBlockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  claimBlockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimed_eq?: InputMaybe<Scalars['Boolean']['input']>;
  claimed_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  claimed_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  encodedLowerProof_contains?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_endsWith?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_eq?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_gt?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_gte?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_in?: InputMaybe<Array<Scalars['String']['input']>>;
  encodedLowerProof_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  encodedLowerProof_lt?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_lte?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_not_contains?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_not_eq?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  encodedLowerProof_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  encodedLowerProof_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  isFinalized_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isPending_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isPending_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isPending_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  lowerEvents_every?: InputMaybe<AvnLowerEventWhereInput>;
  lowerEvents_none?: InputMaybe<AvnLowerEventWhereInput>;
  lowerEvents_some?: InputMaybe<AvnLowerEventWhereInput>;
  lowerId_eq?: InputMaybe<Scalars['Int']['input']>;
  lowerId_gt?: InputMaybe<Scalars['Int']['input']>;
  lowerId_gte?: InputMaybe<Scalars['Int']['input']>;
  lowerId_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lowerId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lowerId_lt?: InputMaybe<Scalars['Int']['input']>;
  lowerId_lte?: InputMaybe<Scalars['Int']['input']>;
  lowerId_not_eq?: InputMaybe<Scalars['Int']['input']>;
  lowerId_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lowerPendingProof_contains?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_endsWith?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_eq?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_gt?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_gte?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lowerPendingProof_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lowerPendingProof_lt?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_lte?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_not_contains?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_not_eq?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lowerPendingProof_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  lowerPendingProof_startsWith?: InputMaybe<Scalars['String']['input']>;
  readyToBeClaimed_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readyToBeClaimed_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  readyToBeClaimed_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  receiver_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  receiver_endsWith?: InputMaybe<Scalars['String']['input']>;
  receiver_eq?: InputMaybe<Scalars['String']['input']>;
  receiver_gt?: InputMaybe<Scalars['String']['input']>;
  receiver_gte?: InputMaybe<Scalars['String']['input']>;
  receiver_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  receiver_lt?: InputMaybe<Scalars['String']['input']>;
  receiver_lte?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  receiver_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  receiver_not_eq?: InputMaybe<Scalars['String']['input']>;
  receiver_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  receiver_startsWith?: InputMaybe<Scalars['String']['input']>;
  recipient_contains?: InputMaybe<Scalars['String']['input']>;
  recipient_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  recipient_endsWith?: InputMaybe<Scalars['String']['input']>;
  recipient_eq?: InputMaybe<Scalars['String']['input']>;
  recipient_gt?: InputMaybe<Scalars['String']['input']>;
  recipient_gte?: InputMaybe<Scalars['String']['input']>;
  recipient_in?: InputMaybe<Array<Scalars['String']['input']>>;
  recipient_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_lt?: InputMaybe<Scalars['String']['input']>;
  recipient_lte?: InputMaybe<Scalars['String']['input']>;
  recipient_not_contains?: InputMaybe<Scalars['String']['input']>;
  recipient_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  recipient_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  recipient_not_eq?: InputMaybe<Scalars['String']['input']>;
  recipient_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  recipient_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  recipient_startsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleId_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleId_gt?: InputMaybe<Scalars['String']['input']>;
  scheduleId_gte?: InputMaybe<Scalars['String']['input']>;
  scheduleId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId_lt?: InputMaybe<Scalars['String']['input']>;
  scheduleId_lte?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_startsWith?: InputMaybe<Scalars['String']['input']>;
  schedulerDispatch?: InputMaybe<SchedulerDispatchWhereInput>;
  schedulerDispatch_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<AccountWhereInput>;
  sender_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  target_contains?: InputMaybe<Scalars['String']['input']>;
  target_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  target_endsWith?: InputMaybe<Scalars['String']['input']>;
  target_eq?: InputMaybe<Scalars['String']['input']>;
  target_gt?: InputMaybe<Scalars['String']['input']>;
  target_gte?: InputMaybe<Scalars['String']['input']>;
  target_in?: InputMaybe<Array<Scalars['String']['input']>>;
  target_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  target_lt?: InputMaybe<Scalars['String']['input']>;
  target_lte?: InputMaybe<Scalars['String']['input']>;
  target_not_contains?: InputMaybe<Scalars['String']['input']>;
  target_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  target_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  target_not_eq?: InputMaybe<Scalars['String']['input']>;
  target_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  target_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  target_startsWith?: InputMaybe<Scalars['String']['input']>;
  when_eq?: InputMaybe<Scalars['BigInt']['input']>;
  when_gt?: InputMaybe<Scalars['BigInt']['input']>;
  when_gte?: InputMaybe<Scalars['BigInt']['input']>;
  when_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  when_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  when_lt?: InputMaybe<Scalars['BigInt']['input']>;
  when_lte?: InputMaybe<Scalars['BigInt']['input']>;
  when_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  when_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type AvnLowersConnection = {
  __typename?: 'AvnLowersConnection';
  edges: Array<AvnLowerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CanOperatorWorkerVote = {
  __typename?: 'CanOperatorWorkerVote';
  address: Scalars['String']['output'];
  canVote: Scalars['Boolean']['output'];
  fulfillsRewardPeriodCriteria: Scalars['Boolean']['output'];
  fulfillsStakeCriteria: Scalars['Boolean']['output'];
  fulfillsStartBlockCriteria: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  solutionGroupFinished: Scalars['Boolean']['output'];
  solutionGroupId: Scalars['String']['output'];
};

export type EarnedRewards = {
  __typename?: 'EarnedRewards';
  account: Account;
  /** Account address - solution group */
  id: Scalars['String']['output'];
  participationReward: Scalars['BigInt']['output'];
  solutionGroup?: Maybe<SolutionGroup>;
  solutionGroupName: Scalars['String']['output'];
  subscriptionReward: Scalars['BigInt']['output'];
};

export type EarnedRewardsConnection = {
  __typename?: 'EarnedRewardsConnection';
  edges: Array<EarnedRewardsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EarnedRewardsEdge = {
  __typename?: 'EarnedRewardsEdge';
  cursor: Scalars['String']['output'];
  node: EarnedRewards;
};

export enum EarnedRewardsOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  ParticipationRewardAsc = 'participationReward_ASC',
  ParticipationRewardAscNullsFirst = 'participationReward_ASC_NULLS_FIRST',
  ParticipationRewardAscNullsLast = 'participationReward_ASC_NULLS_LAST',
  ParticipationRewardDesc = 'participationReward_DESC',
  ParticipationRewardDescNullsFirst = 'participationReward_DESC_NULLS_FIRST',
  ParticipationRewardDescNullsLast = 'participationReward_DESC_NULLS_LAST',
  SolutionGroupNameAsc = 'solutionGroupName_ASC',
  SolutionGroupNameAscNullsFirst = 'solutionGroupName_ASC_NULLS_FIRST',
  SolutionGroupNameAscNullsLast = 'solutionGroupName_ASC_NULLS_LAST',
  SolutionGroupNameDesc = 'solutionGroupName_DESC',
  SolutionGroupNameDescNullsFirst = 'solutionGroupName_DESC_NULLS_FIRST',
  SolutionGroupNameDescNullsLast = 'solutionGroupName_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
  SubscriptionRewardAsc = 'subscriptionReward_ASC',
  SubscriptionRewardAscNullsFirst = 'subscriptionReward_ASC_NULLS_FIRST',
  SubscriptionRewardAscNullsLast = 'subscriptionReward_ASC_NULLS_LAST',
  SubscriptionRewardDesc = 'subscriptionReward_DESC',
  SubscriptionRewardDescNullsFirst = 'subscriptionReward_DESC_NULLS_FIRST',
  SubscriptionRewardDescNullsLast = 'subscriptionReward_DESC_NULLS_LAST',
}

export type EarnedRewardsWhereInput = {
  AND?: InputMaybe<Array<EarnedRewardsWhereInput>>;
  OR?: InputMaybe<Array<EarnedRewardsWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  participationReward_eq?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  participationReward_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  participationReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  participationReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroupName_contains?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_endsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_eq?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_gt?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_gte?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionGroupName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionGroupName_lt?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_lte?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_not_contains?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_not_eq?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionGroupName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroupName_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionReward_eq?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  subscriptionReward_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type EwtPrice = {
  __typename?: 'EwtPrice';
  id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  refreshedOnBlock: Scalars['Int']['output'];
};

export type EwtPriceEdge = {
  __typename?: 'EwtPriceEdge';
  cursor: Scalars['String']['output'];
  node: EwtPrice;
};

export enum EwtPriceOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  PriceAsc = 'price_ASC',
  PriceAscNullsFirst = 'price_ASC_NULLS_FIRST',
  PriceAscNullsLast = 'price_ASC_NULLS_LAST',
  PriceDesc = 'price_DESC',
  PriceDescNullsFirst = 'price_DESC_NULLS_FIRST',
  PriceDescNullsLast = 'price_DESC_NULLS_LAST',
  RefreshedOnBlockAsc = 'refreshedOnBlock_ASC',
  RefreshedOnBlockAscNullsFirst = 'refreshedOnBlock_ASC_NULLS_FIRST',
  RefreshedOnBlockAscNullsLast = 'refreshedOnBlock_ASC_NULLS_LAST',
  RefreshedOnBlockDesc = 'refreshedOnBlock_DESC',
  RefreshedOnBlockDescNullsFirst = 'refreshedOnBlock_DESC_NULLS_FIRST',
  RefreshedOnBlockDescNullsLast = 'refreshedOnBlock_DESC_NULLS_LAST',
}

export type EwtPriceWhereInput = {
  AND?: InputMaybe<Array<EwtPriceWhereInput>>;
  OR?: InputMaybe<Array<EwtPriceWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  price_eq?: InputMaybe<Scalars['Float']['input']>;
  price_gt?: InputMaybe<Scalars['Float']['input']>;
  price_gte?: InputMaybe<Scalars['Float']['input']>;
  price_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  price_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  price_lt?: InputMaybe<Scalars['Float']['input']>;
  price_lte?: InputMaybe<Scalars['Float']['input']>;
  price_not_eq?: InputMaybe<Scalars['Float']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  refreshedOnBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  refreshedOnBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  refreshedOnBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  refreshedOnBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EwtPricesConnection = {
  __typename?: 'EwtPricesConnection';
  edges: Array<EwtPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InitRun = {
  __typename?: 'InitRun';
  id: Scalars['String']['output'];
};

export type InitRunEdge = {
  __typename?: 'InitRunEdge';
  cursor: Scalars['String']['output'];
  node: InitRun;
};

export enum InitRunOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
}

export type InitRunWhereInput = {
  AND?: InputMaybe<Array<InitRunWhereInput>>;
  OR?: InputMaybe<Array<InitRunWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type InitRunsConnection = {
  __typename?: 'InitRunsConnection';
  edges: Array<InitRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperatorAccount = {
  __typename?: 'OperatorAccount';
  account?: Maybe<Account>;
  allowedSolutionGroups: Array<OperatorAllowedSolutionGroups>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** Account address */
  id: Scalars['String']['output'];
  legalLocation?: Maybe<Scalars['String']['output']>;
  mappings: Array<OperatorMapping>;
  scheduledUnsubscriptions: Array<UnsubscriptionSchedule>;
  subscribedStakes: Array<OperatorSubscribedStake>;
  subscriptions: Array<OperatorSubscribedSolutionGroups>;
};

export type OperatorAccountAllowedSolutionGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorAllowedSolutionGroupsOrderByInput>>;
  where?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
};

export type OperatorAccountMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorMappingOrderByInput>>;
  where?: InputMaybe<OperatorMappingWhereInput>;
};

export type OperatorAccountScheduledUnsubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnsubscriptionScheduleOrderByInput>>;
  where?: InputMaybe<UnsubscriptionScheduleWhereInput>;
};

export type OperatorAccountSubscribedStakesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedStakeOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedStakeWhereInput>;
};

export type OperatorAccountSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedSolutionGroupsOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
};

export type OperatorAccountEdge = {
  __typename?: 'OperatorAccountEdge';
  cursor: Scalars['String']['output'];
  node: OperatorAccount;
};

export enum OperatorAccountOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  FriendlyNameAsc = 'friendlyName_ASC',
  FriendlyNameAscNullsFirst = 'friendlyName_ASC_NULLS_FIRST',
  FriendlyNameAscNullsLast = 'friendlyName_ASC_NULLS_LAST',
  FriendlyNameDesc = 'friendlyName_DESC',
  FriendlyNameDescNullsFirst = 'friendlyName_DESC_NULLS_FIRST',
  FriendlyNameDescNullsLast = 'friendlyName_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  LegalLocationAsc = 'legalLocation_ASC',
  LegalLocationAscNullsFirst = 'legalLocation_ASC_NULLS_FIRST',
  LegalLocationAscNullsLast = 'legalLocation_ASC_NULLS_LAST',
  LegalLocationDesc = 'legalLocation_DESC',
  LegalLocationDescNullsFirst = 'legalLocation_DESC_NULLS_FIRST',
  LegalLocationDescNullsLast = 'legalLocation_DESC_NULLS_LAST',
}

export type OperatorAccountWhereInput = {
  AND?: InputMaybe<Array<OperatorAccountWhereInput>>;
  OR?: InputMaybe<Array<OperatorAccountWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  allowedSolutionGroups_every?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
  allowedSolutionGroups_none?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
  allowedSolutionGroups_some?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
  friendlyName_contains?: InputMaybe<Scalars['String']['input']>;
  friendlyName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  friendlyName_endsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_eq?: InputMaybe<Scalars['String']['input']>;
  friendlyName_gt?: InputMaybe<Scalars['String']['input']>;
  friendlyName_gte?: InputMaybe<Scalars['String']['input']>;
  friendlyName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  friendlyName_lt?: InputMaybe<Scalars['String']['input']>;
  friendlyName_lte?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_eq?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_contains?: InputMaybe<Scalars['String']['input']>;
  legalLocation_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  legalLocation_endsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_eq?: InputMaybe<Scalars['String']['input']>;
  legalLocation_gt?: InputMaybe<Scalars['String']['input']>;
  legalLocation_gte?: InputMaybe<Scalars['String']['input']>;
  legalLocation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  legalLocation_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  legalLocation_lt?: InputMaybe<Scalars['String']['input']>;
  legalLocation_lte?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_eq?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  legalLocation_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_startsWith?: InputMaybe<Scalars['String']['input']>;
  mappings_every?: InputMaybe<OperatorMappingWhereInput>;
  mappings_none?: InputMaybe<OperatorMappingWhereInput>;
  mappings_some?: InputMaybe<OperatorMappingWhereInput>;
  scheduledUnsubscriptions_every?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  scheduledUnsubscriptions_none?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  scheduledUnsubscriptions_some?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  subscribedStakes_every?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  subscribedStakes_none?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  subscribedStakes_some?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  subscriptions_every?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
  subscriptions_none?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
  subscriptions_some?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
};

export type OperatorAccountsConnection = {
  __typename?: 'OperatorAccountsConnection';
  edges: Array<OperatorAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperatorAllowedSolutionGroups = {
  __typename?: 'OperatorAllowedSolutionGroups';
  account: Account;
  id: Scalars['String']['output'];
  operator?: Maybe<OperatorAccount>;
  solutionGroup: SolutionGroup;
};

export type OperatorAllowedSolutionGroupsConnection = {
  __typename?: 'OperatorAllowedSolutionGroupsConnection';
  edges: Array<OperatorAllowedSolutionGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperatorAllowedSolutionGroupsEdge = {
  __typename?: 'OperatorAllowedSolutionGroupsEdge';
  cursor: Scalars['String']['output'];
  node: OperatorAllowedSolutionGroups;
};

export enum OperatorAllowedSolutionGroupsOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
}

export type OperatorAllowedSolutionGroupsWhereInput = {
  AND?: InputMaybe<Array<OperatorAllowedSolutionGroupsWhereInput>>;
  OR?: InputMaybe<Array<OperatorAllowedSolutionGroupsWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorMapping = {
  __typename?: 'OperatorMapping';
  /** Operator_Worker address */
  id: Scalars['String']['output'];
  operator: OperatorAccount;
  worker: WorkerAccount;
};

export type OperatorMappingEdge = {
  __typename?: 'OperatorMappingEdge';
  cursor: Scalars['String']['output'];
  node: OperatorMapping;
};

export enum OperatorMappingOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  WorkerAddressAsc = 'worker_address_ASC',
  WorkerAddressAscNullsFirst = 'worker_address_ASC_NULLS_FIRST',
  WorkerAddressAscNullsLast = 'worker_address_ASC_NULLS_LAST',
  WorkerAddressDesc = 'worker_address_DESC',
  WorkerAddressDescNullsFirst = 'worker_address_DESC_NULLS_FIRST',
  WorkerAddressDescNullsLast = 'worker_address_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST',
}

export type OperatorMappingWhereInput = {
  AND?: InputMaybe<Array<OperatorMappingWhereInput>>;
  OR?: InputMaybe<Array<OperatorMappingWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerAccountWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorMappingsConnection = {
  __typename?: 'OperatorMappingsConnection';
  edges: Array<OperatorMappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperatorSubscribedSolutionGroups = {
  __typename?: 'OperatorSubscribedSolutionGroups';
  blockHash?: Maybe<Scalars['String']['output']>;
  blockNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  operator: OperatorAccount;
  rewardPeriodIndex?: Maybe<ActiveRewardPeriodInfo>;
  solutionGroup: SolutionGroup;
};

export type OperatorSubscribedSolutionGroupsConnection = {
  __typename?: 'OperatorSubscribedSolutionGroupsConnection';
  edges: Array<OperatorSubscribedSolutionGroupsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OperatorSubscribedSolutionGroupsEdge = {
  __typename?: 'OperatorSubscribedSolutionGroupsEdge';
  cursor: Scalars['String']['output'];
  node: OperatorSubscribedSolutionGroups;
};

export enum OperatorSubscribedSolutionGroupsOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  NamespaceAsc = 'namespace_ASC',
  NamespaceAscNullsFirst = 'namespace_ASC_NULLS_FIRST',
  NamespaceAscNullsLast = 'namespace_ASC_NULLS_LAST',
  NamespaceDesc = 'namespace_DESC',
  NamespaceDescNullsFirst = 'namespace_DESC_NULLS_FIRST',
  NamespaceDescNullsLast = 'namespace_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  RewardPeriodIndexBlockNumberAsc = 'rewardPeriodIndex_blockNumber_ASC',
  RewardPeriodIndexBlockNumberAscNullsFirst = 'rewardPeriodIndex_blockNumber_ASC_NULLS_FIRST',
  RewardPeriodIndexBlockNumberAscNullsLast = 'rewardPeriodIndex_blockNumber_ASC_NULLS_LAST',
  RewardPeriodIndexBlockNumberDesc = 'rewardPeriodIndex_blockNumber_DESC',
  RewardPeriodIndexBlockNumberDescNullsFirst = 'rewardPeriodIndex_blockNumber_DESC_NULLS_FIRST',
  RewardPeriodIndexBlockNumberDescNullsLast = 'rewardPeriodIndex_blockNumber_DESC_NULLS_LAST',
  RewardPeriodIndexFirstBlockAsc = 'rewardPeriodIndex_firstBlock_ASC',
  RewardPeriodIndexFirstBlockAscNullsFirst = 'rewardPeriodIndex_firstBlock_ASC_NULLS_FIRST',
  RewardPeriodIndexFirstBlockAscNullsLast = 'rewardPeriodIndex_firstBlock_ASC_NULLS_LAST',
  RewardPeriodIndexFirstBlockDesc = 'rewardPeriodIndex_firstBlock_DESC',
  RewardPeriodIndexFirstBlockDescNullsFirst = 'rewardPeriodIndex_firstBlock_DESC_NULLS_FIRST',
  RewardPeriodIndexFirstBlockDescNullsLast = 'rewardPeriodIndex_firstBlock_DESC_NULLS_LAST',
  RewardPeriodIndexIdAsc = 'rewardPeriodIndex_id_ASC',
  RewardPeriodIndexIdAscNullsFirst = 'rewardPeriodIndex_id_ASC_NULLS_FIRST',
  RewardPeriodIndexIdAscNullsLast = 'rewardPeriodIndex_id_ASC_NULLS_LAST',
  RewardPeriodIndexIdDesc = 'rewardPeriodIndex_id_DESC',
  RewardPeriodIndexIdDescNullsFirst = 'rewardPeriodIndex_id_DESC_NULLS_FIRST',
  RewardPeriodIndexIdDescNullsLast = 'rewardPeriodIndex_id_DESC_NULLS_LAST',
  RewardPeriodIndexIndexAsc = 'rewardPeriodIndex_index_ASC',
  RewardPeriodIndexIndexAscNullsFirst = 'rewardPeriodIndex_index_ASC_NULLS_FIRST',
  RewardPeriodIndexIndexAscNullsLast = 'rewardPeriodIndex_index_ASC_NULLS_LAST',
  RewardPeriodIndexIndexDesc = 'rewardPeriodIndex_index_DESC',
  RewardPeriodIndexIndexDescNullsFirst = 'rewardPeriodIndex_index_DESC_NULLS_FIRST',
  RewardPeriodIndexIndexDescNullsLast = 'rewardPeriodIndex_index_DESC_NULLS_LAST',
  RewardPeriodIndexLengthAsc = 'rewardPeriodIndex_length_ASC',
  RewardPeriodIndexLengthAscNullsFirst = 'rewardPeriodIndex_length_ASC_NULLS_FIRST',
  RewardPeriodIndexLengthAscNullsLast = 'rewardPeriodIndex_length_ASC_NULLS_LAST',
  RewardPeriodIndexLengthDesc = 'rewardPeriodIndex_length_DESC',
  RewardPeriodIndexLengthDescNullsFirst = 'rewardPeriodIndex_length_DESC_NULLS_FIRST',
  RewardPeriodIndexLengthDescNullsLast = 'rewardPeriodIndex_length_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
}

export type OperatorSubscribedSolutionGroupsWhereInput = {
  AND?: InputMaybe<Array<OperatorSubscribedSolutionGroupsWhereInput>>;
  OR?: InputMaybe<Array<OperatorSubscribedSolutionGroupsWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_gt?: InputMaybe<Scalars['String']['input']>;
  namespace_gte?: InputMaybe<Scalars['String']['input']>;
  namespace_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  namespace_lt?: InputMaybe<Scalars['String']['input']>;
  namespace_lte?: InputMaybe<Scalars['String']['input']>;
  namespace_not_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_not_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriodIndex?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
  rewardPeriodIndex_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorSubscribedStake = {
  __typename?: 'OperatorSubscribedStake';
  currentStake: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  nextStake: Scalars['BigInt']['output'];
  operator: OperatorAccount;
  rewardPeriod?: Maybe<ActiveRewardPeriodInfo>;
  rewardPeriodIndex: Scalars['Int']['output'];
  solutionGroup?: Maybe<SolutionGroup>;
};

export type OperatorSubscribedStakeEdge = {
  __typename?: 'OperatorSubscribedStakeEdge';
  cursor: Scalars['String']['output'];
  node: OperatorSubscribedStake;
};

export enum OperatorSubscribedStakeOrderByInput {
  CurrentStakeAsc = 'currentStake_ASC',
  CurrentStakeAscNullsFirst = 'currentStake_ASC_NULLS_FIRST',
  CurrentStakeAscNullsLast = 'currentStake_ASC_NULLS_LAST',
  CurrentStakeDesc = 'currentStake_DESC',
  CurrentStakeDescNullsFirst = 'currentStake_DESC_NULLS_FIRST',
  CurrentStakeDescNullsLast = 'currentStake_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  NextStakeAsc = 'nextStake_ASC',
  NextStakeAscNullsFirst = 'nextStake_ASC_NULLS_FIRST',
  NextStakeAscNullsLast = 'nextStake_ASC_NULLS_LAST',
  NextStakeDesc = 'nextStake_DESC',
  NextStakeDescNullsFirst = 'nextStake_DESC_NULLS_FIRST',
  NextStakeDescNullsLast = 'nextStake_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriodIndex_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriodIndex_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriodIndex_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriodIndex_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriodIndex_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriodIndex_DESC_NULLS_LAST',
  RewardPeriodBlockNumberAsc = 'rewardPeriod_blockNumber_ASC',
  RewardPeriodBlockNumberAscNullsFirst = 'rewardPeriod_blockNumber_ASC_NULLS_FIRST',
  RewardPeriodBlockNumberAscNullsLast = 'rewardPeriod_blockNumber_ASC_NULLS_LAST',
  RewardPeriodBlockNumberDesc = 'rewardPeriod_blockNumber_DESC',
  RewardPeriodBlockNumberDescNullsFirst = 'rewardPeriod_blockNumber_DESC_NULLS_FIRST',
  RewardPeriodBlockNumberDescNullsLast = 'rewardPeriod_blockNumber_DESC_NULLS_LAST',
  RewardPeriodFirstBlockAsc = 'rewardPeriod_firstBlock_ASC',
  RewardPeriodFirstBlockAscNullsFirst = 'rewardPeriod_firstBlock_ASC_NULLS_FIRST',
  RewardPeriodFirstBlockAscNullsLast = 'rewardPeriod_firstBlock_ASC_NULLS_LAST',
  RewardPeriodFirstBlockDesc = 'rewardPeriod_firstBlock_DESC',
  RewardPeriodFirstBlockDescNullsFirst = 'rewardPeriod_firstBlock_DESC_NULLS_FIRST',
  RewardPeriodFirstBlockDescNullsLast = 'rewardPeriod_firstBlock_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodLengthAsc = 'rewardPeriod_length_ASC',
  RewardPeriodLengthAscNullsFirst = 'rewardPeriod_length_ASC_NULLS_FIRST',
  RewardPeriodLengthAscNullsLast = 'rewardPeriod_length_ASC_NULLS_LAST',
  RewardPeriodLengthDesc = 'rewardPeriod_length_DESC',
  RewardPeriodLengthDescNullsFirst = 'rewardPeriod_length_DESC_NULLS_FIRST',
  RewardPeriodLengthDescNullsLast = 'rewardPeriod_length_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
}

export type OperatorSubscribedStakeWhereInput = {
  AND?: InputMaybe<Array<OperatorSubscribedStakeWhereInput>>;
  OR?: InputMaybe<Array<OperatorSubscribedStakeWhereInput>>;
  currentStake_eq?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentStake_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  currentStake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  currentStake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  nextStake_eq?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextStake_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  nextStake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  nextStake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriod?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
  rewardPeriodIndex_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  rewardPeriodIndex_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriodIndex_lt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_lte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorSubscribedStakesConnection = {
  __typename?: 'OperatorSubscribedStakesConnection';
  edges: Array<OperatorSubscribedStakeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PermitLiftGasFees = {
  __typename?: 'PermitLiftGasFees';
  averageGasFee?: Maybe<Scalars['BigInt']['output']>;
  lastFiveTransactions: Array<PermitLiftTransaction>;
};

export type PermitLiftTransaction = {
  __typename?: 'PermitLiftTransaction';
  blockNumber: Scalars['BigInt']['output'];
  gasPrice: Scalars['BigInt']['output'];
  gasUsed: Scalars['BigInt']['output'];
  transactionFee: Scalars['BigInt']['output'];
  transactionIndex: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountById?: Maybe<Account>;
  accounts: Array<Account>;
  accountsConnection: AccountsConnection;
  activeRewardPeriodInfoById?: Maybe<ActiveRewardPeriodInfo>;
  activeRewardPeriodInfos: Array<ActiveRewardPeriodInfo>;
  activeRewardPeriodInfosConnection: ActiveRewardPeriodInfosConnection;
  assetDetails: Array<AssetDetails>;
  assetDetailsById?: Maybe<AssetDetails>;
  assetDetailsConnection: AssetDetailsConnection;
  assetMetadata: Array<AssetMetadata>;
  assetMetadataById?: Maybe<AssetMetadata>;
  assetMetadataConnection: AssetMetadataConnection;
  avnLiftById?: Maybe<AvnLift>;
  avnLifts: Array<AvnLift>;
  avnLiftsConnection: AvnLiftsConnection;
  avnLowerById?: Maybe<AvnLower>;
  avnLowerEventById?: Maybe<AvnLowerEvent>;
  avnLowerEvents: Array<AvnLowerEvent>;
  avnLowerEventsConnection: AvnLowerEventsConnection;
  avnLowers: Array<AvnLower>;
  avnLowersConnection: AvnLowersConnection;
  canOperatorWorkerVote: Array<CanOperatorWorkerVote>;
  earnedRewards: Array<EarnedRewards>;
  earnedRewardsById?: Maybe<EarnedRewards>;
  earnedRewardsConnection: EarnedRewardsConnection;
  ewtPriceById?: Maybe<EwtPrice>;
  ewtPrices: Array<EwtPrice>;
  ewtPricesConnection: EwtPricesConnection;
  initRunById?: Maybe<InitRun>;
  initRuns: Array<InitRun>;
  initRunsConnection: InitRunsConnection;
  operatorAccountById?: Maybe<OperatorAccount>;
  operatorAccounts: Array<OperatorAccount>;
  operatorAccountsConnection: OperatorAccountsConnection;
  operatorAllowedSolutionGroups: Array<OperatorAllowedSolutionGroups>;
  operatorAllowedSolutionGroupsById?: Maybe<OperatorAllowedSolutionGroups>;
  operatorAllowedSolutionGroupsConnection: OperatorAllowedSolutionGroupsConnection;
  operatorMappingById?: Maybe<OperatorMapping>;
  operatorMappings: Array<OperatorMapping>;
  operatorMappingsConnection: OperatorMappingsConnection;
  operatorSubscribedSolutionGroups: Array<OperatorSubscribedSolutionGroups>;
  operatorSubscribedSolutionGroupsById?: Maybe<OperatorSubscribedSolutionGroups>;
  operatorSubscribedSolutionGroupsConnection: OperatorSubscribedSolutionGroupsConnection;
  operatorSubscribedStakeById?: Maybe<OperatorSubscribedStake>;
  operatorSubscribedStakes: Array<OperatorSubscribedStake>;
  operatorSubscribedStakesConnection: OperatorSubscribedStakesConnection;
  permitLiftGasFees: Array<PermitLiftGasFees>;
  registrarAccountById?: Maybe<RegistrarAccount>;
  registrarAccounts: Array<RegistrarAccount>;
  registrarAccountsConnection: RegistrarAccountsConnection;
  rewardsCalculatedForPeriodById?: Maybe<RewardsCalculatedForPeriod>;
  rewardsCalculatedForPeriods: Array<RewardsCalculatedForPeriod>;
  rewardsCalculatedForPeriodsConnection: RewardsCalculatedForPeriodsConnection;
  rewardsClaimedById?: Maybe<RewardsClaimed>;
  rewardsClaimeds: Array<RewardsClaimed>;
  rewardsClaimedsConnection: RewardsClaimedsConnection;
  schedulerDispatchById?: Maybe<SchedulerDispatch>;
  schedulerDispatches: Array<SchedulerDispatch>;
  schedulerDispatchesConnection: SchedulerDispatchesConnection;
  solutionById?: Maybe<Solution>;
  solutionConsensus: Array<SolutionConsensus>;
  solutionConsensusById?: Maybe<SolutionConsensus>;
  solutionConsensusConnection: SolutionConsensusConnection;
  solutionGroupAllowedCidById?: Maybe<SolutionGroupAllowedCid>;
  solutionGroupAllowedCids: Array<SolutionGroupAllowedCid>;
  solutionGroupAllowedCidsConnection: SolutionGroupAllowedCidsConnection;
  solutionGroupAssuranceSlashingConfigById?: Maybe<SolutionGroupAssuranceSlashingConfig>;
  solutionGroupAssuranceSlashingConfigs: Array<SolutionGroupAssuranceSlashingConfig>;
  solutionGroupAssuranceSlashingConfigsConnection: SolutionGroupAssuranceSlashingConfigsConnection;
  solutionGroupById?: Maybe<SolutionGroup>;
  solutionGroupInfoById?: Maybe<SolutionGroupInfo>;
  solutionGroupInfos: Array<SolutionGroupInfo>;
  solutionGroupInfosConnection: SolutionGroupInfosConnection;
  solutionGroupOperatorsConfigById?: Maybe<SolutionGroupOperatorsConfig>;
  solutionGroupOperatorsConfigs: Array<SolutionGroupOperatorsConfig>;
  solutionGroupOperatorsConfigsConnection: SolutionGroupOperatorsConfigsConnection;
  solutionGroupPerformanceSlashingConfigById?: Maybe<SolutionGroupPerformanceSlashingConfig>;
  solutionGroupPerformanceSlashingConfigs: Array<SolutionGroupPerformanceSlashingConfig>;
  solutionGroupPerformanceSlashingConfigsConnection: SolutionGroupPerformanceSlashingConfigsConnection;
  solutionGroupRewardsConfigById?: Maybe<SolutionGroupRewardsConfig>;
  solutionGroupRewardsConfigs: Array<SolutionGroupRewardsConfig>;
  solutionGroupRewardsConfigsConnection: SolutionGroupRewardsConfigsConnection;
  solutionGroupStakingAmounts: Array<SolutionGroupStakingAmounts>;
  solutionGroupStakingAmountsById?: Maybe<SolutionGroupStakingAmounts>;
  solutionGroupStakingAmountsConnection: SolutionGroupStakingAmountsConnection;
  solutionGroups: Array<SolutionGroup>;
  solutionGroupsConnection: SolutionGroupsConnection;
  solutionInfoById?: Maybe<SolutionInfo>;
  solutionInfos: Array<SolutionInfo>;
  solutionInfosConnection: SolutionInfosConnection;
  solutionWorkloadById?: Maybe<SolutionWorkload>;
  solutionWorkloads: Array<SolutionWorkload>;
  solutionWorkloadsConnection: SolutionWorkloadsConnection;
  solutions: Array<Solution>;
  solutionsConnection: SolutionsConnection;
  squidStatus?: Maybe<SquidStatus>;
  unclaimedRewards: Array<UnclaimedRewards>;
  unsubscriptionScheduleById?: Maybe<UnsubscriptionSchedule>;
  unsubscriptionSchedules: Array<UnsubscriptionSchedule>;
  unsubscriptionSchedulesConnection: UnsubscriptionSchedulesConnection;
  workerAccountById?: Maybe<WorkerAccount>;
  workerAccounts: Array<WorkerAccount>;
  workerAccountsConnection: WorkerAccountsConnection;
};

export type QueryAccountByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderByInput>>;
  where?: InputMaybe<AccountWhereInput>;
};

export type QueryAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AccountOrderByInput>;
  where?: InputMaybe<AccountWhereInput>;
};

export type QueryActiveRewardPeriodInfoByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryActiveRewardPeriodInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActiveRewardPeriodInfoOrderByInput>>;
  where?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
};

export type QueryActiveRewardPeriodInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<ActiveRewardPeriodInfoOrderByInput>;
  where?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
};

export type QueryAssetDetailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetDetailsOrderByInput>>;
  where?: InputMaybe<AssetDetailsWhereInput>;
};

export type QueryAssetDetailsByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAssetDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AssetDetailsOrderByInput>;
  where?: InputMaybe<AssetDetailsWhereInput>;
};

export type QueryAssetMetadataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetMetadataOrderByInput>>;
  where?: InputMaybe<AssetMetadataWhereInput>;
};

export type QueryAssetMetadataByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAssetMetadataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AssetMetadataOrderByInput>;
  where?: InputMaybe<AssetMetadataWhereInput>;
};

export type QueryAvnLiftByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAvnLiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLiftOrderByInput>>;
  where?: InputMaybe<AvnLiftWhereInput>;
};

export type QueryAvnLiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AvnLiftOrderByInput>;
  where?: InputMaybe<AvnLiftWhereInput>;
};

export type QueryAvnLowerByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAvnLowerEventByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryAvnLowerEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLowerEventOrderByInput>>;
  where?: InputMaybe<AvnLowerEventWhereInput>;
};

export type QueryAvnLowerEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AvnLowerEventOrderByInput>;
  where?: InputMaybe<AvnLowerEventWhereInput>;
};

export type QueryAvnLowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvnLowerOrderByInput>>;
  where?: InputMaybe<AvnLowerWhereInput>;
};

export type QueryAvnLowersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AvnLowerOrderByInput>;
  where?: InputMaybe<AvnLowerWhereInput>;
};

export type QueryCanOperatorWorkerVoteArgs = {
  address: Scalars['String']['input'];
  solutionGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEarnedRewardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EarnedRewardsOrderByInput>>;
  where?: InputMaybe<EarnedRewardsWhereInput>;
};

export type QueryEarnedRewardsByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryEarnedRewardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<EarnedRewardsOrderByInput>;
  where?: InputMaybe<EarnedRewardsWhereInput>;
};

export type QueryEwtPriceByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryEwtPricesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EwtPriceOrderByInput>>;
  where?: InputMaybe<EwtPriceWhereInput>;
};

export type QueryEwtPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<EwtPriceOrderByInput>;
  where?: InputMaybe<EwtPriceWhereInput>;
};

export type QueryInitRunByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryInitRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InitRunOrderByInput>>;
  where?: InputMaybe<InitRunWhereInput>;
};

export type QueryInitRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<InitRunOrderByInput>;
  where?: InputMaybe<InitRunWhereInput>;
};

export type QueryOperatorAccountByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorAccountOrderByInput>>;
  where?: InputMaybe<OperatorAccountWhereInput>;
};

export type QueryOperatorAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorAccountOrderByInput>;
  where?: InputMaybe<OperatorAccountWhereInput>;
};

export type QueryOperatorAllowedSolutionGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorAllowedSolutionGroupsOrderByInput>>;
  where?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
};

export type QueryOperatorAllowedSolutionGroupsByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorAllowedSolutionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorAllowedSolutionGroupsOrderByInput>;
  where?: InputMaybe<OperatorAllowedSolutionGroupsWhereInput>;
};

export type QueryOperatorMappingByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorMappingOrderByInput>>;
  where?: InputMaybe<OperatorMappingWhereInput>;
};

export type QueryOperatorMappingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorMappingOrderByInput>;
  where?: InputMaybe<OperatorMappingWhereInput>;
};

export type QueryOperatorSubscribedSolutionGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedSolutionGroupsOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
};

export type QueryOperatorSubscribedSolutionGroupsByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorSubscribedSolutionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorSubscribedSolutionGroupsOrderByInput>;
  where?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
};

export type QueryOperatorSubscribedStakeByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorSubscribedStakesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedStakeOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedStakeWhereInput>;
};

export type QueryOperatorSubscribedStakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorSubscribedStakeOrderByInput>;
  where?: InputMaybe<OperatorSubscribedStakeWhereInput>;
};

export type QueryRegistrarAccountByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryRegistrarAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistrarAccountOrderByInput>>;
  where?: InputMaybe<RegistrarAccountWhereInput>;
};

export type QueryRegistrarAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<RegistrarAccountOrderByInput>;
  where?: InputMaybe<RegistrarAccountWhereInput>;
};

export type QueryRewardsCalculatedForPeriodByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryRewardsCalculatedForPeriodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RewardsCalculatedForPeriodOrderByInput>>;
  where?: InputMaybe<RewardsCalculatedForPeriodWhereInput>;
};

export type QueryRewardsCalculatedForPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<RewardsCalculatedForPeriodOrderByInput>;
  where?: InputMaybe<RewardsCalculatedForPeriodWhereInput>;
};

export type QueryRewardsClaimedByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryRewardsClaimedsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RewardsClaimedOrderByInput>>;
  where?: InputMaybe<RewardsClaimedWhereInput>;
};

export type QueryRewardsClaimedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<RewardsClaimedOrderByInput>;
  where?: InputMaybe<RewardsClaimedWhereInput>;
};

export type QuerySchedulerDispatchByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySchedulerDispatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchedulerDispatchOrderByInput>>;
  where?: InputMaybe<SchedulerDispatchWhereInput>;
};

export type QuerySchedulerDispatchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SchedulerDispatchOrderByInput>;
  where?: InputMaybe<SchedulerDispatchWhereInput>;
};

export type QuerySolutionByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionConsensusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionConsensusOrderByInput>>;
  where?: InputMaybe<SolutionConsensusWhereInput>;
};

export type QuerySolutionConsensusByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionConsensusConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionConsensusOrderByInput>;
  where?: InputMaybe<SolutionConsensusWhereInput>;
};

export type QuerySolutionGroupAllowedCidByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupAllowedCidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupAllowedCidOrderByInput>>;
  where?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
};

export type QuerySolutionGroupAllowedCidsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupAllowedCidOrderByInput>;
  where?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
};

export type QuerySolutionGroupAssuranceSlashingConfigByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupAssuranceSlashingConfigsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupAssuranceSlashingConfigOrderByInput>>;
  where?: InputMaybe<SolutionGroupAssuranceSlashingConfigWhereInput>;
};

export type QuerySolutionGroupAssuranceSlashingConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupAssuranceSlashingConfigOrderByInput>;
  where?: InputMaybe<SolutionGroupAssuranceSlashingConfigWhereInput>;
};

export type QuerySolutionGroupByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupInfoByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupInfoOrderByInput>>;
  where?: InputMaybe<SolutionGroupInfoWhereInput>;
};

export type QuerySolutionGroupInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupInfoOrderByInput>;
  where?: InputMaybe<SolutionGroupInfoWhereInput>;
};

export type QuerySolutionGroupOperatorsConfigByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupOperatorsConfigsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupOperatorsConfigOrderByInput>>;
  where?: InputMaybe<SolutionGroupOperatorsConfigWhereInput>;
};

export type QuerySolutionGroupOperatorsConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupOperatorsConfigOrderByInput>;
  where?: InputMaybe<SolutionGroupOperatorsConfigWhereInput>;
};

export type QuerySolutionGroupPerformanceSlashingConfigByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupPerformanceSlashingConfigsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupPerformanceSlashingConfigOrderByInput>>;
  where?: InputMaybe<SolutionGroupPerformanceSlashingConfigWhereInput>;
};

export type QuerySolutionGroupPerformanceSlashingConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupPerformanceSlashingConfigOrderByInput>;
  where?: InputMaybe<SolutionGroupPerformanceSlashingConfigWhereInput>;
};

export type QuerySolutionGroupRewardsConfigByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupRewardsConfigsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupRewardsConfigOrderByInput>>;
  where?: InputMaybe<SolutionGroupRewardsConfigWhereInput>;
};

export type QuerySolutionGroupRewardsConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupRewardsConfigOrderByInput>;
  where?: InputMaybe<SolutionGroupRewardsConfigWhereInput>;
};

export type QuerySolutionGroupStakingAmountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupStakingAmountsOrderByInput>>;
  where?: InputMaybe<SolutionGroupStakingAmountsWhereInput>;
};

export type QuerySolutionGroupStakingAmountsByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionGroupStakingAmountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupStakingAmountsOrderByInput>;
  where?: InputMaybe<SolutionGroupStakingAmountsWhereInput>;
};

export type QuerySolutionGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupOrderByInput>>;
  where?: InputMaybe<SolutionGroupWhereInput>;
};

export type QuerySolutionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionGroupOrderByInput>;
  where?: InputMaybe<SolutionGroupWhereInput>;
};

export type QuerySolutionInfoByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionInfoOrderByInput>>;
  where?: InputMaybe<SolutionInfoWhereInput>;
};

export type QuerySolutionInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionInfoOrderByInput>;
  where?: InputMaybe<SolutionInfoWhereInput>;
};

export type QuerySolutionWorkloadByIdArgs = {
  id: Scalars['String']['input'];
};

export type QuerySolutionWorkloadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionWorkloadOrderByInput>>;
  where?: InputMaybe<SolutionWorkloadWhereInput>;
};

export type QuerySolutionWorkloadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionWorkloadOrderByInput>;
  where?: InputMaybe<SolutionWorkloadWhereInput>;
};

export type QuerySolutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionOrderByInput>>;
  where?: InputMaybe<SolutionWhereInput>;
};

export type QuerySolutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionOrderByInput>;
  where?: InputMaybe<SolutionWhereInput>;
};

export type QueryUnclaimedRewardsArgs = {
  address: Scalars['String']['input'];
};

export type QueryUnsubscriptionScheduleByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryUnsubscriptionSchedulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnsubscriptionScheduleOrderByInput>>;
  where?: InputMaybe<UnsubscriptionScheduleWhereInput>;
};

export type QueryUnsubscriptionSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<UnsubscriptionScheduleOrderByInput>;
  where?: InputMaybe<UnsubscriptionScheduleWhereInput>;
};

export type QueryWorkerAccountByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryWorkerAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkerAccountOrderByInput>>;
  where?: InputMaybe<WorkerAccountWhereInput>;
};

export type QueryWorkerAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<WorkerAccountOrderByInput>;
  where?: InputMaybe<WorkerAccountWhereInput>;
};

export type RegistrarAccount = {
  __typename?: 'RegistrarAccount';
  account: Account;
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** Account address */
  id: Scalars['String']['output'];
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  legalLocation?: Maybe<Scalars['String']['output']>;
  solutions: Array<Solution>;
  solutionsGroups: Array<SolutionGroup>;
};

export type RegistrarAccountSolutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionOrderByInput>>;
  where?: InputMaybe<SolutionWhereInput>;
};

export type RegistrarAccountSolutionsGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupOrderByInput>>;
  where?: InputMaybe<SolutionGroupWhereInput>;
};

export type RegistrarAccountEdge = {
  __typename?: 'RegistrarAccountEdge';
  cursor: Scalars['String']['output'];
  node: RegistrarAccount;
};

export enum RegistrarAccountOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  FriendlyNameAsc = 'friendlyName_ASC',
  FriendlyNameAscNullsFirst = 'friendlyName_ASC_NULLS_FIRST',
  FriendlyNameAscNullsLast = 'friendlyName_ASC_NULLS_LAST',
  FriendlyNameDesc = 'friendlyName_DESC',
  FriendlyNameDescNullsFirst = 'friendlyName_DESC_NULLS_FIRST',
  FriendlyNameDescNullsLast = 'friendlyName_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IsAllowedAsc = 'isAllowed_ASC',
  IsAllowedAscNullsFirst = 'isAllowed_ASC_NULLS_FIRST',
  IsAllowedAscNullsLast = 'isAllowed_ASC_NULLS_LAST',
  IsAllowedDesc = 'isAllowed_DESC',
  IsAllowedDescNullsFirst = 'isAllowed_DESC_NULLS_FIRST',
  IsAllowedDescNullsLast = 'isAllowed_DESC_NULLS_LAST',
  LegalLocationAsc = 'legalLocation_ASC',
  LegalLocationAscNullsFirst = 'legalLocation_ASC_NULLS_FIRST',
  LegalLocationAscNullsLast = 'legalLocation_ASC_NULLS_LAST',
  LegalLocationDesc = 'legalLocation_DESC',
  LegalLocationDescNullsFirst = 'legalLocation_DESC_NULLS_FIRST',
  LegalLocationDescNullsLast = 'legalLocation_DESC_NULLS_LAST',
}

export type RegistrarAccountWhereInput = {
  AND?: InputMaybe<Array<RegistrarAccountWhereInput>>;
  OR?: InputMaybe<Array<RegistrarAccountWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  friendlyName_contains?: InputMaybe<Scalars['String']['input']>;
  friendlyName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  friendlyName_endsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_eq?: InputMaybe<Scalars['String']['input']>;
  friendlyName_gt?: InputMaybe<Scalars['String']['input']>;
  friendlyName_gte?: InputMaybe<Scalars['String']['input']>;
  friendlyName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  friendlyName_lt?: InputMaybe<Scalars['String']['input']>;
  friendlyName_lte?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_eq?: InputMaybe<Scalars['String']['input']>;
  friendlyName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  friendlyName_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  isAllowed_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  legalLocation_contains?: InputMaybe<Scalars['String']['input']>;
  legalLocation_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  legalLocation_endsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_eq?: InputMaybe<Scalars['String']['input']>;
  legalLocation_gt?: InputMaybe<Scalars['String']['input']>;
  legalLocation_gte?: InputMaybe<Scalars['String']['input']>;
  legalLocation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  legalLocation_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  legalLocation_lt?: InputMaybe<Scalars['String']['input']>;
  legalLocation_lte?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_eq?: InputMaybe<Scalars['String']['input']>;
  legalLocation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  legalLocation_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  legalLocation_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionsGroups_every?: InputMaybe<SolutionGroupWhereInput>;
  solutionsGroups_none?: InputMaybe<SolutionGroupWhereInput>;
  solutionsGroups_some?: InputMaybe<SolutionGroupWhereInput>;
  solutions_every?: InputMaybe<SolutionWhereInput>;
  solutions_none?: InputMaybe<SolutionWhereInput>;
  solutions_some?: InputMaybe<SolutionWhereInput>;
};

export type RegistrarAccountsConnection = {
  __typename?: 'RegistrarAccountsConnection';
  edges: Array<RegistrarAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RewardsCalculatedForPeriod = {
  __typename?: 'RewardsCalculatedForPeriod';
  /** Reward index */
  id: Scalars['String']['output'];
  rewardPeriodInfo: ActiveRewardPeriodInfo;
};

export type RewardsCalculatedForPeriodEdge = {
  __typename?: 'RewardsCalculatedForPeriodEdge';
  cursor: Scalars['String']['output'];
  node: RewardsCalculatedForPeriod;
};

export enum RewardsCalculatedForPeriodOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  RewardPeriodInfoBlockNumberAsc = 'rewardPeriodInfo_blockNumber_ASC',
  RewardPeriodInfoBlockNumberAscNullsFirst = 'rewardPeriodInfo_blockNumber_ASC_NULLS_FIRST',
  RewardPeriodInfoBlockNumberAscNullsLast = 'rewardPeriodInfo_blockNumber_ASC_NULLS_LAST',
  RewardPeriodInfoBlockNumberDesc = 'rewardPeriodInfo_blockNumber_DESC',
  RewardPeriodInfoBlockNumberDescNullsFirst = 'rewardPeriodInfo_blockNumber_DESC_NULLS_FIRST',
  RewardPeriodInfoBlockNumberDescNullsLast = 'rewardPeriodInfo_blockNumber_DESC_NULLS_LAST',
  RewardPeriodInfoFirstBlockAsc = 'rewardPeriodInfo_firstBlock_ASC',
  RewardPeriodInfoFirstBlockAscNullsFirst = 'rewardPeriodInfo_firstBlock_ASC_NULLS_FIRST',
  RewardPeriodInfoFirstBlockAscNullsLast = 'rewardPeriodInfo_firstBlock_ASC_NULLS_LAST',
  RewardPeriodInfoFirstBlockDesc = 'rewardPeriodInfo_firstBlock_DESC',
  RewardPeriodInfoFirstBlockDescNullsFirst = 'rewardPeriodInfo_firstBlock_DESC_NULLS_FIRST',
  RewardPeriodInfoFirstBlockDescNullsLast = 'rewardPeriodInfo_firstBlock_DESC_NULLS_LAST',
  RewardPeriodInfoIdAsc = 'rewardPeriodInfo_id_ASC',
  RewardPeriodInfoIdAscNullsFirst = 'rewardPeriodInfo_id_ASC_NULLS_FIRST',
  RewardPeriodInfoIdAscNullsLast = 'rewardPeriodInfo_id_ASC_NULLS_LAST',
  RewardPeriodInfoIdDesc = 'rewardPeriodInfo_id_DESC',
  RewardPeriodInfoIdDescNullsFirst = 'rewardPeriodInfo_id_DESC_NULLS_FIRST',
  RewardPeriodInfoIdDescNullsLast = 'rewardPeriodInfo_id_DESC_NULLS_LAST',
  RewardPeriodInfoIndexAsc = 'rewardPeriodInfo_index_ASC',
  RewardPeriodInfoIndexAscNullsFirst = 'rewardPeriodInfo_index_ASC_NULLS_FIRST',
  RewardPeriodInfoIndexAscNullsLast = 'rewardPeriodInfo_index_ASC_NULLS_LAST',
  RewardPeriodInfoIndexDesc = 'rewardPeriodInfo_index_DESC',
  RewardPeriodInfoIndexDescNullsFirst = 'rewardPeriodInfo_index_DESC_NULLS_FIRST',
  RewardPeriodInfoIndexDescNullsLast = 'rewardPeriodInfo_index_DESC_NULLS_LAST',
  RewardPeriodInfoLengthAsc = 'rewardPeriodInfo_length_ASC',
  RewardPeriodInfoLengthAscNullsFirst = 'rewardPeriodInfo_length_ASC_NULLS_FIRST',
  RewardPeriodInfoLengthAscNullsLast = 'rewardPeriodInfo_length_ASC_NULLS_LAST',
  RewardPeriodInfoLengthDesc = 'rewardPeriodInfo_length_DESC',
  RewardPeriodInfoLengthDescNullsFirst = 'rewardPeriodInfo_length_DESC_NULLS_FIRST',
  RewardPeriodInfoLengthDescNullsLast = 'rewardPeriodInfo_length_DESC_NULLS_LAST',
}

export type RewardsCalculatedForPeriodWhereInput = {
  AND?: InputMaybe<Array<RewardsCalculatedForPeriodWhereInput>>;
  OR?: InputMaybe<Array<RewardsCalculatedForPeriodWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriodInfo?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
  rewardPeriodInfo_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewardsCalculatedForPeriodsConnection = {
  __typename?: 'RewardsCalculatedForPeriodsConnection';
  edges: Array<RewardsCalculatedForPeriodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RewardsClaimed = {
  __typename?: 'RewardsClaimed';
  address: Account;
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  rewardPeriod: ActiveRewardPeriodInfo;
  totalRewardsClaimed?: Maybe<Scalars['BigInt']['output']>;
};

export type RewardsClaimedEdge = {
  __typename?: 'RewardsClaimedEdge';
  cursor: Scalars['String']['output'];
  node: RewardsClaimed;
};

export enum RewardsClaimedOrderByInput {
  AddressIdAsc = 'address_id_ASC',
  AddressIdAscNullsFirst = 'address_id_ASC_NULLS_FIRST',
  AddressIdAscNullsLast = 'address_id_ASC_NULLS_LAST',
  AddressIdDesc = 'address_id_DESC',
  AddressIdDescNullsFirst = 'address_id_DESC_NULLS_FIRST',
  AddressIdDescNullsLast = 'address_id_DESC_NULLS_LAST',
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  RewardPeriodBlockNumberAsc = 'rewardPeriod_blockNumber_ASC',
  RewardPeriodBlockNumberAscNullsFirst = 'rewardPeriod_blockNumber_ASC_NULLS_FIRST',
  RewardPeriodBlockNumberAscNullsLast = 'rewardPeriod_blockNumber_ASC_NULLS_LAST',
  RewardPeriodBlockNumberDesc = 'rewardPeriod_blockNumber_DESC',
  RewardPeriodBlockNumberDescNullsFirst = 'rewardPeriod_blockNumber_DESC_NULLS_FIRST',
  RewardPeriodBlockNumberDescNullsLast = 'rewardPeriod_blockNumber_DESC_NULLS_LAST',
  RewardPeriodFirstBlockAsc = 'rewardPeriod_firstBlock_ASC',
  RewardPeriodFirstBlockAscNullsFirst = 'rewardPeriod_firstBlock_ASC_NULLS_FIRST',
  RewardPeriodFirstBlockAscNullsLast = 'rewardPeriod_firstBlock_ASC_NULLS_LAST',
  RewardPeriodFirstBlockDesc = 'rewardPeriod_firstBlock_DESC',
  RewardPeriodFirstBlockDescNullsFirst = 'rewardPeriod_firstBlock_DESC_NULLS_FIRST',
  RewardPeriodFirstBlockDescNullsLast = 'rewardPeriod_firstBlock_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriod_index_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriod_index_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriod_index_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriod_index_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriod_index_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriod_index_DESC_NULLS_LAST',
  RewardPeriodLengthAsc = 'rewardPeriod_length_ASC',
  RewardPeriodLengthAscNullsFirst = 'rewardPeriod_length_ASC_NULLS_FIRST',
  RewardPeriodLengthAscNullsLast = 'rewardPeriod_length_ASC_NULLS_LAST',
  RewardPeriodLengthDesc = 'rewardPeriod_length_DESC',
  RewardPeriodLengthDescNullsFirst = 'rewardPeriod_length_DESC_NULLS_FIRST',
  RewardPeriodLengthDescNullsLast = 'rewardPeriod_length_DESC_NULLS_LAST',
  TotalRewardsClaimedAsc = 'totalRewardsClaimed_ASC',
  TotalRewardsClaimedAscNullsFirst = 'totalRewardsClaimed_ASC_NULLS_FIRST',
  TotalRewardsClaimedAscNullsLast = 'totalRewardsClaimed_ASC_NULLS_LAST',
  TotalRewardsClaimedDesc = 'totalRewardsClaimed_DESC',
  TotalRewardsClaimedDescNullsFirst = 'totalRewardsClaimed_DESC_NULLS_FIRST',
  TotalRewardsClaimedDescNullsLast = 'totalRewardsClaimed_DESC_NULLS_LAST',
}

export type RewardsClaimedWhereInput = {
  AND?: InputMaybe<Array<RewardsClaimedWhereInput>>;
  OR?: InputMaybe<Array<RewardsClaimedWhereInput>>;
  address?: InputMaybe<AccountWhereInput>;
  address_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriod?: InputMaybe<ActiveRewardPeriodInfoWhereInput>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  totalRewardsClaimed_eq?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalRewardsClaimed_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  totalRewardsClaimed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardsClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type RewardsClaimedsConnection = {
  __typename?: 'RewardsClaimedsConnection';
  edges: Array<RewardsClaimedEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ScheduleExecutionResult {
  Err = 'Err',
  Ok = 'Ok',
}

export type SchedulerDispatch = {
  __typename?: 'SchedulerDispatch';
  avnLower?: Maybe<AvnLower>;
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['Int']['output'];
  blockTimestamp: Scalars['DateTime']['output'];
  errorDocs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errorMethod?: Maybe<Scalars['String']['output']>;
  errorName?: Maybe<Scalars['String']['output']>;
  errorPallet?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  scheduleExecutionResult?: Maybe<ScheduleExecutionResult>;
  scheduleId: Scalars['String']['output'];
  task0: Scalars['Int']['output'];
  task1: Scalars['Int']['output'];
};

export type SchedulerDispatchEdge = {
  __typename?: 'SchedulerDispatchEdge';
  cursor: Scalars['String']['output'];
  node: SchedulerDispatch;
};

export enum SchedulerDispatchOrderByInput {
  AvnLowerAmountAsc = 'avnLower_amount_ASC',
  AvnLowerAmountAscNullsFirst = 'avnLower_amount_ASC_NULLS_FIRST',
  AvnLowerAmountAscNullsLast = 'avnLower_amount_ASC_NULLS_LAST',
  AvnLowerAmountDesc = 'avnLower_amount_DESC',
  AvnLowerAmountDescNullsFirst = 'avnLower_amount_DESC_NULLS_FIRST',
  AvnLowerAmountDescNullsLast = 'avnLower_amount_DESC_NULLS_LAST',
  AvnLowerBlockNumberAsc = 'avnLower_blockNumber_ASC',
  AvnLowerBlockNumberAscNullsFirst = 'avnLower_blockNumber_ASC_NULLS_FIRST',
  AvnLowerBlockNumberAscNullsLast = 'avnLower_blockNumber_ASC_NULLS_LAST',
  AvnLowerBlockNumberDesc = 'avnLower_blockNumber_DESC',
  AvnLowerBlockNumberDescNullsFirst = 'avnLower_blockNumber_DESC_NULLS_FIRST',
  AvnLowerBlockNumberDescNullsLast = 'avnLower_blockNumber_DESC_NULLS_LAST',
  AvnLowerClaimBlockNumberAsc = 'avnLower_claimBlockNumber_ASC',
  AvnLowerClaimBlockNumberAscNullsFirst = 'avnLower_claimBlockNumber_ASC_NULLS_FIRST',
  AvnLowerClaimBlockNumberAscNullsLast = 'avnLower_claimBlockNumber_ASC_NULLS_LAST',
  AvnLowerClaimBlockNumberDesc = 'avnLower_claimBlockNumber_DESC',
  AvnLowerClaimBlockNumberDescNullsFirst = 'avnLower_claimBlockNumber_DESC_NULLS_FIRST',
  AvnLowerClaimBlockNumberDescNullsLast = 'avnLower_claimBlockNumber_DESC_NULLS_LAST',
  AvnLowerClaimedAsc = 'avnLower_claimed_ASC',
  AvnLowerClaimedAscNullsFirst = 'avnLower_claimed_ASC_NULLS_FIRST',
  AvnLowerClaimedAscNullsLast = 'avnLower_claimed_ASC_NULLS_LAST',
  AvnLowerClaimedDesc = 'avnLower_claimed_DESC',
  AvnLowerClaimedDescNullsFirst = 'avnLower_claimed_DESC_NULLS_FIRST',
  AvnLowerClaimedDescNullsLast = 'avnLower_claimed_DESC_NULLS_LAST',
  AvnLowerEncodedLowerProofAsc = 'avnLower_encodedLowerProof_ASC',
  AvnLowerEncodedLowerProofAscNullsFirst = 'avnLower_encodedLowerProof_ASC_NULLS_FIRST',
  AvnLowerEncodedLowerProofAscNullsLast = 'avnLower_encodedLowerProof_ASC_NULLS_LAST',
  AvnLowerEncodedLowerProofDesc = 'avnLower_encodedLowerProof_DESC',
  AvnLowerEncodedLowerProofDescNullsFirst = 'avnLower_encodedLowerProof_DESC_NULLS_FIRST',
  AvnLowerEncodedLowerProofDescNullsLast = 'avnLower_encodedLowerProof_DESC_NULLS_LAST',
  AvnLowerIdAsc = 'avnLower_id_ASC',
  AvnLowerIdAscNullsFirst = 'avnLower_id_ASC_NULLS_FIRST',
  AvnLowerIdAscNullsLast = 'avnLower_id_ASC_NULLS_LAST',
  AvnLowerIdDesc = 'avnLower_id_DESC',
  AvnLowerIdDescNullsFirst = 'avnLower_id_DESC_NULLS_FIRST',
  AvnLowerIdDescNullsLast = 'avnLower_id_DESC_NULLS_LAST',
  AvnLowerIsFinalizedAsc = 'avnLower_isFinalized_ASC',
  AvnLowerIsFinalizedAscNullsFirst = 'avnLower_isFinalized_ASC_NULLS_FIRST',
  AvnLowerIsFinalizedAscNullsLast = 'avnLower_isFinalized_ASC_NULLS_LAST',
  AvnLowerIsFinalizedDesc = 'avnLower_isFinalized_DESC',
  AvnLowerIsFinalizedDescNullsFirst = 'avnLower_isFinalized_DESC_NULLS_FIRST',
  AvnLowerIsFinalizedDescNullsLast = 'avnLower_isFinalized_DESC_NULLS_LAST',
  AvnLowerIsPendingAsc = 'avnLower_isPending_ASC',
  AvnLowerIsPendingAscNullsFirst = 'avnLower_isPending_ASC_NULLS_FIRST',
  AvnLowerIsPendingAscNullsLast = 'avnLower_isPending_ASC_NULLS_LAST',
  AvnLowerIsPendingDesc = 'avnLower_isPending_DESC',
  AvnLowerIsPendingDescNullsFirst = 'avnLower_isPending_DESC_NULLS_FIRST',
  AvnLowerIsPendingDescNullsLast = 'avnLower_isPending_DESC_NULLS_LAST',
  AvnLowerLowerIdAsc = 'avnLower_lowerId_ASC',
  AvnLowerLowerIdAscNullsFirst = 'avnLower_lowerId_ASC_NULLS_FIRST',
  AvnLowerLowerIdAscNullsLast = 'avnLower_lowerId_ASC_NULLS_LAST',
  AvnLowerLowerIdDesc = 'avnLower_lowerId_DESC',
  AvnLowerLowerIdDescNullsFirst = 'avnLower_lowerId_DESC_NULLS_FIRST',
  AvnLowerLowerIdDescNullsLast = 'avnLower_lowerId_DESC_NULLS_LAST',
  AvnLowerLowerPendingProofAsc = 'avnLower_lowerPendingProof_ASC',
  AvnLowerLowerPendingProofAscNullsFirst = 'avnLower_lowerPendingProof_ASC_NULLS_FIRST',
  AvnLowerLowerPendingProofAscNullsLast = 'avnLower_lowerPendingProof_ASC_NULLS_LAST',
  AvnLowerLowerPendingProofDesc = 'avnLower_lowerPendingProof_DESC',
  AvnLowerLowerPendingProofDescNullsFirst = 'avnLower_lowerPendingProof_DESC_NULLS_FIRST',
  AvnLowerLowerPendingProofDescNullsLast = 'avnLower_lowerPendingProof_DESC_NULLS_LAST',
  AvnLowerReadyToBeClaimedAsc = 'avnLower_readyToBeClaimed_ASC',
  AvnLowerReadyToBeClaimedAscNullsFirst = 'avnLower_readyToBeClaimed_ASC_NULLS_FIRST',
  AvnLowerReadyToBeClaimedAscNullsLast = 'avnLower_readyToBeClaimed_ASC_NULLS_LAST',
  AvnLowerReadyToBeClaimedDesc = 'avnLower_readyToBeClaimed_DESC',
  AvnLowerReadyToBeClaimedDescNullsFirst = 'avnLower_readyToBeClaimed_DESC_NULLS_FIRST',
  AvnLowerReadyToBeClaimedDescNullsLast = 'avnLower_readyToBeClaimed_DESC_NULLS_LAST',
  AvnLowerReceiverAsc = 'avnLower_receiver_ASC',
  AvnLowerReceiverAscNullsFirst = 'avnLower_receiver_ASC_NULLS_FIRST',
  AvnLowerReceiverAscNullsLast = 'avnLower_receiver_ASC_NULLS_LAST',
  AvnLowerReceiverDesc = 'avnLower_receiver_DESC',
  AvnLowerReceiverDescNullsFirst = 'avnLower_receiver_DESC_NULLS_FIRST',
  AvnLowerReceiverDescNullsLast = 'avnLower_receiver_DESC_NULLS_LAST',
  AvnLowerRecipientAsc = 'avnLower_recipient_ASC',
  AvnLowerRecipientAscNullsFirst = 'avnLower_recipient_ASC_NULLS_FIRST',
  AvnLowerRecipientAscNullsLast = 'avnLower_recipient_ASC_NULLS_LAST',
  AvnLowerRecipientDesc = 'avnLower_recipient_DESC',
  AvnLowerRecipientDescNullsFirst = 'avnLower_recipient_DESC_NULLS_FIRST',
  AvnLowerRecipientDescNullsLast = 'avnLower_recipient_DESC_NULLS_LAST',
  AvnLowerScheduleIdAsc = 'avnLower_scheduleId_ASC',
  AvnLowerScheduleIdAscNullsFirst = 'avnLower_scheduleId_ASC_NULLS_FIRST',
  AvnLowerScheduleIdAscNullsLast = 'avnLower_scheduleId_ASC_NULLS_LAST',
  AvnLowerScheduleIdDesc = 'avnLower_scheduleId_DESC',
  AvnLowerScheduleIdDescNullsFirst = 'avnLower_scheduleId_DESC_NULLS_FIRST',
  AvnLowerScheduleIdDescNullsLast = 'avnLower_scheduleId_DESC_NULLS_LAST',
  AvnLowerTargetAsc = 'avnLower_target_ASC',
  AvnLowerTargetAscNullsFirst = 'avnLower_target_ASC_NULLS_FIRST',
  AvnLowerTargetAscNullsLast = 'avnLower_target_ASC_NULLS_LAST',
  AvnLowerTargetDesc = 'avnLower_target_DESC',
  AvnLowerTargetDescNullsFirst = 'avnLower_target_DESC_NULLS_FIRST',
  AvnLowerTargetDescNullsLast = 'avnLower_target_DESC_NULLS_LAST',
  AvnLowerWhenAsc = 'avnLower_when_ASC',
  AvnLowerWhenAscNullsFirst = 'avnLower_when_ASC_NULLS_FIRST',
  AvnLowerWhenAscNullsLast = 'avnLower_when_ASC_NULLS_LAST',
  AvnLowerWhenDesc = 'avnLower_when_DESC',
  AvnLowerWhenDescNullsFirst = 'avnLower_when_DESC_NULLS_FIRST',
  AvnLowerWhenDescNullsLast = 'avnLower_when_DESC_NULLS_LAST',
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  BlockTimestampAsc = 'blockTimestamp_ASC',
  BlockTimestampAscNullsFirst = 'blockTimestamp_ASC_NULLS_FIRST',
  BlockTimestampAscNullsLast = 'blockTimestamp_ASC_NULLS_LAST',
  BlockTimestampDesc = 'blockTimestamp_DESC',
  BlockTimestampDescNullsFirst = 'blockTimestamp_DESC_NULLS_FIRST',
  BlockTimestampDescNullsLast = 'blockTimestamp_DESC_NULLS_LAST',
  ErrorMethodAsc = 'errorMethod_ASC',
  ErrorMethodAscNullsFirst = 'errorMethod_ASC_NULLS_FIRST',
  ErrorMethodAscNullsLast = 'errorMethod_ASC_NULLS_LAST',
  ErrorMethodDesc = 'errorMethod_DESC',
  ErrorMethodDescNullsFirst = 'errorMethod_DESC_NULLS_FIRST',
  ErrorMethodDescNullsLast = 'errorMethod_DESC_NULLS_LAST',
  ErrorNameAsc = 'errorName_ASC',
  ErrorNameAscNullsFirst = 'errorName_ASC_NULLS_FIRST',
  ErrorNameAscNullsLast = 'errorName_ASC_NULLS_LAST',
  ErrorNameDesc = 'errorName_DESC',
  ErrorNameDescNullsFirst = 'errorName_DESC_NULLS_FIRST',
  ErrorNameDescNullsLast = 'errorName_DESC_NULLS_LAST',
  ErrorPalletAsc = 'errorPallet_ASC',
  ErrorPalletAscNullsFirst = 'errorPallet_ASC_NULLS_FIRST',
  ErrorPalletAscNullsLast = 'errorPallet_ASC_NULLS_LAST',
  ErrorPalletDesc = 'errorPallet_DESC',
  ErrorPalletDescNullsFirst = 'errorPallet_DESC_NULLS_FIRST',
  ErrorPalletDescNullsLast = 'errorPallet_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  ScheduleExecutionResultAsc = 'scheduleExecutionResult_ASC',
  ScheduleExecutionResultAscNullsFirst = 'scheduleExecutionResult_ASC_NULLS_FIRST',
  ScheduleExecutionResultAscNullsLast = 'scheduleExecutionResult_ASC_NULLS_LAST',
  ScheduleExecutionResultDesc = 'scheduleExecutionResult_DESC',
  ScheduleExecutionResultDescNullsFirst = 'scheduleExecutionResult_DESC_NULLS_FIRST',
  ScheduleExecutionResultDescNullsLast = 'scheduleExecutionResult_DESC_NULLS_LAST',
  ScheduleIdAsc = 'scheduleId_ASC',
  ScheduleIdAscNullsFirst = 'scheduleId_ASC_NULLS_FIRST',
  ScheduleIdAscNullsLast = 'scheduleId_ASC_NULLS_LAST',
  ScheduleIdDesc = 'scheduleId_DESC',
  ScheduleIdDescNullsFirst = 'scheduleId_DESC_NULLS_FIRST',
  ScheduleIdDescNullsLast = 'scheduleId_DESC_NULLS_LAST',
  Task0Asc = 'task0_ASC',
  Task0AscNullsFirst = 'task0_ASC_NULLS_FIRST',
  Task0AscNullsLast = 'task0_ASC_NULLS_LAST',
  Task0Desc = 'task0_DESC',
  Task0DescNullsFirst = 'task0_DESC_NULLS_FIRST',
  Task0DescNullsLast = 'task0_DESC_NULLS_LAST',
  Task1Asc = 'task1_ASC',
  Task1AscNullsFirst = 'task1_ASC_NULLS_FIRST',
  Task1AscNullsLast = 'task1_ASC_NULLS_LAST',
  Task1Desc = 'task1_DESC',
  Task1DescNullsFirst = 'task1_DESC_NULLS_FIRST',
  Task1DescNullsLast = 'task1_DESC_NULLS_LAST',
}

export type SchedulerDispatchWhereInput = {
  AND?: InputMaybe<Array<SchedulerDispatchWhereInput>>;
  OR?: InputMaybe<Array<SchedulerDispatchWhereInput>>;
  avnLower?: InputMaybe<AvnLowerWhereInput>;
  avnLower_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockTimestamp_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  blockTimestamp_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockTimestamp_lt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorDocs_containsAll?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDocs_containsAny?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDocs_containsNone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDocs_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorMethod_contains?: InputMaybe<Scalars['String']['input']>;
  errorMethod_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorMethod_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorMethod_eq?: InputMaybe<Scalars['String']['input']>;
  errorMethod_gt?: InputMaybe<Scalars['String']['input']>;
  errorMethod_gte?: InputMaybe<Scalars['String']['input']>;
  errorMethod_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMethod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorMethod_lt?: InputMaybe<Scalars['String']['input']>;
  errorMethod_lte?: InputMaybe<Scalars['String']['input']>;
  errorMethod_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorMethod_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorMethod_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorMethod_not_eq?: InputMaybe<Scalars['String']['input']>;
  errorMethod_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMethod_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorMethod_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_contains?: InputMaybe<Scalars['String']['input']>;
  errorName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorName_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_eq?: InputMaybe<Scalars['String']['input']>;
  errorName_gt?: InputMaybe<Scalars['String']['input']>;
  errorName_gte?: InputMaybe<Scalars['String']['input']>;
  errorName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorName_lt?: InputMaybe<Scalars['String']['input']>;
  errorName_lte?: InputMaybe<Scalars['String']['input']>;
  errorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_not_eq?: InputMaybe<Scalars['String']['input']>;
  errorName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorPallet_contains?: InputMaybe<Scalars['String']['input']>;
  errorPallet_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorPallet_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorPallet_eq?: InputMaybe<Scalars['String']['input']>;
  errorPallet_gt?: InputMaybe<Scalars['String']['input']>;
  errorPallet_gte?: InputMaybe<Scalars['String']['input']>;
  errorPallet_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorPallet_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorPallet_lt?: InputMaybe<Scalars['String']['input']>;
  errorPallet_lte?: InputMaybe<Scalars['String']['input']>;
  errorPallet_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorPallet_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorPallet_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorPallet_not_eq?: InputMaybe<Scalars['String']['input']>;
  errorPallet_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorPallet_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorPallet_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleExecutionResult_eq?: InputMaybe<ScheduleExecutionResult>;
  scheduleExecutionResult_in?: InputMaybe<Array<ScheduleExecutionResult>>;
  scheduleExecutionResult_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleExecutionResult_not_eq?: InputMaybe<ScheduleExecutionResult>;
  scheduleExecutionResult_not_in?: InputMaybe<Array<ScheduleExecutionResult>>;
  scheduleId_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleId_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleId_gt?: InputMaybe<Scalars['String']['input']>;
  scheduleId_gte?: InputMaybe<Scalars['String']['input']>;
  scheduleId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId_lt?: InputMaybe<Scalars['String']['input']>;
  scheduleId_lte?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleId_startsWith?: InputMaybe<Scalars['String']['input']>;
  task0_eq?: InputMaybe<Scalars['Int']['input']>;
  task0_gt?: InputMaybe<Scalars['Int']['input']>;
  task0_gte?: InputMaybe<Scalars['Int']['input']>;
  task0_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  task0_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  task0_lt?: InputMaybe<Scalars['Int']['input']>;
  task0_lte?: InputMaybe<Scalars['Int']['input']>;
  task0_not_eq?: InputMaybe<Scalars['Int']['input']>;
  task0_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  task1_eq?: InputMaybe<Scalars['Int']['input']>;
  task1_gt?: InputMaybe<Scalars['Int']['input']>;
  task1_gte?: InputMaybe<Scalars['Int']['input']>;
  task1_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  task1_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  task1_lt?: InputMaybe<Scalars['Int']['input']>;
  task1_lte?: InputMaybe<Scalars['Int']['input']>;
  task1_not_eq?: InputMaybe<Scalars['Int']['input']>;
  task1_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SchedulerDispatchesConnection = {
  __typename?: 'SchedulerDispatchesConnection';
  edges: Array<SchedulerDispatchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Solution = {
  __typename?: 'Solution';
  additionToExtraneousGroupsAllowed?: Maybe<Scalars['Boolean']['output']>;
  consensus: SolutionConsensus;
  expirationBlock: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  info: SolutionInfo;
  namespace: Scalars['String']['output'];
  nominationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  registrar: RegistrarAccount;
  solutionGroup?: Maybe<SolutionGroup>;
  status?: Maybe<Scalars['String']['output']>;
  workload: SolutionWorkload;
};

export type SolutionConsensus = {
  __typename?: 'SolutionConsensus';
  id: Scalars['String']['output'];
  maxWaitingThreshold: Scalars['Int']['output'];
  quorumPercent?: Maybe<Scalars['Int']['output']>;
  voteThresholdPercent: Scalars['Int']['output'];
  votingStartMethod?: Maybe<Scalars['String']['output']>;
};

export type SolutionConsensusConnection = {
  __typename?: 'SolutionConsensusConnection';
  edges: Array<SolutionConsensusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionConsensusEdge = {
  __typename?: 'SolutionConsensusEdge';
  cursor: Scalars['String']['output'];
  node: SolutionConsensus;
};

export enum SolutionConsensusOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  MaxWaitingThresholdAsc = 'maxWaitingThreshold_ASC',
  MaxWaitingThresholdAscNullsFirst = 'maxWaitingThreshold_ASC_NULLS_FIRST',
  MaxWaitingThresholdAscNullsLast = 'maxWaitingThreshold_ASC_NULLS_LAST',
  MaxWaitingThresholdDesc = 'maxWaitingThreshold_DESC',
  MaxWaitingThresholdDescNullsFirst = 'maxWaitingThreshold_DESC_NULLS_FIRST',
  MaxWaitingThresholdDescNullsLast = 'maxWaitingThreshold_DESC_NULLS_LAST',
  QuorumPercentAsc = 'quorumPercent_ASC',
  QuorumPercentAscNullsFirst = 'quorumPercent_ASC_NULLS_FIRST',
  QuorumPercentAscNullsLast = 'quorumPercent_ASC_NULLS_LAST',
  QuorumPercentDesc = 'quorumPercent_DESC',
  QuorumPercentDescNullsFirst = 'quorumPercent_DESC_NULLS_FIRST',
  QuorumPercentDescNullsLast = 'quorumPercent_DESC_NULLS_LAST',
  VoteThresholdPercentAsc = 'voteThresholdPercent_ASC',
  VoteThresholdPercentAscNullsFirst = 'voteThresholdPercent_ASC_NULLS_FIRST',
  VoteThresholdPercentAscNullsLast = 'voteThresholdPercent_ASC_NULLS_LAST',
  VoteThresholdPercentDesc = 'voteThresholdPercent_DESC',
  VoteThresholdPercentDescNullsFirst = 'voteThresholdPercent_DESC_NULLS_FIRST',
  VoteThresholdPercentDescNullsLast = 'voteThresholdPercent_DESC_NULLS_LAST',
  VotingStartMethodAsc = 'votingStartMethod_ASC',
  VotingStartMethodAscNullsFirst = 'votingStartMethod_ASC_NULLS_FIRST',
  VotingStartMethodAscNullsLast = 'votingStartMethod_ASC_NULLS_LAST',
  VotingStartMethodDesc = 'votingStartMethod_DESC',
  VotingStartMethodDescNullsFirst = 'votingStartMethod_DESC_NULLS_FIRST',
  VotingStartMethodDescNullsLast = 'votingStartMethod_DESC_NULLS_LAST',
}

export type SolutionConsensusWhereInput = {
  AND?: InputMaybe<Array<SolutionConsensusWhereInput>>;
  OR?: InputMaybe<Array<SolutionConsensusWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  maxWaitingThreshold_eq?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxWaitingThreshold_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  maxWaitingThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_not_eq?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingThreshold_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  quorumPercent_eq?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_gt?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_gte?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  quorumPercent_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  quorumPercent_lt?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_lte?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_not_eq?: InputMaybe<Scalars['Int']['input']>;
  quorumPercent_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  voteThresholdPercent_eq?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_gt?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_gte?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  voteThresholdPercent_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  voteThresholdPercent_lt?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_lte?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_not_eq?: InputMaybe<Scalars['Int']['input']>;
  voteThresholdPercent_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  votingStartMethod_contains?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_eq?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_gt?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_gte?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingStartMethod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingStartMethod_lt?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_lte?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_not_contains?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_not_eq?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingStartMethod_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  votingStartMethod_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SolutionEdge = {
  __typename?: 'SolutionEdge';
  cursor: Scalars['String']['output'];
  node: Solution;
};

export type SolutionGroup = {
  __typename?: 'SolutionGroup';
  allowedCids: Array<SolutionGroupAllowedCid>;
  assuranceSlashingConfig?: Maybe<SolutionGroupAssuranceSlashingConfig>;
  earnedRewards: Array<EarnedRewards>;
  hasCidAllowList?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  info: SolutionGroupInfo;
  namespace: Scalars['String']['output'];
  operationEndBlock: Scalars['Int']['output'];
  operationStartBlock: Scalars['Int']['output'];
  operatorsConfig: SolutionGroupOperatorsConfig;
  performanceSlashingConfig?: Maybe<SolutionGroupPerformanceSlashingConfig>;
  registrar: RegistrarAccount;
  rewardsConfig: SolutionGroupRewardsConfig;
  scheduledUnsubscriptions: Array<UnsubscriptionSchedule>;
  slaVotingThreshold?: Maybe<Scalars['Int']['output']>;
  solutions: Array<Solution>;
  stakes: Array<OperatorSubscribedStake>;
  stakingAmounts: SolutionGroupStakingAmounts;
  subscribedOperators: Array<OperatorSubscribedSolutionGroups>;
  withdrawalDelay?: Maybe<Scalars['Int']['output']>;
};

export type SolutionGroupAllowedCidsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionGroupAllowedCidOrderByInput>>;
  where?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
};

export type SolutionGroupEarnedRewardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EarnedRewardsOrderByInput>>;
  where?: InputMaybe<EarnedRewardsWhereInput>;
};

export type SolutionGroupScheduledUnsubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnsubscriptionScheduleOrderByInput>>;
  where?: InputMaybe<UnsubscriptionScheduleWhereInput>;
};

export type SolutionGroupSolutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionOrderByInput>>;
  where?: InputMaybe<SolutionWhereInput>;
};

export type SolutionGroupStakesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedStakeOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedStakeWhereInput>;
};

export type SolutionGroupSubscribedOperatorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorSubscribedSolutionGroupsOrderByInput>>;
  where?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
};

export type SolutionGroupAllowedCid = {
  __typename?: 'SolutionGroupAllowedCid';
  id: Scalars['String']['output'];
  solutionGroup: SolutionGroup;
  worklogicCid: Scalars['String']['output'];
};

export type SolutionGroupAllowedCidEdge = {
  __typename?: 'SolutionGroupAllowedCidEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupAllowedCid;
};

export enum SolutionGroupAllowedCidOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
  WorklogicCidAsc = 'worklogicCid_ASC',
  WorklogicCidAscNullsFirst = 'worklogicCid_ASC_NULLS_FIRST',
  WorklogicCidAscNullsLast = 'worklogicCid_ASC_NULLS_LAST',
  WorklogicCidDesc = 'worklogicCid_DESC',
  WorklogicCidDescNullsFirst = 'worklogicCid_DESC_NULLS_FIRST',
  WorklogicCidDescNullsLast = 'worklogicCid_DESC_NULLS_LAST',
}

export type SolutionGroupAllowedCidWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupAllowedCidWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupAllowedCidWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worklogicCid_contains?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_endsWith?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_eq?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_gt?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_gte?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_in?: InputMaybe<Array<Scalars['String']['input']>>;
  worklogicCid_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worklogicCid_lt?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_lte?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_not_contains?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_not_eq?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  worklogicCid_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  worklogicCid_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SolutionGroupAllowedCidsConnection = {
  __typename?: 'SolutionGroupAllowedCidsConnection';
  edges: Array<SolutionGroupAllowedCidEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupAssuranceSlashingConfig = {
  __typename?: 'SolutionGroupAssuranceSlashingConfig';
  disputeAuthority?: Maybe<Scalars['String']['output']>;
  disputeExpiry: Scalars['Int']['output'];
  disputeInitiation: Scalars['String']['output'];
  disputeInitiationReserve: Scalars['BigInt']['output'];
  disputePeriod: Scalars['Int']['output'];
  disputeTreasury?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  slashingCriteriaMajority: Scalars['Int']['output'];
  slashingCriteriaMinority: Scalars['Int']['output'];
  solutionGroup: SolutionGroup;
};

export type SolutionGroupAssuranceSlashingConfigEdge = {
  __typename?: 'SolutionGroupAssuranceSlashingConfigEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupAssuranceSlashingConfig;
};

export enum SolutionGroupAssuranceSlashingConfigOrderByInput {
  DisputeAuthorityAsc = 'disputeAuthority_ASC',
  DisputeAuthorityAscNullsFirst = 'disputeAuthority_ASC_NULLS_FIRST',
  DisputeAuthorityAscNullsLast = 'disputeAuthority_ASC_NULLS_LAST',
  DisputeAuthorityDesc = 'disputeAuthority_DESC',
  DisputeAuthorityDescNullsFirst = 'disputeAuthority_DESC_NULLS_FIRST',
  DisputeAuthorityDescNullsLast = 'disputeAuthority_DESC_NULLS_LAST',
  DisputeExpiryAsc = 'disputeExpiry_ASC',
  DisputeExpiryAscNullsFirst = 'disputeExpiry_ASC_NULLS_FIRST',
  DisputeExpiryAscNullsLast = 'disputeExpiry_ASC_NULLS_LAST',
  DisputeExpiryDesc = 'disputeExpiry_DESC',
  DisputeExpiryDescNullsFirst = 'disputeExpiry_DESC_NULLS_FIRST',
  DisputeExpiryDescNullsLast = 'disputeExpiry_DESC_NULLS_LAST',
  DisputeInitiationReserveAsc = 'disputeInitiationReserve_ASC',
  DisputeInitiationReserveAscNullsFirst = 'disputeInitiationReserve_ASC_NULLS_FIRST',
  DisputeInitiationReserveAscNullsLast = 'disputeInitiationReserve_ASC_NULLS_LAST',
  DisputeInitiationReserveDesc = 'disputeInitiationReserve_DESC',
  DisputeInitiationReserveDescNullsFirst = 'disputeInitiationReserve_DESC_NULLS_FIRST',
  DisputeInitiationReserveDescNullsLast = 'disputeInitiationReserve_DESC_NULLS_LAST',
  DisputeInitiationAsc = 'disputeInitiation_ASC',
  DisputeInitiationAscNullsFirst = 'disputeInitiation_ASC_NULLS_FIRST',
  DisputeInitiationAscNullsLast = 'disputeInitiation_ASC_NULLS_LAST',
  DisputeInitiationDesc = 'disputeInitiation_DESC',
  DisputeInitiationDescNullsFirst = 'disputeInitiation_DESC_NULLS_FIRST',
  DisputeInitiationDescNullsLast = 'disputeInitiation_DESC_NULLS_LAST',
  DisputePeriodAsc = 'disputePeriod_ASC',
  DisputePeriodAscNullsFirst = 'disputePeriod_ASC_NULLS_FIRST',
  DisputePeriodAscNullsLast = 'disputePeriod_ASC_NULLS_LAST',
  DisputePeriodDesc = 'disputePeriod_DESC',
  DisputePeriodDescNullsFirst = 'disputePeriod_DESC_NULLS_FIRST',
  DisputePeriodDescNullsLast = 'disputePeriod_DESC_NULLS_LAST',
  DisputeTreasuryAsc = 'disputeTreasury_ASC',
  DisputeTreasuryAscNullsFirst = 'disputeTreasury_ASC_NULLS_FIRST',
  DisputeTreasuryAscNullsLast = 'disputeTreasury_ASC_NULLS_LAST',
  DisputeTreasuryDesc = 'disputeTreasury_DESC',
  DisputeTreasuryDescNullsFirst = 'disputeTreasury_DESC_NULLS_FIRST',
  DisputeTreasuryDescNullsLast = 'disputeTreasury_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  SlashingCriteriaMajorityAsc = 'slashingCriteriaMajority_ASC',
  SlashingCriteriaMajorityAscNullsFirst = 'slashingCriteriaMajority_ASC_NULLS_FIRST',
  SlashingCriteriaMajorityAscNullsLast = 'slashingCriteriaMajority_ASC_NULLS_LAST',
  SlashingCriteriaMajorityDesc = 'slashingCriteriaMajority_DESC',
  SlashingCriteriaMajorityDescNullsFirst = 'slashingCriteriaMajority_DESC_NULLS_FIRST',
  SlashingCriteriaMajorityDescNullsLast = 'slashingCriteriaMajority_DESC_NULLS_LAST',
  SlashingCriteriaMinorityAsc = 'slashingCriteriaMinority_ASC',
  SlashingCriteriaMinorityAscNullsFirst = 'slashingCriteriaMinority_ASC_NULLS_FIRST',
  SlashingCriteriaMinorityAscNullsLast = 'slashingCriteriaMinority_ASC_NULLS_LAST',
  SlashingCriteriaMinorityDesc = 'slashingCriteriaMinority_DESC',
  SlashingCriteriaMinorityDescNullsFirst = 'slashingCriteriaMinority_DESC_NULLS_FIRST',
  SlashingCriteriaMinorityDescNullsLast = 'slashingCriteriaMinority_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
}

export type SolutionGroupAssuranceSlashingConfigWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupAssuranceSlashingConfigWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupAssuranceSlashingConfigWhereInput>>;
  disputeAuthority_contains?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_eq?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_gt?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_gte?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeAuthority_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputeAuthority_lt?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_lte?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_not_contains?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_not_eq?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeAuthority_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  disputeAuthority_startsWith?: InputMaybe<Scalars['String']['input']>;
  disputeExpiry_eq?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_gt?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_gte?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  disputeExpiry_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputeExpiry_lt?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_lte?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_not_eq?: InputMaybe<Scalars['Int']['input']>;
  disputeExpiry_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  disputeInitiationReserve_eq?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_gt?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_gte?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  disputeInitiationReserve_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputeInitiationReserve_lt?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_lte?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  disputeInitiationReserve_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  disputeInitiation_contains?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_eq?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_gt?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_gte?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeInitiation_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputeInitiation_lt?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_lte?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_not_contains?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_not_eq?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeInitiation_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  disputeInitiation_startsWith?: InputMaybe<Scalars['String']['input']>;
  disputePeriod_eq?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_gt?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_gte?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  disputePeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputePeriod_lt?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_lte?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_not_eq?: InputMaybe<Scalars['Int']['input']>;
  disputePeriod_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  disputeTreasury_contains?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_eq?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_gt?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_gte?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeTreasury_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  disputeTreasury_lt?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_lte?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_not_contains?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_not_eq?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeTreasury_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  disputeTreasury_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  slashingCriteriaMajority_eq?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_gt?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_gte?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  slashingCriteriaMajority_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  slashingCriteriaMajority_lt?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_lte?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_not_eq?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMajority_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  slashingCriteriaMinority_eq?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_gt?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_gte?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  slashingCriteriaMinority_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  slashingCriteriaMinority_lt?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_lte?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_not_eq?: InputMaybe<Scalars['Int']['input']>;
  slashingCriteriaMinority_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionGroupAssuranceSlashingConfigsConnection = {
  __typename?: 'SolutionGroupAssuranceSlashingConfigsConnection';
  edges: Array<SolutionGroupAssuranceSlashingConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupEdge = {
  __typename?: 'SolutionGroupEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroup;
};

export type SolutionGroupInfo = {
  __typename?: 'SolutionGroupInfo';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publisherInfo: Scalars['String']['output'];
};

export type SolutionGroupInfoEdge = {
  __typename?: 'SolutionGroupInfoEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupInfo;
};

export enum SolutionGroupInfoOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionAscNullsFirst = 'description_ASC_NULLS_FIRST',
  DescriptionAscNullsLast = 'description_ASC_NULLS_LAST',
  DescriptionDesc = 'description_DESC',
  DescriptionDescNullsFirst = 'description_DESC_NULLS_FIRST',
  DescriptionDescNullsLast = 'description_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlAscNullsFirst = 'logoUrl_ASC_NULLS_FIRST',
  LogoUrlAscNullsLast = 'logoUrl_ASC_NULLS_LAST',
  LogoUrlDesc = 'logoUrl_DESC',
  LogoUrlDescNullsFirst = 'logoUrl_DESC_NULLS_FIRST',
  LogoUrlDescNullsLast = 'logoUrl_DESC_NULLS_LAST',
  NameAsc = 'name_ASC',
  NameAscNullsFirst = 'name_ASC_NULLS_FIRST',
  NameAscNullsLast = 'name_ASC_NULLS_LAST',
  NameDesc = 'name_DESC',
  NameDescNullsFirst = 'name_DESC_NULLS_FIRST',
  NameDescNullsLast = 'name_DESC_NULLS_LAST',
  PublisherInfoAsc = 'publisherInfo_ASC',
  PublisherInfoAscNullsFirst = 'publisherInfo_ASC_NULLS_FIRST',
  PublisherInfoAscNullsLast = 'publisherInfo_ASC_NULLS_LAST',
  PublisherInfoDesc = 'publisherInfo_DESC',
  PublisherInfoDescNullsFirst = 'publisherInfo_DESC_NULLS_FIRST',
  PublisherInfoDescNullsLast = 'publisherInfo_DESC_NULLS_LAST',
}

export type SolutionGroupInfoWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupInfoWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupInfoWhereInput>>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  description_endsWith?: InputMaybe<Scalars['String']['input']>;
  description_eq?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  description_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  description_not_eq?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  description_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  logoUrl_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  logoUrl_endsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_eq?: InputMaybe<Scalars['String']['input']>;
  logoUrl_gt?: InputMaybe<Scalars['String']['input']>;
  logoUrl_gte?: InputMaybe<Scalars['String']['input']>;
  logoUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  logoUrl_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl_lt?: InputMaybe<Scalars['String']['input']>;
  logoUrl_lte?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_eq?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  logoUrl_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_startsWith?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_eq?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_not_eq?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  name_startsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_contains?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_endsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_eq?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_gt?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_gte?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherInfo_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  publisherInfo_lt?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_lte?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_contains?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_eq?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherInfo_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SolutionGroupInfosConnection = {
  __typename?: 'SolutionGroupInfosConnection';
  edges: Array<SolutionGroupInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupOperatorsConfig = {
  __typename?: 'SolutionGroupOperatorsConfig';
  allowedOperators: Scalars['Int']['output'];
  hasOperatorsAllowlist: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxOperatorWorkers: Scalars['Int']['output'];
  stakingAmounts: SolutionGroupStakingAmounts;
  startBlock: Scalars['Int']['output'];
};

export type SolutionGroupOperatorsConfigEdge = {
  __typename?: 'SolutionGroupOperatorsConfigEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupOperatorsConfig;
};

export enum SolutionGroupOperatorsConfigOrderByInput {
  AllowedOperatorsAsc = 'allowedOperators_ASC',
  AllowedOperatorsAscNullsFirst = 'allowedOperators_ASC_NULLS_FIRST',
  AllowedOperatorsAscNullsLast = 'allowedOperators_ASC_NULLS_LAST',
  AllowedOperatorsDesc = 'allowedOperators_DESC',
  AllowedOperatorsDescNullsFirst = 'allowedOperators_DESC_NULLS_FIRST',
  AllowedOperatorsDescNullsLast = 'allowedOperators_DESC_NULLS_LAST',
  HasOperatorsAllowlistAsc = 'hasOperatorsAllowlist_ASC',
  HasOperatorsAllowlistAscNullsFirst = 'hasOperatorsAllowlist_ASC_NULLS_FIRST',
  HasOperatorsAllowlistAscNullsLast = 'hasOperatorsAllowlist_ASC_NULLS_LAST',
  HasOperatorsAllowlistDesc = 'hasOperatorsAllowlist_DESC',
  HasOperatorsAllowlistDescNullsFirst = 'hasOperatorsAllowlist_DESC_NULLS_FIRST',
  HasOperatorsAllowlistDescNullsLast = 'hasOperatorsAllowlist_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  MaxOperatorWorkersAsc = 'maxOperatorWorkers_ASC',
  MaxOperatorWorkersAscNullsFirst = 'maxOperatorWorkers_ASC_NULLS_FIRST',
  MaxOperatorWorkersAscNullsLast = 'maxOperatorWorkers_ASC_NULLS_LAST',
  MaxOperatorWorkersDesc = 'maxOperatorWorkers_DESC',
  MaxOperatorWorkersDescNullsFirst = 'maxOperatorWorkers_DESC_NULLS_FIRST',
  MaxOperatorWorkersDescNullsLast = 'maxOperatorWorkers_DESC_NULLS_LAST',
  StakingAmountsIdAsc = 'stakingAmounts_id_ASC',
  StakingAmountsIdAscNullsFirst = 'stakingAmounts_id_ASC_NULLS_FIRST',
  StakingAmountsIdAscNullsLast = 'stakingAmounts_id_ASC_NULLS_LAST',
  StakingAmountsIdDesc = 'stakingAmounts_id_DESC',
  StakingAmountsIdDescNullsFirst = 'stakingAmounts_id_DESC_NULLS_FIRST',
  StakingAmountsIdDescNullsLast = 'stakingAmounts_id_DESC_NULLS_LAST',
  StakingAmountsMaxAsc = 'stakingAmounts_max_ASC',
  StakingAmountsMaxAscNullsFirst = 'stakingAmounts_max_ASC_NULLS_FIRST',
  StakingAmountsMaxAscNullsLast = 'stakingAmounts_max_ASC_NULLS_LAST',
  StakingAmountsMaxDesc = 'stakingAmounts_max_DESC',
  StakingAmountsMaxDescNullsFirst = 'stakingAmounts_max_DESC_NULLS_FIRST',
  StakingAmountsMaxDescNullsLast = 'stakingAmounts_max_DESC_NULLS_LAST',
  StakingAmountsMinAsc = 'stakingAmounts_min_ASC',
  StakingAmountsMinAscNullsFirst = 'stakingAmounts_min_ASC_NULLS_FIRST',
  StakingAmountsMinAscNullsLast = 'stakingAmounts_min_ASC_NULLS_LAST',
  StakingAmountsMinDesc = 'stakingAmounts_min_DESC',
  StakingAmountsMinDescNullsFirst = 'stakingAmounts_min_DESC_NULLS_FIRST',
  StakingAmountsMinDescNullsLast = 'stakingAmounts_min_DESC_NULLS_LAST',
  StartBlockAsc = 'startBlock_ASC',
  StartBlockAscNullsFirst = 'startBlock_ASC_NULLS_FIRST',
  StartBlockAscNullsLast = 'startBlock_ASC_NULLS_LAST',
  StartBlockDesc = 'startBlock_DESC',
  StartBlockDescNullsFirst = 'startBlock_DESC_NULLS_FIRST',
  StartBlockDescNullsLast = 'startBlock_DESC_NULLS_LAST',
}

export type SolutionGroupOperatorsConfigWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupOperatorsConfigWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupOperatorsConfigWhereInput>>;
  allowedOperators_eq?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_gt?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_gte?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowedOperators_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  allowedOperators_lt?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_lte?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_not_eq?: InputMaybe<Scalars['Int']['input']>;
  allowedOperators_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasOperatorsAllowlist_eq?: InputMaybe<Scalars['Boolean']['input']>;
  hasOperatorsAllowlist_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  hasOperatorsAllowlist_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  maxOperatorWorkers_eq?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_gt?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_gte?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxOperatorWorkers_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  maxOperatorWorkers_lt?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_lte?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_not_eq?: InputMaybe<Scalars['Int']['input']>;
  maxOperatorWorkers_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  stakingAmounts?: InputMaybe<SolutionGroupStakingAmountsWhereInput>;
  stakingAmounts_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  startBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  startBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  startBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  startBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  startBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  startBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  startBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  startBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  startBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SolutionGroupOperatorsConfigsConnection = {
  __typename?: 'SolutionGroupOperatorsConfigsConnection';
  edges: Array<SolutionGroupOperatorsConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SolutionGroupOrderByInput {
  AssuranceSlashingConfigDisputeAuthorityAsc = 'assuranceSlashingConfig_disputeAuthority_ASC',
  AssuranceSlashingConfigDisputeAuthorityAscNullsFirst = 'assuranceSlashingConfig_disputeAuthority_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeAuthorityAscNullsLast = 'assuranceSlashingConfig_disputeAuthority_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputeAuthorityDesc = 'assuranceSlashingConfig_disputeAuthority_DESC',
  AssuranceSlashingConfigDisputeAuthorityDescNullsFirst = 'assuranceSlashingConfig_disputeAuthority_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeAuthorityDescNullsLast = 'assuranceSlashingConfig_disputeAuthority_DESC_NULLS_LAST',
  AssuranceSlashingConfigDisputeExpiryAsc = 'assuranceSlashingConfig_disputeExpiry_ASC',
  AssuranceSlashingConfigDisputeExpiryAscNullsFirst = 'assuranceSlashingConfig_disputeExpiry_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeExpiryAscNullsLast = 'assuranceSlashingConfig_disputeExpiry_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputeExpiryDesc = 'assuranceSlashingConfig_disputeExpiry_DESC',
  AssuranceSlashingConfigDisputeExpiryDescNullsFirst = 'assuranceSlashingConfig_disputeExpiry_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeExpiryDescNullsLast = 'assuranceSlashingConfig_disputeExpiry_DESC_NULLS_LAST',
  AssuranceSlashingConfigDisputeInitiationReserveAsc = 'assuranceSlashingConfig_disputeInitiationReserve_ASC',
  AssuranceSlashingConfigDisputeInitiationReserveAscNullsFirst = 'assuranceSlashingConfig_disputeInitiationReserve_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeInitiationReserveAscNullsLast = 'assuranceSlashingConfig_disputeInitiationReserve_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputeInitiationReserveDesc = 'assuranceSlashingConfig_disputeInitiationReserve_DESC',
  AssuranceSlashingConfigDisputeInitiationReserveDescNullsFirst = 'assuranceSlashingConfig_disputeInitiationReserve_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeInitiationReserveDescNullsLast = 'assuranceSlashingConfig_disputeInitiationReserve_DESC_NULLS_LAST',
  AssuranceSlashingConfigDisputeInitiationAsc = 'assuranceSlashingConfig_disputeInitiation_ASC',
  AssuranceSlashingConfigDisputeInitiationAscNullsFirst = 'assuranceSlashingConfig_disputeInitiation_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeInitiationAscNullsLast = 'assuranceSlashingConfig_disputeInitiation_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputeInitiationDesc = 'assuranceSlashingConfig_disputeInitiation_DESC',
  AssuranceSlashingConfigDisputeInitiationDescNullsFirst = 'assuranceSlashingConfig_disputeInitiation_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeInitiationDescNullsLast = 'assuranceSlashingConfig_disputeInitiation_DESC_NULLS_LAST',
  AssuranceSlashingConfigDisputePeriodAsc = 'assuranceSlashingConfig_disputePeriod_ASC',
  AssuranceSlashingConfigDisputePeriodAscNullsFirst = 'assuranceSlashingConfig_disputePeriod_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputePeriodAscNullsLast = 'assuranceSlashingConfig_disputePeriod_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputePeriodDesc = 'assuranceSlashingConfig_disputePeriod_DESC',
  AssuranceSlashingConfigDisputePeriodDescNullsFirst = 'assuranceSlashingConfig_disputePeriod_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputePeriodDescNullsLast = 'assuranceSlashingConfig_disputePeriod_DESC_NULLS_LAST',
  AssuranceSlashingConfigDisputeTreasuryAsc = 'assuranceSlashingConfig_disputeTreasury_ASC',
  AssuranceSlashingConfigDisputeTreasuryAscNullsFirst = 'assuranceSlashingConfig_disputeTreasury_ASC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeTreasuryAscNullsLast = 'assuranceSlashingConfig_disputeTreasury_ASC_NULLS_LAST',
  AssuranceSlashingConfigDisputeTreasuryDesc = 'assuranceSlashingConfig_disputeTreasury_DESC',
  AssuranceSlashingConfigDisputeTreasuryDescNullsFirst = 'assuranceSlashingConfig_disputeTreasury_DESC_NULLS_FIRST',
  AssuranceSlashingConfigDisputeTreasuryDescNullsLast = 'assuranceSlashingConfig_disputeTreasury_DESC_NULLS_LAST',
  AssuranceSlashingConfigIdAsc = 'assuranceSlashingConfig_id_ASC',
  AssuranceSlashingConfigIdAscNullsFirst = 'assuranceSlashingConfig_id_ASC_NULLS_FIRST',
  AssuranceSlashingConfigIdAscNullsLast = 'assuranceSlashingConfig_id_ASC_NULLS_LAST',
  AssuranceSlashingConfigIdDesc = 'assuranceSlashingConfig_id_DESC',
  AssuranceSlashingConfigIdDescNullsFirst = 'assuranceSlashingConfig_id_DESC_NULLS_FIRST',
  AssuranceSlashingConfigIdDescNullsLast = 'assuranceSlashingConfig_id_DESC_NULLS_LAST',
  AssuranceSlashingConfigSlashingCriteriaMajorityAsc = 'assuranceSlashingConfig_slashingCriteriaMajority_ASC',
  AssuranceSlashingConfigSlashingCriteriaMajorityAscNullsFirst = 'assuranceSlashingConfig_slashingCriteriaMajority_ASC_NULLS_FIRST',
  AssuranceSlashingConfigSlashingCriteriaMajorityAscNullsLast = 'assuranceSlashingConfig_slashingCriteriaMajority_ASC_NULLS_LAST',
  AssuranceSlashingConfigSlashingCriteriaMajorityDesc = 'assuranceSlashingConfig_slashingCriteriaMajority_DESC',
  AssuranceSlashingConfigSlashingCriteriaMajorityDescNullsFirst = 'assuranceSlashingConfig_slashingCriteriaMajority_DESC_NULLS_FIRST',
  AssuranceSlashingConfigSlashingCriteriaMajorityDescNullsLast = 'assuranceSlashingConfig_slashingCriteriaMajority_DESC_NULLS_LAST',
  AssuranceSlashingConfigSlashingCriteriaMinorityAsc = 'assuranceSlashingConfig_slashingCriteriaMinority_ASC',
  AssuranceSlashingConfigSlashingCriteriaMinorityAscNullsFirst = 'assuranceSlashingConfig_slashingCriteriaMinority_ASC_NULLS_FIRST',
  AssuranceSlashingConfigSlashingCriteriaMinorityAscNullsLast = 'assuranceSlashingConfig_slashingCriteriaMinority_ASC_NULLS_LAST',
  AssuranceSlashingConfigSlashingCriteriaMinorityDesc = 'assuranceSlashingConfig_slashingCriteriaMinority_DESC',
  AssuranceSlashingConfigSlashingCriteriaMinorityDescNullsFirst = 'assuranceSlashingConfig_slashingCriteriaMinority_DESC_NULLS_FIRST',
  AssuranceSlashingConfigSlashingCriteriaMinorityDescNullsLast = 'assuranceSlashingConfig_slashingCriteriaMinority_DESC_NULLS_LAST',
  HasCidAllowListAsc = 'hasCidAllowList_ASC',
  HasCidAllowListAscNullsFirst = 'hasCidAllowList_ASC_NULLS_FIRST',
  HasCidAllowListAscNullsLast = 'hasCidAllowList_ASC_NULLS_LAST',
  HasCidAllowListDesc = 'hasCidAllowList_DESC',
  HasCidAllowListDescNullsFirst = 'hasCidAllowList_DESC_NULLS_FIRST',
  HasCidAllowListDescNullsLast = 'hasCidAllowList_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  InfoDescriptionAsc = 'info_description_ASC',
  InfoDescriptionAscNullsFirst = 'info_description_ASC_NULLS_FIRST',
  InfoDescriptionAscNullsLast = 'info_description_ASC_NULLS_LAST',
  InfoDescriptionDesc = 'info_description_DESC',
  InfoDescriptionDescNullsFirst = 'info_description_DESC_NULLS_FIRST',
  InfoDescriptionDescNullsLast = 'info_description_DESC_NULLS_LAST',
  InfoIdAsc = 'info_id_ASC',
  InfoIdAscNullsFirst = 'info_id_ASC_NULLS_FIRST',
  InfoIdAscNullsLast = 'info_id_ASC_NULLS_LAST',
  InfoIdDesc = 'info_id_DESC',
  InfoIdDescNullsFirst = 'info_id_DESC_NULLS_FIRST',
  InfoIdDescNullsLast = 'info_id_DESC_NULLS_LAST',
  InfoLogoUrlAsc = 'info_logoUrl_ASC',
  InfoLogoUrlAscNullsFirst = 'info_logoUrl_ASC_NULLS_FIRST',
  InfoLogoUrlAscNullsLast = 'info_logoUrl_ASC_NULLS_LAST',
  InfoLogoUrlDesc = 'info_logoUrl_DESC',
  InfoLogoUrlDescNullsFirst = 'info_logoUrl_DESC_NULLS_FIRST',
  InfoLogoUrlDescNullsLast = 'info_logoUrl_DESC_NULLS_LAST',
  InfoNameAsc = 'info_name_ASC',
  InfoNameAscNullsFirst = 'info_name_ASC_NULLS_FIRST',
  InfoNameAscNullsLast = 'info_name_ASC_NULLS_LAST',
  InfoNameDesc = 'info_name_DESC',
  InfoNameDescNullsFirst = 'info_name_DESC_NULLS_FIRST',
  InfoNameDescNullsLast = 'info_name_DESC_NULLS_LAST',
  InfoPublisherInfoAsc = 'info_publisherInfo_ASC',
  InfoPublisherInfoAscNullsFirst = 'info_publisherInfo_ASC_NULLS_FIRST',
  InfoPublisherInfoAscNullsLast = 'info_publisherInfo_ASC_NULLS_LAST',
  InfoPublisherInfoDesc = 'info_publisherInfo_DESC',
  InfoPublisherInfoDescNullsFirst = 'info_publisherInfo_DESC_NULLS_FIRST',
  InfoPublisherInfoDescNullsLast = 'info_publisherInfo_DESC_NULLS_LAST',
  NamespaceAsc = 'namespace_ASC',
  NamespaceAscNullsFirst = 'namespace_ASC_NULLS_FIRST',
  NamespaceAscNullsLast = 'namespace_ASC_NULLS_LAST',
  NamespaceDesc = 'namespace_DESC',
  NamespaceDescNullsFirst = 'namespace_DESC_NULLS_FIRST',
  NamespaceDescNullsLast = 'namespace_DESC_NULLS_LAST',
  OperationEndBlockAsc = 'operationEndBlock_ASC',
  OperationEndBlockAscNullsFirst = 'operationEndBlock_ASC_NULLS_FIRST',
  OperationEndBlockAscNullsLast = 'operationEndBlock_ASC_NULLS_LAST',
  OperationEndBlockDesc = 'operationEndBlock_DESC',
  OperationEndBlockDescNullsFirst = 'operationEndBlock_DESC_NULLS_FIRST',
  OperationEndBlockDescNullsLast = 'operationEndBlock_DESC_NULLS_LAST',
  OperationStartBlockAsc = 'operationStartBlock_ASC',
  OperationStartBlockAscNullsFirst = 'operationStartBlock_ASC_NULLS_FIRST',
  OperationStartBlockAscNullsLast = 'operationStartBlock_ASC_NULLS_LAST',
  OperationStartBlockDesc = 'operationStartBlock_DESC',
  OperationStartBlockDescNullsFirst = 'operationStartBlock_DESC_NULLS_FIRST',
  OperationStartBlockDescNullsLast = 'operationStartBlock_DESC_NULLS_LAST',
  OperatorsConfigAllowedOperatorsAsc = 'operatorsConfig_allowedOperators_ASC',
  OperatorsConfigAllowedOperatorsAscNullsFirst = 'operatorsConfig_allowedOperators_ASC_NULLS_FIRST',
  OperatorsConfigAllowedOperatorsAscNullsLast = 'operatorsConfig_allowedOperators_ASC_NULLS_LAST',
  OperatorsConfigAllowedOperatorsDesc = 'operatorsConfig_allowedOperators_DESC',
  OperatorsConfigAllowedOperatorsDescNullsFirst = 'operatorsConfig_allowedOperators_DESC_NULLS_FIRST',
  OperatorsConfigAllowedOperatorsDescNullsLast = 'operatorsConfig_allowedOperators_DESC_NULLS_LAST',
  OperatorsConfigHasOperatorsAllowlistAsc = 'operatorsConfig_hasOperatorsAllowlist_ASC',
  OperatorsConfigHasOperatorsAllowlistAscNullsFirst = 'operatorsConfig_hasOperatorsAllowlist_ASC_NULLS_FIRST',
  OperatorsConfigHasOperatorsAllowlistAscNullsLast = 'operatorsConfig_hasOperatorsAllowlist_ASC_NULLS_LAST',
  OperatorsConfigHasOperatorsAllowlistDesc = 'operatorsConfig_hasOperatorsAllowlist_DESC',
  OperatorsConfigHasOperatorsAllowlistDescNullsFirst = 'operatorsConfig_hasOperatorsAllowlist_DESC_NULLS_FIRST',
  OperatorsConfigHasOperatorsAllowlistDescNullsLast = 'operatorsConfig_hasOperatorsAllowlist_DESC_NULLS_LAST',
  OperatorsConfigIdAsc = 'operatorsConfig_id_ASC',
  OperatorsConfigIdAscNullsFirst = 'operatorsConfig_id_ASC_NULLS_FIRST',
  OperatorsConfigIdAscNullsLast = 'operatorsConfig_id_ASC_NULLS_LAST',
  OperatorsConfigIdDesc = 'operatorsConfig_id_DESC',
  OperatorsConfigIdDescNullsFirst = 'operatorsConfig_id_DESC_NULLS_FIRST',
  OperatorsConfigIdDescNullsLast = 'operatorsConfig_id_DESC_NULLS_LAST',
  OperatorsConfigMaxOperatorWorkersAsc = 'operatorsConfig_maxOperatorWorkers_ASC',
  OperatorsConfigMaxOperatorWorkersAscNullsFirst = 'operatorsConfig_maxOperatorWorkers_ASC_NULLS_FIRST',
  OperatorsConfigMaxOperatorWorkersAscNullsLast = 'operatorsConfig_maxOperatorWorkers_ASC_NULLS_LAST',
  OperatorsConfigMaxOperatorWorkersDesc = 'operatorsConfig_maxOperatorWorkers_DESC',
  OperatorsConfigMaxOperatorWorkersDescNullsFirst = 'operatorsConfig_maxOperatorWorkers_DESC_NULLS_FIRST',
  OperatorsConfigMaxOperatorWorkersDescNullsLast = 'operatorsConfig_maxOperatorWorkers_DESC_NULLS_LAST',
  OperatorsConfigStartBlockAsc = 'operatorsConfig_startBlock_ASC',
  OperatorsConfigStartBlockAscNullsFirst = 'operatorsConfig_startBlock_ASC_NULLS_FIRST',
  OperatorsConfigStartBlockAscNullsLast = 'operatorsConfig_startBlock_ASC_NULLS_LAST',
  OperatorsConfigStartBlockDesc = 'operatorsConfig_startBlock_DESC',
  OperatorsConfigStartBlockDescNullsFirst = 'operatorsConfig_startBlock_DESC_NULLS_FIRST',
  OperatorsConfigStartBlockDescNullsLast = 'operatorsConfig_startBlock_DESC_NULLS_LAST',
  PerformanceSlashingConfigIdAsc = 'performanceSlashingConfig_id_ASC',
  PerformanceSlashingConfigIdAscNullsFirst = 'performanceSlashingConfig_id_ASC_NULLS_FIRST',
  PerformanceSlashingConfigIdAscNullsLast = 'performanceSlashingConfig_id_ASC_NULLS_LAST',
  PerformanceSlashingConfigIdDesc = 'performanceSlashingConfig_id_DESC',
  PerformanceSlashingConfigIdDescNullsFirst = 'performanceSlashingConfig_id_DESC_NULLS_FIRST',
  PerformanceSlashingConfigIdDescNullsLast = 'performanceSlashingConfig_id_DESC_NULLS_LAST',
  PerformanceSlashingConfigPerformanceSlashingCriteriaAsc = 'performanceSlashingConfig_performanceSlashingCriteria_ASC',
  PerformanceSlashingConfigPerformanceSlashingCriteriaAscNullsFirst = 'performanceSlashingConfig_performanceSlashingCriteria_ASC_NULLS_FIRST',
  PerformanceSlashingConfigPerformanceSlashingCriteriaAscNullsLast = 'performanceSlashingConfig_performanceSlashingCriteria_ASC_NULLS_LAST',
  PerformanceSlashingConfigPerformanceSlashingCriteriaDesc = 'performanceSlashingConfig_performanceSlashingCriteria_DESC',
  PerformanceSlashingConfigPerformanceSlashingCriteriaDescNullsFirst = 'performanceSlashingConfig_performanceSlashingCriteria_DESC_NULLS_FIRST',
  PerformanceSlashingConfigPerformanceSlashingCriteriaDescNullsLast = 'performanceSlashingConfig_performanceSlashingCriteria_DESC_NULLS_LAST',
  RegistrarFriendlyNameAsc = 'registrar_friendlyName_ASC',
  RegistrarFriendlyNameAscNullsFirst = 'registrar_friendlyName_ASC_NULLS_FIRST',
  RegistrarFriendlyNameAscNullsLast = 'registrar_friendlyName_ASC_NULLS_LAST',
  RegistrarFriendlyNameDesc = 'registrar_friendlyName_DESC',
  RegistrarFriendlyNameDescNullsFirst = 'registrar_friendlyName_DESC_NULLS_FIRST',
  RegistrarFriendlyNameDescNullsLast = 'registrar_friendlyName_DESC_NULLS_LAST',
  RegistrarIdAsc = 'registrar_id_ASC',
  RegistrarIdAscNullsFirst = 'registrar_id_ASC_NULLS_FIRST',
  RegistrarIdAscNullsLast = 'registrar_id_ASC_NULLS_LAST',
  RegistrarIdDesc = 'registrar_id_DESC',
  RegistrarIdDescNullsFirst = 'registrar_id_DESC_NULLS_FIRST',
  RegistrarIdDescNullsLast = 'registrar_id_DESC_NULLS_LAST',
  RegistrarIsAllowedAsc = 'registrar_isAllowed_ASC',
  RegistrarIsAllowedAscNullsFirst = 'registrar_isAllowed_ASC_NULLS_FIRST',
  RegistrarIsAllowedAscNullsLast = 'registrar_isAllowed_ASC_NULLS_LAST',
  RegistrarIsAllowedDesc = 'registrar_isAllowed_DESC',
  RegistrarIsAllowedDescNullsFirst = 'registrar_isAllowed_DESC_NULLS_FIRST',
  RegistrarIsAllowedDescNullsLast = 'registrar_isAllowed_DESC_NULLS_LAST',
  RegistrarLegalLocationAsc = 'registrar_legalLocation_ASC',
  RegistrarLegalLocationAscNullsFirst = 'registrar_legalLocation_ASC_NULLS_FIRST',
  RegistrarLegalLocationAscNullsLast = 'registrar_legalLocation_ASC_NULLS_LAST',
  RegistrarLegalLocationDesc = 'registrar_legalLocation_DESC',
  RegistrarLegalLocationDescNullsFirst = 'registrar_legalLocation_DESC_NULLS_FIRST',
  RegistrarLegalLocationDescNullsLast = 'registrar_legalLocation_DESC_NULLS_LAST',
  RewardsConfigIdAsc = 'rewardsConfig_id_ASC',
  RewardsConfigIdAscNullsFirst = 'rewardsConfig_id_ASC_NULLS_FIRST',
  RewardsConfigIdAscNullsLast = 'rewardsConfig_id_ASC_NULLS_LAST',
  RewardsConfigIdDesc = 'rewardsConfig_id_DESC',
  RewardsConfigIdDescNullsFirst = 'rewardsConfig_id_DESC_NULLS_FIRST',
  RewardsConfigIdDescNullsLast = 'rewardsConfig_id_DESC_NULLS_LAST',
  RewardsConfigIsNativeAsc = 'rewardsConfig_isNative_ASC',
  RewardsConfigIsNativeAscNullsFirst = 'rewardsConfig_isNative_ASC_NULLS_FIRST',
  RewardsConfigIsNativeAscNullsLast = 'rewardsConfig_isNative_ASC_NULLS_LAST',
  RewardsConfigIsNativeDesc = 'rewardsConfig_isNative_DESC',
  RewardsConfigIsNativeDescNullsFirst = 'rewardsConfig_isNative_DESC_NULLS_FIRST',
  RewardsConfigIsNativeDescNullsLast = 'rewardsConfig_isNative_DESC_NULLS_LAST',
  RewardsConfigSubscriptionRewardPerBlockAsc = 'rewardsConfig_subscriptionRewardPerBlock_ASC',
  RewardsConfigSubscriptionRewardPerBlockAscNullsFirst = 'rewardsConfig_subscriptionRewardPerBlock_ASC_NULLS_FIRST',
  RewardsConfigSubscriptionRewardPerBlockAscNullsLast = 'rewardsConfig_subscriptionRewardPerBlock_ASC_NULLS_LAST',
  RewardsConfigSubscriptionRewardPerBlockDesc = 'rewardsConfig_subscriptionRewardPerBlock_DESC',
  RewardsConfigSubscriptionRewardPerBlockDescNullsFirst = 'rewardsConfig_subscriptionRewardPerBlock_DESC_NULLS_FIRST',
  RewardsConfigSubscriptionRewardPerBlockDescNullsLast = 'rewardsConfig_subscriptionRewardPerBlock_DESC_NULLS_LAST',
  RewardsConfigTopPerformanceBonusAsc = 'rewardsConfig_topPerformanceBonus_ASC',
  RewardsConfigTopPerformanceBonusAscNullsFirst = 'rewardsConfig_topPerformanceBonus_ASC_NULLS_FIRST',
  RewardsConfigTopPerformanceBonusAscNullsLast = 'rewardsConfig_topPerformanceBonus_ASC_NULLS_LAST',
  RewardsConfigTopPerformanceBonusDesc = 'rewardsConfig_topPerformanceBonus_DESC',
  RewardsConfigTopPerformanceBonusDescNullsFirst = 'rewardsConfig_topPerformanceBonus_DESC_NULLS_FIRST',
  RewardsConfigTopPerformanceBonusDescNullsLast = 'rewardsConfig_topPerformanceBonus_DESC_NULLS_LAST',
  RewardsConfigVotingRewardPerBlockAsc = 'rewardsConfig_votingRewardPerBlock_ASC',
  RewardsConfigVotingRewardPerBlockAscNullsFirst = 'rewardsConfig_votingRewardPerBlock_ASC_NULLS_FIRST',
  RewardsConfigVotingRewardPerBlockAscNullsLast = 'rewardsConfig_votingRewardPerBlock_ASC_NULLS_LAST',
  RewardsConfigVotingRewardPerBlockDesc = 'rewardsConfig_votingRewardPerBlock_DESC',
  RewardsConfigVotingRewardPerBlockDescNullsFirst = 'rewardsConfig_votingRewardPerBlock_DESC_NULLS_FIRST',
  RewardsConfigVotingRewardPerBlockDescNullsLast = 'rewardsConfig_votingRewardPerBlock_DESC_NULLS_LAST',
  SlaVotingThresholdAsc = 'slaVotingThreshold_ASC',
  SlaVotingThresholdAscNullsFirst = 'slaVotingThreshold_ASC_NULLS_FIRST',
  SlaVotingThresholdAscNullsLast = 'slaVotingThreshold_ASC_NULLS_LAST',
  SlaVotingThresholdDesc = 'slaVotingThreshold_DESC',
  SlaVotingThresholdDescNullsFirst = 'slaVotingThreshold_DESC_NULLS_FIRST',
  SlaVotingThresholdDescNullsLast = 'slaVotingThreshold_DESC_NULLS_LAST',
  StakingAmountsIdAsc = 'stakingAmounts_id_ASC',
  StakingAmountsIdAscNullsFirst = 'stakingAmounts_id_ASC_NULLS_FIRST',
  StakingAmountsIdAscNullsLast = 'stakingAmounts_id_ASC_NULLS_LAST',
  StakingAmountsIdDesc = 'stakingAmounts_id_DESC',
  StakingAmountsIdDescNullsFirst = 'stakingAmounts_id_DESC_NULLS_FIRST',
  StakingAmountsIdDescNullsLast = 'stakingAmounts_id_DESC_NULLS_LAST',
  StakingAmountsMaxAsc = 'stakingAmounts_max_ASC',
  StakingAmountsMaxAscNullsFirst = 'stakingAmounts_max_ASC_NULLS_FIRST',
  StakingAmountsMaxAscNullsLast = 'stakingAmounts_max_ASC_NULLS_LAST',
  StakingAmountsMaxDesc = 'stakingAmounts_max_DESC',
  StakingAmountsMaxDescNullsFirst = 'stakingAmounts_max_DESC_NULLS_FIRST',
  StakingAmountsMaxDescNullsLast = 'stakingAmounts_max_DESC_NULLS_LAST',
  StakingAmountsMinAsc = 'stakingAmounts_min_ASC',
  StakingAmountsMinAscNullsFirst = 'stakingAmounts_min_ASC_NULLS_FIRST',
  StakingAmountsMinAscNullsLast = 'stakingAmounts_min_ASC_NULLS_LAST',
  StakingAmountsMinDesc = 'stakingAmounts_min_DESC',
  StakingAmountsMinDescNullsFirst = 'stakingAmounts_min_DESC_NULLS_FIRST',
  StakingAmountsMinDescNullsLast = 'stakingAmounts_min_DESC_NULLS_LAST',
  WithdrawalDelayAsc = 'withdrawalDelay_ASC',
  WithdrawalDelayAscNullsFirst = 'withdrawalDelay_ASC_NULLS_FIRST',
  WithdrawalDelayAscNullsLast = 'withdrawalDelay_ASC_NULLS_LAST',
  WithdrawalDelayDesc = 'withdrawalDelay_DESC',
  WithdrawalDelayDescNullsFirst = 'withdrawalDelay_DESC_NULLS_FIRST',
  WithdrawalDelayDescNullsLast = 'withdrawalDelay_DESC_NULLS_LAST',
}

export type SolutionGroupPerformanceSlashingConfig = {
  __typename?: 'SolutionGroupPerformanceSlashingConfig';
  id: Scalars['String']['output'];
  performanceSlashingCriteria: Scalars['Int']['output'];
  solutionGroup: SolutionGroup;
};

export type SolutionGroupPerformanceSlashingConfigEdge = {
  __typename?: 'SolutionGroupPerformanceSlashingConfigEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupPerformanceSlashingConfig;
};

export enum SolutionGroupPerformanceSlashingConfigOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  PerformanceSlashingCriteriaAsc = 'performanceSlashingCriteria_ASC',
  PerformanceSlashingCriteriaAscNullsFirst = 'performanceSlashingCriteria_ASC_NULLS_FIRST',
  PerformanceSlashingCriteriaAscNullsLast = 'performanceSlashingCriteria_ASC_NULLS_LAST',
  PerformanceSlashingCriteriaDesc = 'performanceSlashingCriteria_DESC',
  PerformanceSlashingCriteriaDescNullsFirst = 'performanceSlashingCriteria_DESC_NULLS_FIRST',
  PerformanceSlashingCriteriaDescNullsLast = 'performanceSlashingCriteria_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
}

export type SolutionGroupPerformanceSlashingConfigWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupPerformanceSlashingConfigWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupPerformanceSlashingConfigWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  performanceSlashingCriteria_eq?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_gt?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_gte?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  performanceSlashingCriteria_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  performanceSlashingCriteria_lt?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_lte?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_not_eq?: InputMaybe<Scalars['Int']['input']>;
  performanceSlashingCriteria_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionGroupPerformanceSlashingConfigsConnection = {
  __typename?: 'SolutionGroupPerformanceSlashingConfigsConnection';
  edges: Array<SolutionGroupPerformanceSlashingConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupRewardsConfig = {
  __typename?: 'SolutionGroupRewardsConfig';
  assetDetails?: Maybe<AssetDetails>;
  assetMetadata?: Maybe<AssetMetadata>;
  id: Scalars['String']['output'];
  isNative?: Maybe<Scalars['Boolean']['output']>;
  subscriptionRewardPerBlock: Scalars['BigInt']['output'];
  topPerformanceBonus: Scalars['BigInt']['output'];
  votingRewardPerBlock: Scalars['BigInt']['output'];
};

export type SolutionGroupRewardsConfigEdge = {
  __typename?: 'SolutionGroupRewardsConfigEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupRewardsConfig;
};

export enum SolutionGroupRewardsConfigOrderByInput {
  AssetDetailsAccountsAsc = 'assetDetails_accounts_ASC',
  AssetDetailsAccountsAscNullsFirst = 'assetDetails_accounts_ASC_NULLS_FIRST',
  AssetDetailsAccountsAscNullsLast = 'assetDetails_accounts_ASC_NULLS_LAST',
  AssetDetailsAccountsDesc = 'assetDetails_accounts_DESC',
  AssetDetailsAccountsDescNullsFirst = 'assetDetails_accounts_DESC_NULLS_FIRST',
  AssetDetailsAccountsDescNullsLast = 'assetDetails_accounts_DESC_NULLS_LAST',
  AssetDetailsApprovalsAsc = 'assetDetails_approvals_ASC',
  AssetDetailsApprovalsAscNullsFirst = 'assetDetails_approvals_ASC_NULLS_FIRST',
  AssetDetailsApprovalsAscNullsLast = 'assetDetails_approvals_ASC_NULLS_LAST',
  AssetDetailsApprovalsDesc = 'assetDetails_approvals_DESC',
  AssetDetailsApprovalsDescNullsFirst = 'assetDetails_approvals_DESC_NULLS_FIRST',
  AssetDetailsApprovalsDescNullsLast = 'assetDetails_approvals_DESC_NULLS_LAST',
  AssetDetailsDepositAsc = 'assetDetails_deposit_ASC',
  AssetDetailsDepositAscNullsFirst = 'assetDetails_deposit_ASC_NULLS_FIRST',
  AssetDetailsDepositAscNullsLast = 'assetDetails_deposit_ASC_NULLS_LAST',
  AssetDetailsDepositDesc = 'assetDetails_deposit_DESC',
  AssetDetailsDepositDescNullsFirst = 'assetDetails_deposit_DESC_NULLS_FIRST',
  AssetDetailsDepositDescNullsLast = 'assetDetails_deposit_DESC_NULLS_LAST',
  AssetDetailsIdAsc = 'assetDetails_id_ASC',
  AssetDetailsIdAscNullsFirst = 'assetDetails_id_ASC_NULLS_FIRST',
  AssetDetailsIdAscNullsLast = 'assetDetails_id_ASC_NULLS_LAST',
  AssetDetailsIdDesc = 'assetDetails_id_DESC',
  AssetDetailsIdDescNullsFirst = 'assetDetails_id_DESC_NULLS_FIRST',
  AssetDetailsIdDescNullsLast = 'assetDetails_id_DESC_NULLS_LAST',
  AssetDetailsIsSufficientAsc = 'assetDetails_isSufficient_ASC',
  AssetDetailsIsSufficientAscNullsFirst = 'assetDetails_isSufficient_ASC_NULLS_FIRST',
  AssetDetailsIsSufficientAscNullsLast = 'assetDetails_isSufficient_ASC_NULLS_LAST',
  AssetDetailsIsSufficientDesc = 'assetDetails_isSufficient_DESC',
  AssetDetailsIsSufficientDescNullsFirst = 'assetDetails_isSufficient_DESC_NULLS_FIRST',
  AssetDetailsIsSufficientDescNullsLast = 'assetDetails_isSufficient_DESC_NULLS_LAST',
  AssetDetailsMinBalanceAsc = 'assetDetails_minBalance_ASC',
  AssetDetailsMinBalanceAscNullsFirst = 'assetDetails_minBalance_ASC_NULLS_FIRST',
  AssetDetailsMinBalanceAscNullsLast = 'assetDetails_minBalance_ASC_NULLS_LAST',
  AssetDetailsMinBalanceDesc = 'assetDetails_minBalance_DESC',
  AssetDetailsMinBalanceDescNullsFirst = 'assetDetails_minBalance_DESC_NULLS_FIRST',
  AssetDetailsMinBalanceDescNullsLast = 'assetDetails_minBalance_DESC_NULLS_LAST',
  AssetDetailsStatusAsc = 'assetDetails_status_ASC',
  AssetDetailsStatusAscNullsFirst = 'assetDetails_status_ASC_NULLS_FIRST',
  AssetDetailsStatusAscNullsLast = 'assetDetails_status_ASC_NULLS_LAST',
  AssetDetailsStatusDesc = 'assetDetails_status_DESC',
  AssetDetailsStatusDescNullsFirst = 'assetDetails_status_DESC_NULLS_FIRST',
  AssetDetailsStatusDescNullsLast = 'assetDetails_status_DESC_NULLS_LAST',
  AssetDetailsSufficientsAsc = 'assetDetails_sufficients_ASC',
  AssetDetailsSufficientsAscNullsFirst = 'assetDetails_sufficients_ASC_NULLS_FIRST',
  AssetDetailsSufficientsAscNullsLast = 'assetDetails_sufficients_ASC_NULLS_LAST',
  AssetDetailsSufficientsDesc = 'assetDetails_sufficients_DESC',
  AssetDetailsSufficientsDescNullsFirst = 'assetDetails_sufficients_DESC_NULLS_FIRST',
  AssetDetailsSufficientsDescNullsLast = 'assetDetails_sufficients_DESC_NULLS_LAST',
  AssetDetailsSupplyAsc = 'assetDetails_supply_ASC',
  AssetDetailsSupplyAscNullsFirst = 'assetDetails_supply_ASC_NULLS_FIRST',
  AssetDetailsSupplyAscNullsLast = 'assetDetails_supply_ASC_NULLS_LAST',
  AssetDetailsSupplyDesc = 'assetDetails_supply_DESC',
  AssetDetailsSupplyDescNullsFirst = 'assetDetails_supply_DESC_NULLS_FIRST',
  AssetDetailsSupplyDescNullsLast = 'assetDetails_supply_DESC_NULLS_LAST',
  AssetDetailsV3MultiLocationAsc = 'assetDetails_v3MultiLocation_ASC',
  AssetDetailsV3MultiLocationAscNullsFirst = 'assetDetails_v3MultiLocation_ASC_NULLS_FIRST',
  AssetDetailsV3MultiLocationAscNullsLast = 'assetDetails_v3MultiLocation_ASC_NULLS_LAST',
  AssetDetailsV3MultiLocationDesc = 'assetDetails_v3MultiLocation_DESC',
  AssetDetailsV3MultiLocationDescNullsFirst = 'assetDetails_v3MultiLocation_DESC_NULLS_FIRST',
  AssetDetailsV3MultiLocationDescNullsLast = 'assetDetails_v3MultiLocation_DESC_NULLS_LAST',
  AssetMetadataDecimalsAsc = 'assetMetadata_decimals_ASC',
  AssetMetadataDecimalsAscNullsFirst = 'assetMetadata_decimals_ASC_NULLS_FIRST',
  AssetMetadataDecimalsAscNullsLast = 'assetMetadata_decimals_ASC_NULLS_LAST',
  AssetMetadataDecimalsDesc = 'assetMetadata_decimals_DESC',
  AssetMetadataDecimalsDescNullsFirst = 'assetMetadata_decimals_DESC_NULLS_FIRST',
  AssetMetadataDecimalsDescNullsLast = 'assetMetadata_decimals_DESC_NULLS_LAST',
  AssetMetadataDepositAsc = 'assetMetadata_deposit_ASC',
  AssetMetadataDepositAscNullsFirst = 'assetMetadata_deposit_ASC_NULLS_FIRST',
  AssetMetadataDepositAscNullsLast = 'assetMetadata_deposit_ASC_NULLS_LAST',
  AssetMetadataDepositDesc = 'assetMetadata_deposit_DESC',
  AssetMetadataDepositDescNullsFirst = 'assetMetadata_deposit_DESC_NULLS_FIRST',
  AssetMetadataDepositDescNullsLast = 'assetMetadata_deposit_DESC_NULLS_LAST',
  AssetMetadataIdAsc = 'assetMetadata_id_ASC',
  AssetMetadataIdAscNullsFirst = 'assetMetadata_id_ASC_NULLS_FIRST',
  AssetMetadataIdAscNullsLast = 'assetMetadata_id_ASC_NULLS_LAST',
  AssetMetadataIdDesc = 'assetMetadata_id_DESC',
  AssetMetadataIdDescNullsFirst = 'assetMetadata_id_DESC_NULLS_FIRST',
  AssetMetadataIdDescNullsLast = 'assetMetadata_id_DESC_NULLS_LAST',
  AssetMetadataIsFrozenAsc = 'assetMetadata_isFrozen_ASC',
  AssetMetadataIsFrozenAscNullsFirst = 'assetMetadata_isFrozen_ASC_NULLS_FIRST',
  AssetMetadataIsFrozenAscNullsLast = 'assetMetadata_isFrozen_ASC_NULLS_LAST',
  AssetMetadataIsFrozenDesc = 'assetMetadata_isFrozen_DESC',
  AssetMetadataIsFrozenDescNullsFirst = 'assetMetadata_isFrozen_DESC_NULLS_FIRST',
  AssetMetadataIsFrozenDescNullsLast = 'assetMetadata_isFrozen_DESC_NULLS_LAST',
  AssetMetadataNameAsc = 'assetMetadata_name_ASC',
  AssetMetadataNameAscNullsFirst = 'assetMetadata_name_ASC_NULLS_FIRST',
  AssetMetadataNameAscNullsLast = 'assetMetadata_name_ASC_NULLS_LAST',
  AssetMetadataNameDesc = 'assetMetadata_name_DESC',
  AssetMetadataNameDescNullsFirst = 'assetMetadata_name_DESC_NULLS_FIRST',
  AssetMetadataNameDescNullsLast = 'assetMetadata_name_DESC_NULLS_LAST',
  AssetMetadataSymbolAsc = 'assetMetadata_symbol_ASC',
  AssetMetadataSymbolAscNullsFirst = 'assetMetadata_symbol_ASC_NULLS_FIRST',
  AssetMetadataSymbolAscNullsLast = 'assetMetadata_symbol_ASC_NULLS_LAST',
  AssetMetadataSymbolDesc = 'assetMetadata_symbol_DESC',
  AssetMetadataSymbolDescNullsFirst = 'assetMetadata_symbol_DESC_NULLS_FIRST',
  AssetMetadataSymbolDescNullsLast = 'assetMetadata_symbol_DESC_NULLS_LAST',
  AssetMetadataV3MultiLocationAsc = 'assetMetadata_v3MultiLocation_ASC',
  AssetMetadataV3MultiLocationAscNullsFirst = 'assetMetadata_v3MultiLocation_ASC_NULLS_FIRST',
  AssetMetadataV3MultiLocationAscNullsLast = 'assetMetadata_v3MultiLocation_ASC_NULLS_LAST',
  AssetMetadataV3MultiLocationDesc = 'assetMetadata_v3MultiLocation_DESC',
  AssetMetadataV3MultiLocationDescNullsFirst = 'assetMetadata_v3MultiLocation_DESC_NULLS_FIRST',
  AssetMetadataV3MultiLocationDescNullsLast = 'assetMetadata_v3MultiLocation_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IsNativeAsc = 'isNative_ASC',
  IsNativeAscNullsFirst = 'isNative_ASC_NULLS_FIRST',
  IsNativeAscNullsLast = 'isNative_ASC_NULLS_LAST',
  IsNativeDesc = 'isNative_DESC',
  IsNativeDescNullsFirst = 'isNative_DESC_NULLS_FIRST',
  IsNativeDescNullsLast = 'isNative_DESC_NULLS_LAST',
  SubscriptionRewardPerBlockAsc = 'subscriptionRewardPerBlock_ASC',
  SubscriptionRewardPerBlockAscNullsFirst = 'subscriptionRewardPerBlock_ASC_NULLS_FIRST',
  SubscriptionRewardPerBlockAscNullsLast = 'subscriptionRewardPerBlock_ASC_NULLS_LAST',
  SubscriptionRewardPerBlockDesc = 'subscriptionRewardPerBlock_DESC',
  SubscriptionRewardPerBlockDescNullsFirst = 'subscriptionRewardPerBlock_DESC_NULLS_FIRST',
  SubscriptionRewardPerBlockDescNullsLast = 'subscriptionRewardPerBlock_DESC_NULLS_LAST',
  TopPerformanceBonusAsc = 'topPerformanceBonus_ASC',
  TopPerformanceBonusAscNullsFirst = 'topPerformanceBonus_ASC_NULLS_FIRST',
  TopPerformanceBonusAscNullsLast = 'topPerformanceBonus_ASC_NULLS_LAST',
  TopPerformanceBonusDesc = 'topPerformanceBonus_DESC',
  TopPerformanceBonusDescNullsFirst = 'topPerformanceBonus_DESC_NULLS_FIRST',
  TopPerformanceBonusDescNullsLast = 'topPerformanceBonus_DESC_NULLS_LAST',
  VotingRewardPerBlockAsc = 'votingRewardPerBlock_ASC',
  VotingRewardPerBlockAscNullsFirst = 'votingRewardPerBlock_ASC_NULLS_FIRST',
  VotingRewardPerBlockAscNullsLast = 'votingRewardPerBlock_ASC_NULLS_LAST',
  VotingRewardPerBlockDesc = 'votingRewardPerBlock_DESC',
  VotingRewardPerBlockDescNullsFirst = 'votingRewardPerBlock_DESC_NULLS_FIRST',
  VotingRewardPerBlockDescNullsLast = 'votingRewardPerBlock_DESC_NULLS_LAST',
}

export type SolutionGroupRewardsConfigWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupRewardsConfigWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupRewardsConfigWhereInput>>;
  assetDetails?: InputMaybe<AssetDetailsWhereInput>;
  assetDetails_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  assetMetadata?: InputMaybe<AssetMetadataWhereInput>;
  assetMetadata_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  isNative_eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNative_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNative_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionRewardPerBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  subscriptionRewardPerBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionRewardPerBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  subscriptionRewardPerBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  topPerformanceBonus_eq?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_gt?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_gte?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  topPerformanceBonus_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  topPerformanceBonus_lt?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_lte?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  topPerformanceBonus_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  votingRewardPerBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  votingRewardPerBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRewardPerBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  votingRewardPerBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type SolutionGroupRewardsConfigsConnection = {
  __typename?: 'SolutionGroupRewardsConfigsConnection';
  edges: Array<SolutionGroupRewardsConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupStakingAmounts = {
  __typename?: 'SolutionGroupStakingAmounts';
  id: Scalars['String']['output'];
  max: Scalars['BigInt']['output'];
  min: Scalars['BigInt']['output'];
};

export type SolutionGroupStakingAmountsConnection = {
  __typename?: 'SolutionGroupStakingAmountsConnection';
  edges: Array<SolutionGroupStakingAmountsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionGroupStakingAmountsEdge = {
  __typename?: 'SolutionGroupStakingAmountsEdge';
  cursor: Scalars['String']['output'];
  node: SolutionGroupStakingAmounts;
};

export enum SolutionGroupStakingAmountsOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  MaxAsc = 'max_ASC',
  MaxAscNullsFirst = 'max_ASC_NULLS_FIRST',
  MaxAscNullsLast = 'max_ASC_NULLS_LAST',
  MaxDesc = 'max_DESC',
  MaxDescNullsFirst = 'max_DESC_NULLS_FIRST',
  MaxDescNullsLast = 'max_DESC_NULLS_LAST',
  MinAsc = 'min_ASC',
  MinAscNullsFirst = 'min_ASC_NULLS_FIRST',
  MinAscNullsLast = 'min_ASC_NULLS_LAST',
  MinDesc = 'min_DESC',
  MinDescNullsFirst = 'min_DESC_NULLS_FIRST',
  MinDescNullsLast = 'min_DESC_NULLS_LAST',
}

export type SolutionGroupStakingAmountsWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupStakingAmountsWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupStakingAmountsWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  max_eq?: InputMaybe<Scalars['BigInt']['input']>;
  max_gt?: InputMaybe<Scalars['BigInt']['input']>;
  max_gte?: InputMaybe<Scalars['BigInt']['input']>;
  max_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  max_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  max_lt?: InputMaybe<Scalars['BigInt']['input']>;
  max_lte?: InputMaybe<Scalars['BigInt']['input']>;
  max_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  max_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  min_eq?: InputMaybe<Scalars['BigInt']['input']>;
  min_gt?: InputMaybe<Scalars['BigInt']['input']>;
  min_gte?: InputMaybe<Scalars['BigInt']['input']>;
  min_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  min_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  min_lt?: InputMaybe<Scalars['BigInt']['input']>;
  min_lte?: InputMaybe<Scalars['BigInt']['input']>;
  min_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  min_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type SolutionGroupWhereInput = {
  AND?: InputMaybe<Array<SolutionGroupWhereInput>>;
  OR?: InputMaybe<Array<SolutionGroupWhereInput>>;
  allowedCids_every?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
  allowedCids_none?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
  allowedCids_some?: InputMaybe<SolutionGroupAllowedCidWhereInput>;
  assuranceSlashingConfig?: InputMaybe<SolutionGroupAssuranceSlashingConfigWhereInput>;
  assuranceSlashingConfig_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  earnedRewards_every?: InputMaybe<EarnedRewardsWhereInput>;
  earnedRewards_none?: InputMaybe<EarnedRewardsWhereInput>;
  earnedRewards_some?: InputMaybe<EarnedRewardsWhereInput>;
  hasCidAllowList_eq?: InputMaybe<Scalars['Boolean']['input']>;
  hasCidAllowList_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  hasCidAllowList_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<SolutionGroupInfoWhereInput>;
  info_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  namespace_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_gt?: InputMaybe<Scalars['String']['input']>;
  namespace_gte?: InputMaybe<Scalars['String']['input']>;
  namespace_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  namespace_lt?: InputMaybe<Scalars['String']['input']>;
  namespace_lte?: InputMaybe<Scalars['String']['input']>;
  namespace_not_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_not_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_startsWith?: InputMaybe<Scalars['String']['input']>;
  operationEndBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  operationEndBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  operationEndBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  operationEndBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  operationStartBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  operationStartBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  operationStartBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  operationStartBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  operatorsConfig?: InputMaybe<SolutionGroupOperatorsConfigWhereInput>;
  operatorsConfig_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  performanceSlashingConfig?: InputMaybe<SolutionGroupPerformanceSlashingConfigWhereInput>;
  performanceSlashingConfig_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  registrar?: InputMaybe<RegistrarAccountWhereInput>;
  registrar_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardsConfig?: InputMaybe<SolutionGroupRewardsConfigWhereInput>;
  rewardsConfig_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUnsubscriptions_every?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  scheduledUnsubscriptions_none?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  scheduledUnsubscriptions_some?: InputMaybe<UnsubscriptionScheduleWhereInput>;
  slaVotingThreshold_eq?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  slaVotingThreshold_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  slaVotingThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_not_eq?: InputMaybe<Scalars['Int']['input']>;
  slaVotingThreshold_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  solutions_every?: InputMaybe<SolutionWhereInput>;
  solutions_none?: InputMaybe<SolutionWhereInput>;
  solutions_some?: InputMaybe<SolutionWhereInput>;
  stakes_every?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  stakes_none?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  stakes_some?: InputMaybe<OperatorSubscribedStakeWhereInput>;
  stakingAmounts?: InputMaybe<SolutionGroupStakingAmountsWhereInput>;
  stakingAmounts_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  subscribedOperators_every?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
  subscribedOperators_none?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
  subscribedOperators_some?: InputMaybe<OperatorSubscribedSolutionGroupsWhereInput>;
  withdrawalDelay_eq?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_gt?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_gte?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  withdrawalDelay_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalDelay_lt?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_lte?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_not_eq?: InputMaybe<Scalars['Int']['input']>;
  withdrawalDelay_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SolutionGroupsConnection = {
  __typename?: 'SolutionGroupsConnection';
  edges: Array<SolutionGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionInfo = {
  __typename?: 'SolutionInfo';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publisherInfo: Scalars['String']['output'];
};

export type SolutionInfoEdge = {
  __typename?: 'SolutionInfoEdge';
  cursor: Scalars['String']['output'];
  node: SolutionInfo;
};

export enum SolutionInfoOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionAscNullsFirst = 'description_ASC_NULLS_FIRST',
  DescriptionAscNullsLast = 'description_ASC_NULLS_LAST',
  DescriptionDesc = 'description_DESC',
  DescriptionDescNullsFirst = 'description_DESC_NULLS_FIRST',
  DescriptionDescNullsLast = 'description_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  LogoUrlAsc = 'logoUrl_ASC',
  LogoUrlAscNullsFirst = 'logoUrl_ASC_NULLS_FIRST',
  LogoUrlAscNullsLast = 'logoUrl_ASC_NULLS_LAST',
  LogoUrlDesc = 'logoUrl_DESC',
  LogoUrlDescNullsFirst = 'logoUrl_DESC_NULLS_FIRST',
  LogoUrlDescNullsLast = 'logoUrl_DESC_NULLS_LAST',
  NameAsc = 'name_ASC',
  NameAscNullsFirst = 'name_ASC_NULLS_FIRST',
  NameAscNullsLast = 'name_ASC_NULLS_LAST',
  NameDesc = 'name_DESC',
  NameDescNullsFirst = 'name_DESC_NULLS_FIRST',
  NameDescNullsLast = 'name_DESC_NULLS_LAST',
  PublisherInfoAsc = 'publisherInfo_ASC',
  PublisherInfoAscNullsFirst = 'publisherInfo_ASC_NULLS_FIRST',
  PublisherInfoAscNullsLast = 'publisherInfo_ASC_NULLS_LAST',
  PublisherInfoDesc = 'publisherInfo_DESC',
  PublisherInfoDescNullsFirst = 'publisherInfo_DESC_NULLS_FIRST',
  PublisherInfoDescNullsLast = 'publisherInfo_DESC_NULLS_LAST',
}

export type SolutionInfoWhereInput = {
  AND?: InputMaybe<Array<SolutionInfoWhereInput>>;
  OR?: InputMaybe<Array<SolutionInfoWhereInput>>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  description_endsWith?: InputMaybe<Scalars['String']['input']>;
  description_eq?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  description_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  description_not_eq?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  description_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  logoUrl_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  logoUrl_endsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_eq?: InputMaybe<Scalars['String']['input']>;
  logoUrl_gt?: InputMaybe<Scalars['String']['input']>;
  logoUrl_gte?: InputMaybe<Scalars['String']['input']>;
  logoUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  logoUrl_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl_lt?: InputMaybe<Scalars['String']['input']>;
  logoUrl_lte?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_eq?: InputMaybe<Scalars['String']['input']>;
  logoUrl_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  logoUrl_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  logoUrl_startsWith?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_eq?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  name_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  name_not_eq?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  name_startsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_contains?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_endsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_eq?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_gt?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_gte?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherInfo_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  publisherInfo_lt?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_lte?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_contains?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_eq?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publisherInfo_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  publisherInfo_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SolutionInfosConnection = {
  __typename?: 'SolutionInfosConnection';
  edges: Array<SolutionInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SolutionOrderByInput {
  AdditionToExtraneousGroupsAllowedAsc = 'additionToExtraneousGroupsAllowed_ASC',
  AdditionToExtraneousGroupsAllowedAscNullsFirst = 'additionToExtraneousGroupsAllowed_ASC_NULLS_FIRST',
  AdditionToExtraneousGroupsAllowedAscNullsLast = 'additionToExtraneousGroupsAllowed_ASC_NULLS_LAST',
  AdditionToExtraneousGroupsAllowedDesc = 'additionToExtraneousGroupsAllowed_DESC',
  AdditionToExtraneousGroupsAllowedDescNullsFirst = 'additionToExtraneousGroupsAllowed_DESC_NULLS_FIRST',
  AdditionToExtraneousGroupsAllowedDescNullsLast = 'additionToExtraneousGroupsAllowed_DESC_NULLS_LAST',
  ConsensusIdAsc = 'consensus_id_ASC',
  ConsensusIdAscNullsFirst = 'consensus_id_ASC_NULLS_FIRST',
  ConsensusIdAscNullsLast = 'consensus_id_ASC_NULLS_LAST',
  ConsensusIdDesc = 'consensus_id_DESC',
  ConsensusIdDescNullsFirst = 'consensus_id_DESC_NULLS_FIRST',
  ConsensusIdDescNullsLast = 'consensus_id_DESC_NULLS_LAST',
  ConsensusMaxWaitingThresholdAsc = 'consensus_maxWaitingThreshold_ASC',
  ConsensusMaxWaitingThresholdAscNullsFirst = 'consensus_maxWaitingThreshold_ASC_NULLS_FIRST',
  ConsensusMaxWaitingThresholdAscNullsLast = 'consensus_maxWaitingThreshold_ASC_NULLS_LAST',
  ConsensusMaxWaitingThresholdDesc = 'consensus_maxWaitingThreshold_DESC',
  ConsensusMaxWaitingThresholdDescNullsFirst = 'consensus_maxWaitingThreshold_DESC_NULLS_FIRST',
  ConsensusMaxWaitingThresholdDescNullsLast = 'consensus_maxWaitingThreshold_DESC_NULLS_LAST',
  ConsensusQuorumPercentAsc = 'consensus_quorumPercent_ASC',
  ConsensusQuorumPercentAscNullsFirst = 'consensus_quorumPercent_ASC_NULLS_FIRST',
  ConsensusQuorumPercentAscNullsLast = 'consensus_quorumPercent_ASC_NULLS_LAST',
  ConsensusQuorumPercentDesc = 'consensus_quorumPercent_DESC',
  ConsensusQuorumPercentDescNullsFirst = 'consensus_quorumPercent_DESC_NULLS_FIRST',
  ConsensusQuorumPercentDescNullsLast = 'consensus_quorumPercent_DESC_NULLS_LAST',
  ConsensusVoteThresholdPercentAsc = 'consensus_voteThresholdPercent_ASC',
  ConsensusVoteThresholdPercentAscNullsFirst = 'consensus_voteThresholdPercent_ASC_NULLS_FIRST',
  ConsensusVoteThresholdPercentAscNullsLast = 'consensus_voteThresholdPercent_ASC_NULLS_LAST',
  ConsensusVoteThresholdPercentDesc = 'consensus_voteThresholdPercent_DESC',
  ConsensusVoteThresholdPercentDescNullsFirst = 'consensus_voteThresholdPercent_DESC_NULLS_FIRST',
  ConsensusVoteThresholdPercentDescNullsLast = 'consensus_voteThresholdPercent_DESC_NULLS_LAST',
  ConsensusVotingStartMethodAsc = 'consensus_votingStartMethod_ASC',
  ConsensusVotingStartMethodAscNullsFirst = 'consensus_votingStartMethod_ASC_NULLS_FIRST',
  ConsensusVotingStartMethodAscNullsLast = 'consensus_votingStartMethod_ASC_NULLS_LAST',
  ConsensusVotingStartMethodDesc = 'consensus_votingStartMethod_DESC',
  ConsensusVotingStartMethodDescNullsFirst = 'consensus_votingStartMethod_DESC_NULLS_FIRST',
  ConsensusVotingStartMethodDescNullsLast = 'consensus_votingStartMethod_DESC_NULLS_LAST',
  ExpirationBlockAsc = 'expirationBlock_ASC',
  ExpirationBlockAscNullsFirst = 'expirationBlock_ASC_NULLS_FIRST',
  ExpirationBlockAscNullsLast = 'expirationBlock_ASC_NULLS_LAST',
  ExpirationBlockDesc = 'expirationBlock_DESC',
  ExpirationBlockDescNullsFirst = 'expirationBlock_DESC_NULLS_FIRST',
  ExpirationBlockDescNullsLast = 'expirationBlock_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  InfoDescriptionAsc = 'info_description_ASC',
  InfoDescriptionAscNullsFirst = 'info_description_ASC_NULLS_FIRST',
  InfoDescriptionAscNullsLast = 'info_description_ASC_NULLS_LAST',
  InfoDescriptionDesc = 'info_description_DESC',
  InfoDescriptionDescNullsFirst = 'info_description_DESC_NULLS_FIRST',
  InfoDescriptionDescNullsLast = 'info_description_DESC_NULLS_LAST',
  InfoIdAsc = 'info_id_ASC',
  InfoIdAscNullsFirst = 'info_id_ASC_NULLS_FIRST',
  InfoIdAscNullsLast = 'info_id_ASC_NULLS_LAST',
  InfoIdDesc = 'info_id_DESC',
  InfoIdDescNullsFirst = 'info_id_DESC_NULLS_FIRST',
  InfoIdDescNullsLast = 'info_id_DESC_NULLS_LAST',
  InfoLogoUrlAsc = 'info_logoUrl_ASC',
  InfoLogoUrlAscNullsFirst = 'info_logoUrl_ASC_NULLS_FIRST',
  InfoLogoUrlAscNullsLast = 'info_logoUrl_ASC_NULLS_LAST',
  InfoLogoUrlDesc = 'info_logoUrl_DESC',
  InfoLogoUrlDescNullsFirst = 'info_logoUrl_DESC_NULLS_FIRST',
  InfoLogoUrlDescNullsLast = 'info_logoUrl_DESC_NULLS_LAST',
  InfoNameAsc = 'info_name_ASC',
  InfoNameAscNullsFirst = 'info_name_ASC_NULLS_FIRST',
  InfoNameAscNullsLast = 'info_name_ASC_NULLS_LAST',
  InfoNameDesc = 'info_name_DESC',
  InfoNameDescNullsFirst = 'info_name_DESC_NULLS_FIRST',
  InfoNameDescNullsLast = 'info_name_DESC_NULLS_LAST',
  InfoPublisherInfoAsc = 'info_publisherInfo_ASC',
  InfoPublisherInfoAscNullsFirst = 'info_publisherInfo_ASC_NULLS_FIRST',
  InfoPublisherInfoAscNullsLast = 'info_publisherInfo_ASC_NULLS_LAST',
  InfoPublisherInfoDesc = 'info_publisherInfo_DESC',
  InfoPublisherInfoDescNullsFirst = 'info_publisherInfo_DESC_NULLS_FIRST',
  InfoPublisherInfoDescNullsLast = 'info_publisherInfo_DESC_NULLS_LAST',
  NamespaceAsc = 'namespace_ASC',
  NamespaceAscNullsFirst = 'namespace_ASC_NULLS_FIRST',
  NamespaceAscNullsLast = 'namespace_ASC_NULLS_LAST',
  NamespaceDesc = 'namespace_DESC',
  NamespaceDescNullsFirst = 'namespace_DESC_NULLS_FIRST',
  NamespaceDescNullsLast = 'namespace_DESC_NULLS_LAST',
  NominationsEnabledAsc = 'nominationsEnabled_ASC',
  NominationsEnabledAscNullsFirst = 'nominationsEnabled_ASC_NULLS_FIRST',
  NominationsEnabledAscNullsLast = 'nominationsEnabled_ASC_NULLS_LAST',
  NominationsEnabledDesc = 'nominationsEnabled_DESC',
  NominationsEnabledDescNullsFirst = 'nominationsEnabled_DESC_NULLS_FIRST',
  NominationsEnabledDescNullsLast = 'nominationsEnabled_DESC_NULLS_LAST',
  RegistrarFriendlyNameAsc = 'registrar_friendlyName_ASC',
  RegistrarFriendlyNameAscNullsFirst = 'registrar_friendlyName_ASC_NULLS_FIRST',
  RegistrarFriendlyNameAscNullsLast = 'registrar_friendlyName_ASC_NULLS_LAST',
  RegistrarFriendlyNameDesc = 'registrar_friendlyName_DESC',
  RegistrarFriendlyNameDescNullsFirst = 'registrar_friendlyName_DESC_NULLS_FIRST',
  RegistrarFriendlyNameDescNullsLast = 'registrar_friendlyName_DESC_NULLS_LAST',
  RegistrarIdAsc = 'registrar_id_ASC',
  RegistrarIdAscNullsFirst = 'registrar_id_ASC_NULLS_FIRST',
  RegistrarIdAscNullsLast = 'registrar_id_ASC_NULLS_LAST',
  RegistrarIdDesc = 'registrar_id_DESC',
  RegistrarIdDescNullsFirst = 'registrar_id_DESC_NULLS_FIRST',
  RegistrarIdDescNullsLast = 'registrar_id_DESC_NULLS_LAST',
  RegistrarIsAllowedAsc = 'registrar_isAllowed_ASC',
  RegistrarIsAllowedAscNullsFirst = 'registrar_isAllowed_ASC_NULLS_FIRST',
  RegistrarIsAllowedAscNullsLast = 'registrar_isAllowed_ASC_NULLS_LAST',
  RegistrarIsAllowedDesc = 'registrar_isAllowed_DESC',
  RegistrarIsAllowedDescNullsFirst = 'registrar_isAllowed_DESC_NULLS_FIRST',
  RegistrarIsAllowedDescNullsLast = 'registrar_isAllowed_DESC_NULLS_LAST',
  RegistrarLegalLocationAsc = 'registrar_legalLocation_ASC',
  RegistrarLegalLocationAscNullsFirst = 'registrar_legalLocation_ASC_NULLS_FIRST',
  RegistrarLegalLocationAscNullsLast = 'registrar_legalLocation_ASC_NULLS_LAST',
  RegistrarLegalLocationDesc = 'registrar_legalLocation_DESC',
  RegistrarLegalLocationDescNullsFirst = 'registrar_legalLocation_DESC_NULLS_FIRST',
  RegistrarLegalLocationDescNullsLast = 'registrar_legalLocation_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
  StatusAsc = 'status_ASC',
  StatusAscNullsFirst = 'status_ASC_NULLS_FIRST',
  StatusAscNullsLast = 'status_ASC_NULLS_LAST',
  StatusDesc = 'status_DESC',
  StatusDescNullsFirst = 'status_DESC_NULLS_FIRST',
  StatusDescNullsLast = 'status_DESC_NULLS_LAST',
  WorkloadExecutionEnvironmentAsc = 'workload_executionEnvironment_ASC',
  WorkloadExecutionEnvironmentAscNullsFirst = 'workload_executionEnvironment_ASC_NULLS_FIRST',
  WorkloadExecutionEnvironmentAscNullsLast = 'workload_executionEnvironment_ASC_NULLS_LAST',
  WorkloadExecutionEnvironmentDesc = 'workload_executionEnvironment_DESC',
  WorkloadExecutionEnvironmentDescNullsFirst = 'workload_executionEnvironment_DESC_NULLS_FIRST',
  WorkloadExecutionEnvironmentDescNullsLast = 'workload_executionEnvironment_DESC_NULLS_LAST',
  WorkloadIdAsc = 'workload_id_ASC',
  WorkloadIdAscNullsFirst = 'workload_id_ASC_NULLS_FIRST',
  WorkloadIdAscNullsLast = 'workload_id_ASC_NULLS_LAST',
  WorkloadIdDesc = 'workload_id_DESC',
  WorkloadIdDescNullsFirst = 'workload_id_DESC_NULLS_FIRST',
  WorkloadIdDescNullsLast = 'workload_id_DESC_NULLS_LAST',
  WorkloadWorkLogicAsc = 'workload_workLogic_ASC',
  WorkloadWorkLogicAscNullsFirst = 'workload_workLogic_ASC_NULLS_FIRST',
  WorkloadWorkLogicAscNullsLast = 'workload_workLogic_ASC_NULLS_LAST',
  WorkloadWorkLogicDesc = 'workload_workLogic_DESC',
  WorkloadWorkLogicDescNullsFirst = 'workload_workLogic_DESC_NULLS_FIRST',
  WorkloadWorkLogicDescNullsLast = 'workload_workLogic_DESC_NULLS_LAST',
}

export type SolutionWhereInput = {
  AND?: InputMaybe<Array<SolutionWhereInput>>;
  OR?: InputMaybe<Array<SolutionWhereInput>>;
  additionToExtraneousGroupsAllowed_eq?: InputMaybe<Scalars['Boolean']['input']>;
  additionToExtraneousGroupsAllowed_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  additionToExtraneousGroupsAllowed_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  consensus?: InputMaybe<SolutionConsensusWhereInput>;
  consensus_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  expirationBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expirationBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  expirationBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<SolutionInfoWhereInput>;
  info_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  namespace_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_gt?: InputMaybe<Scalars['String']['input']>;
  namespace_gte?: InputMaybe<Scalars['String']['input']>;
  namespace_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  namespace_lt?: InputMaybe<Scalars['String']['input']>;
  namespace_lte?: InputMaybe<Scalars['String']['input']>;
  namespace_not_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  namespace_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_not_eq?: InputMaybe<Scalars['String']['input']>;
  namespace_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  namespace_startsWith?: InputMaybe<Scalars['String']['input']>;
  nominationsEnabled_eq?: InputMaybe<Scalars['Boolean']['input']>;
  nominationsEnabled_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  nominationsEnabled_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  registrar?: InputMaybe<RegistrarAccountWhereInput>;
  registrar_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  status_contains?: InputMaybe<Scalars['String']['input']>;
  status_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  status_endsWith?: InputMaybe<Scalars['String']['input']>;
  status_eq?: InputMaybe<Scalars['String']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<Scalars['String']['input']>>;
  status_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_not_contains?: InputMaybe<Scalars['String']['input']>;
  status_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  status_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  status_not_eq?: InputMaybe<Scalars['String']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  status_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  status_startsWith?: InputMaybe<Scalars['String']['input']>;
  workload?: InputMaybe<SolutionWorkloadWhereInput>;
  workload_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolutionWorkload = {
  __typename?: 'SolutionWorkload';
  executionEnvironment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  workLogic: Scalars['String']['output'];
};

export type SolutionWorkloadEdge = {
  __typename?: 'SolutionWorkloadEdge';
  cursor: Scalars['String']['output'];
  node: SolutionWorkload;
};

export enum SolutionWorkloadOrderByInput {
  ExecutionEnvironmentAsc = 'executionEnvironment_ASC',
  ExecutionEnvironmentAscNullsFirst = 'executionEnvironment_ASC_NULLS_FIRST',
  ExecutionEnvironmentAscNullsLast = 'executionEnvironment_ASC_NULLS_LAST',
  ExecutionEnvironmentDesc = 'executionEnvironment_DESC',
  ExecutionEnvironmentDescNullsFirst = 'executionEnvironment_DESC_NULLS_FIRST',
  ExecutionEnvironmentDescNullsLast = 'executionEnvironment_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  WorkLogicAsc = 'workLogic_ASC',
  WorkLogicAscNullsFirst = 'workLogic_ASC_NULLS_FIRST',
  WorkLogicAscNullsLast = 'workLogic_ASC_NULLS_LAST',
  WorkLogicDesc = 'workLogic_DESC',
  WorkLogicDescNullsFirst = 'workLogic_DESC_NULLS_FIRST',
  WorkLogicDescNullsLast = 'workLogic_DESC_NULLS_LAST',
}

export type SolutionWorkloadWhereInput = {
  AND?: InputMaybe<Array<SolutionWorkloadWhereInput>>;
  OR?: InputMaybe<Array<SolutionWorkloadWhereInput>>;
  executionEnvironment_contains?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_endsWith?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_eq?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_gt?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_gte?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_in?: InputMaybe<Array<Scalars['String']['input']>>;
  executionEnvironment_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  executionEnvironment_lt?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_lte?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_not_contains?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_not_eq?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  executionEnvironment_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  executionEnvironment_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  workLogic_contains?: InputMaybe<Scalars['String']['input']>;
  workLogic_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  workLogic_endsWith?: InputMaybe<Scalars['String']['input']>;
  workLogic_eq?: InputMaybe<Scalars['String']['input']>;
  workLogic_gt?: InputMaybe<Scalars['String']['input']>;
  workLogic_gte?: InputMaybe<Scalars['String']['input']>;
  workLogic_in?: InputMaybe<Array<Scalars['String']['input']>>;
  workLogic_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  workLogic_lt?: InputMaybe<Scalars['String']['input']>;
  workLogic_lte?: InputMaybe<Scalars['String']['input']>;
  workLogic_not_contains?: InputMaybe<Scalars['String']['input']>;
  workLogic_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  workLogic_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  workLogic_not_eq?: InputMaybe<Scalars['String']['input']>;
  workLogic_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  workLogic_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  workLogic_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SolutionWorkloadsConnection = {
  __typename?: 'SolutionWorkloadsConnection';
  edges: Array<SolutionWorkloadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SolutionsConnection = {
  __typename?: 'SolutionsConnection';
  edges: Array<SolutionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SquidStatus = {
  __typename?: 'SquidStatus';
  /** The hash of the last processed finalized block */
  finalizedHash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed finalized block */
  finalizedHeight?: Maybe<Scalars['Int']['output']>;
  /** The hash of the last processed block */
  hash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed block */
  height?: Maybe<Scalars['Int']['output']>;
};

export type UnclaimedRewards = {
  __typename?: 'UnclaimedRewards';
  address: Scalars['String']['output'];
  participationReward: Scalars['BigInt']['output'];
  solutionGroupId: Scalars['String']['output'];
  subscriptionReward: Scalars['BigInt']['output'];
};

export type UnsubscriptionSchedule = {
  __typename?: 'UnsubscriptionSchedule';
  id: Scalars['String']['output'];
  operator: OperatorAccount;
  scheduleName: Scalars['String']['output'];
  solutionGroup?: Maybe<SolutionGroup>;
  unsubscribeBlock: Scalars['Int']['output'];
};

export type UnsubscriptionScheduleEdge = {
  __typename?: 'UnsubscriptionScheduleEdge';
  cursor: Scalars['String']['output'];
  node: UnsubscriptionSchedule;
};

export enum UnsubscriptionScheduleOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorFriendlyNameAsc = 'operator_friendlyName_ASC',
  OperatorFriendlyNameAscNullsFirst = 'operator_friendlyName_ASC_NULLS_FIRST',
  OperatorFriendlyNameAscNullsLast = 'operator_friendlyName_ASC_NULLS_LAST',
  OperatorFriendlyNameDesc = 'operator_friendlyName_DESC',
  OperatorFriendlyNameDescNullsFirst = 'operator_friendlyName_DESC_NULLS_FIRST',
  OperatorFriendlyNameDescNullsLast = 'operator_friendlyName_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  OperatorLegalLocationAsc = 'operator_legalLocation_ASC',
  OperatorLegalLocationAscNullsFirst = 'operator_legalLocation_ASC_NULLS_FIRST',
  OperatorLegalLocationAscNullsLast = 'operator_legalLocation_ASC_NULLS_LAST',
  OperatorLegalLocationDesc = 'operator_legalLocation_DESC',
  OperatorLegalLocationDescNullsFirst = 'operator_legalLocation_DESC_NULLS_FIRST',
  OperatorLegalLocationDescNullsLast = 'operator_legalLocation_DESC_NULLS_LAST',
  ScheduleNameAsc = 'scheduleName_ASC',
  ScheduleNameAscNullsFirst = 'scheduleName_ASC_NULLS_FIRST',
  ScheduleNameAscNullsLast = 'scheduleName_ASC_NULLS_LAST',
  ScheduleNameDesc = 'scheduleName_DESC',
  ScheduleNameDescNullsFirst = 'scheduleName_DESC_NULLS_FIRST',
  ScheduleNameDescNullsLast = 'scheduleName_DESC_NULLS_LAST',
  SolutionGroupHasCidAllowListAsc = 'solutionGroup_hasCidAllowList_ASC',
  SolutionGroupHasCidAllowListAscNullsFirst = 'solutionGroup_hasCidAllowList_ASC_NULLS_FIRST',
  SolutionGroupHasCidAllowListAscNullsLast = 'solutionGroup_hasCidAllowList_ASC_NULLS_LAST',
  SolutionGroupHasCidAllowListDesc = 'solutionGroup_hasCidAllowList_DESC',
  SolutionGroupHasCidAllowListDescNullsFirst = 'solutionGroup_hasCidAllowList_DESC_NULLS_FIRST',
  SolutionGroupHasCidAllowListDescNullsLast = 'solutionGroup_hasCidAllowList_DESC_NULLS_LAST',
  SolutionGroupIdAsc = 'solutionGroup_id_ASC',
  SolutionGroupIdAscNullsFirst = 'solutionGroup_id_ASC_NULLS_FIRST',
  SolutionGroupIdAscNullsLast = 'solutionGroup_id_ASC_NULLS_LAST',
  SolutionGroupIdDesc = 'solutionGroup_id_DESC',
  SolutionGroupIdDescNullsFirst = 'solutionGroup_id_DESC_NULLS_FIRST',
  SolutionGroupIdDescNullsLast = 'solutionGroup_id_DESC_NULLS_LAST',
  SolutionGroupNamespaceAsc = 'solutionGroup_namespace_ASC',
  SolutionGroupNamespaceAscNullsFirst = 'solutionGroup_namespace_ASC_NULLS_FIRST',
  SolutionGroupNamespaceAscNullsLast = 'solutionGroup_namespace_ASC_NULLS_LAST',
  SolutionGroupNamespaceDesc = 'solutionGroup_namespace_DESC',
  SolutionGroupNamespaceDescNullsFirst = 'solutionGroup_namespace_DESC_NULLS_FIRST',
  SolutionGroupNamespaceDescNullsLast = 'solutionGroup_namespace_DESC_NULLS_LAST',
  SolutionGroupOperationEndBlockAsc = 'solutionGroup_operationEndBlock_ASC',
  SolutionGroupOperationEndBlockAscNullsFirst = 'solutionGroup_operationEndBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationEndBlockAscNullsLast = 'solutionGroup_operationEndBlock_ASC_NULLS_LAST',
  SolutionGroupOperationEndBlockDesc = 'solutionGroup_operationEndBlock_DESC',
  SolutionGroupOperationEndBlockDescNullsFirst = 'solutionGroup_operationEndBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationEndBlockDescNullsLast = 'solutionGroup_operationEndBlock_DESC_NULLS_LAST',
  SolutionGroupOperationStartBlockAsc = 'solutionGroup_operationStartBlock_ASC',
  SolutionGroupOperationStartBlockAscNullsFirst = 'solutionGroup_operationStartBlock_ASC_NULLS_FIRST',
  SolutionGroupOperationStartBlockAscNullsLast = 'solutionGroup_operationStartBlock_ASC_NULLS_LAST',
  SolutionGroupOperationStartBlockDesc = 'solutionGroup_operationStartBlock_DESC',
  SolutionGroupOperationStartBlockDescNullsFirst = 'solutionGroup_operationStartBlock_DESC_NULLS_FIRST',
  SolutionGroupOperationStartBlockDescNullsLast = 'solutionGroup_operationStartBlock_DESC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdAsc = 'solutionGroup_slaVotingThreshold_ASC',
  SolutionGroupSlaVotingThresholdAscNullsFirst = 'solutionGroup_slaVotingThreshold_ASC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdAscNullsLast = 'solutionGroup_slaVotingThreshold_ASC_NULLS_LAST',
  SolutionGroupSlaVotingThresholdDesc = 'solutionGroup_slaVotingThreshold_DESC',
  SolutionGroupSlaVotingThresholdDescNullsFirst = 'solutionGroup_slaVotingThreshold_DESC_NULLS_FIRST',
  SolutionGroupSlaVotingThresholdDescNullsLast = 'solutionGroup_slaVotingThreshold_DESC_NULLS_LAST',
  SolutionGroupWithdrawalDelayAsc = 'solutionGroup_withdrawalDelay_ASC',
  SolutionGroupWithdrawalDelayAscNullsFirst = 'solutionGroup_withdrawalDelay_ASC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayAscNullsLast = 'solutionGroup_withdrawalDelay_ASC_NULLS_LAST',
  SolutionGroupWithdrawalDelayDesc = 'solutionGroup_withdrawalDelay_DESC',
  SolutionGroupWithdrawalDelayDescNullsFirst = 'solutionGroup_withdrawalDelay_DESC_NULLS_FIRST',
  SolutionGroupWithdrawalDelayDescNullsLast = 'solutionGroup_withdrawalDelay_DESC_NULLS_LAST',
  UnsubscribeBlockAsc = 'unsubscribeBlock_ASC',
  UnsubscribeBlockAscNullsFirst = 'unsubscribeBlock_ASC_NULLS_FIRST',
  UnsubscribeBlockAscNullsLast = 'unsubscribeBlock_ASC_NULLS_LAST',
  UnsubscribeBlockDesc = 'unsubscribeBlock_DESC',
  UnsubscribeBlockDescNullsFirst = 'unsubscribeBlock_DESC_NULLS_FIRST',
  UnsubscribeBlockDescNullsLast = 'unsubscribeBlock_DESC_NULLS_LAST',
}

export type UnsubscriptionScheduleWhereInput = {
  AND?: InputMaybe<Array<UnsubscriptionScheduleWhereInput>>;
  OR?: InputMaybe<Array<UnsubscriptionScheduleWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorAccountWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleName_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleName_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleName_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleName_gt?: InputMaybe<Scalars['String']['input']>;
  scheduleName_gte?: InputMaybe<Scalars['String']['input']>;
  scheduleName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleName_lt?: InputMaybe<Scalars['String']['input']>;
  scheduleName_lte?: InputMaybe<Scalars['String']['input']>;
  scheduleName_not_contains?: InputMaybe<Scalars['String']['input']>;
  scheduleName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  scheduleName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleName_not_eq?: InputMaybe<Scalars['String']['input']>;
  scheduleName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  scheduleName_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionGroup?: InputMaybe<SolutionGroupWhereInput>;
  solutionGroup_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribeBlock_eq?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_gt?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_gte?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  unsubscribeBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribeBlock_lt?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_lte?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_not_eq?: InputMaybe<Scalars['Int']['input']>;
  unsubscribeBlock_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UnsubscriptionSchedulesConnection = {
  __typename?: 'UnsubscriptionSchedulesConnection';
  edges: Array<UnsubscriptionScheduleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkerAccount = {
  __typename?: 'WorkerAccount';
  account: Account;
  address: Scalars['String']['output'];
  /** Account address */
  id: Scalars['String']['output'];
  mapping?: Maybe<OperatorMapping>;
};

export type WorkerAccountEdge = {
  __typename?: 'WorkerAccountEdge';
  cursor: Scalars['String']['output'];
  node: WorkerAccount;
};

export enum WorkerAccountOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  AddressAsc = 'address_ASC',
  AddressAscNullsFirst = 'address_ASC_NULLS_FIRST',
  AddressAscNullsLast = 'address_ASC_NULLS_LAST',
  AddressDesc = 'address_DESC',
  AddressDescNullsFirst = 'address_DESC_NULLS_FIRST',
  AddressDescNullsLast = 'address_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  MappingIdAsc = 'mapping_id_ASC',
  MappingIdAscNullsFirst = 'mapping_id_ASC_NULLS_FIRST',
  MappingIdAscNullsLast = 'mapping_id_ASC_NULLS_LAST',
  MappingIdDesc = 'mapping_id_DESC',
  MappingIdDescNullsFirst = 'mapping_id_DESC_NULLS_FIRST',
  MappingIdDescNullsLast = 'mapping_id_DESC_NULLS_LAST',
}

export type WorkerAccountWhereInput = {
  AND?: InputMaybe<Array<WorkerAccountWhereInput>>;
  OR?: InputMaybe<Array<WorkerAccountWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  address_contains?: InputMaybe<Scalars['String']['input']>;
  address_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  address_endsWith?: InputMaybe<Scalars['String']['input']>;
  address_eq?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_not_contains?: InputMaybe<Scalars['String']['input']>;
  address_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  address_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  address_not_eq?: InputMaybe<Scalars['String']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  address_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<OperatorMappingWhereInput>;
  mapping_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerAccountsConnection = {
  __typename?: 'WorkerAccountsConnection';
  edges: Array<WorkerAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubscriptionsByOperatorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type SubscriptionsByOperatorQuery = {
  __typename?: 'Query';
  operatorAccountById?: {
    __typename?: 'OperatorAccount';
    subscribedStakes: Array<{
      __typename?: 'OperatorSubscribedStake';
      currentStake: any;
      nextStake: any;
      rewardPeriodIndex: number;
      solutionGroup?: { __typename?: 'SolutionGroup'; namespace: string } | null;
    }>;
    subscriptions: Array<{
      __typename?: 'OperatorSubscribedSolutionGroups';
      id: string;
      namespace: string;
      solutionGroup: {
        __typename?: 'SolutionGroup';
        id: string;
        namespace: string;
        operationStartBlock: number;
        operationEndBlock: number;
        withdrawalDelay?: number | null;
        operatorsConfig: {
          __typename?: 'SolutionGroupOperatorsConfig';
          startBlock: number;
          allowedOperators: number;
          maxOperatorWorkers: number;
          hasOperatorsAllowlist: boolean;
          stakingAmounts: { __typename?: 'SolutionGroupStakingAmounts'; min: any; max: any };
        };
        rewardsConfig: {
          __typename?: 'SolutionGroupRewardsConfig';
          subscriptionRewardPerBlock: any;
          votingRewardPerBlock: any;
          topPerformanceBonus: any;
        };
        info: {
          __typename?: 'SolutionGroupInfo';
          id: string;
          name: string;
          description: string;
          publisherInfo: string;
          logoUrl?: string | null;
        };
        solutions: Array<{
          __typename?: 'Solution';
          id: string;
          status?: string | null;
          namespace: string;
          additionToExtraneousGroupsAllowed?: boolean | null;
          expirationBlock: any;
          workload: {
            __typename?: 'SolutionWorkload';
            workLogic: string;
            executionEnvironment: string;
          };
          info: { __typename?: 'SolutionInfo'; id: string; description: string };
        }>;
        scheduledUnsubscriptions: Array<{
          __typename?: 'UnsubscriptionSchedule';
          unsubscribeBlock: number;
        }>;
      };
    }>;
  } | null;
};

export type GetSubscriptionStakeQueryVariables = Exact<{
  queryId: Scalars['String']['input'];
}>;

export type GetSubscriptionStakeQuery = {
  __typename?: 'Query';
  operatorSubscribedStakeById?: {
    __typename?: 'OperatorSubscribedStake';
    currentStake: any;
    nextStake: any;
  } | null;
};

export type GetSubscriptionsStakeQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  currentRewardPeriod: Scalars['Int']['input'];
}>;

export type GetSubscriptionsStakeQuery = {
  __typename?: 'Query';
  operatorSubscribedSolutionGroups: Array<{
    __typename?: 'OperatorSubscribedSolutionGroups';
    solutionGroup: {
      __typename?: 'SolutionGroup';
      id: string;
      stakes: Array<{ __typename?: 'OperatorSubscribedStake'; currentStake: any; nextStake: any }>;
    };
  }>;
};

export type GetEarnedRewardsQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  groupNamespace: Scalars['String']['input'];
}>;

export type GetEarnedRewardsQuery = {
  __typename?: 'Query';
  earnedRewards: Array<{
    __typename?: 'EarnedRewards';
    id: string;
    subscriptionReward: any;
    participationReward: any;
  }>;
};

export type LowersQueryVariables = Exact<{
  sender?: InputMaybe<Scalars['String']['input']>;
}>;

export type LowersQuery = {
  __typename?: 'Query';
  avnLowers: Array<{
    __typename?: 'AvnLower';
    id: string;
    when: any;
    amount: any;
    blockNumber: any;
    receiver: string;
    isPending?: boolean | null;
    isFinalized?: boolean | null;
    encodedLowerProof?: string | null;
    lowerPendingProof?: string | null;
    readyToBeClaimed?: boolean | null;
    claimed?: boolean | null;
    claimBlockNumber?: any | null;
    lowerId?: number | null;
    target?: string | null;
    sender: { __typename?: 'Account'; id: string };
  }>;
};

export type LiftsQueryVariables = Exact<{
  receiver?: InputMaybe<Scalars['String']['input']>;
}>;

export type LiftsQuery = {
  __typename?: 'Query';
  avnLifts: Array<{
    __typename?: 'AvnLift';
    id: string;
    when: any;
    amount: any;
    blockNumber: any;
    ewcTxHash?: string | null;
    sender?: string | null;
    receiver?: { __typename?: 'Account'; id: string } | null;
  }>;
};

export type GetPermitLiftAverageGasFeeQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermitLiftAverageGasFeeQuery = {
  __typename?: 'Query';
  permitLiftGasFees: Array<{ __typename?: 'PermitLiftGasFees'; averageGasFee?: any | null }>;
};

export type ClaimLowersQueryVariables = Exact<{
  sender?: InputMaybe<Scalars['String']['input']>;
}>;

export type ClaimLowersQuery = {
  __typename?: 'Query';
  avnLowers: Array<{
    __typename?: 'AvnLower';
    isFinalized?: boolean | null;
    isPending?: boolean | null;
    lowerId?: number | null;
    amount: any;
    receiver: string;
    id: string;
    when: any;
    lowerPendingProof?: string | null;
    readyToBeClaimed?: boolean | null;
    claimed?: boolean | null;
    blockNumber: any;
    claimBlockNumber?: any | null;
    sender: { __typename?: 'Account'; id: string };
  }>;
};

export type GetSolutionsGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSolutionsGroupsQuery = {
  __typename?: 'Query';
  solutionGroups: Array<{
    __typename?: 'SolutionGroup';
    id: string;
    withdrawalDelay?: number | null;
    operationStartBlock: number;
    operationEndBlock: number;
    namespace: string;
    info: {
      __typename?: 'SolutionGroupInfo';
      description: string;
      id: string;
      logoUrl?: string | null;
      name: string;
      publisherInfo: string;
    };
    operatorsConfig: {
      __typename?: 'SolutionGroupOperatorsConfig';
      allowedOperators: number;
      hasOperatorsAllowlist: boolean;
      id: string;
      maxOperatorWorkers: number;
      startBlock: number;
      stakingAmounts: {
        __typename?: 'SolutionGroupStakingAmounts';
        id: string;
        max: any;
        min: any;
      };
    };
    registrar: {
      __typename?: 'RegistrarAccount';
      friendlyName?: string | null;
      id: string;
      isAllowed?: boolean | null;
      legalLocation?: string | null;
    };
    rewardsConfig: {
      __typename?: 'SolutionGroupRewardsConfig';
      id: string;
      subscriptionRewardPerBlock: any;
      topPerformanceBonus: any;
      votingRewardPerBlock: any;
      isNative?: boolean | null;
      assetMetadata?: {
        __typename?: 'AssetMetadata';
        id: string;
        name: string;
        symbol: string;
        decimals: number;
      } | null;
    };
  }>;
};

export type GetSolutionGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetSolutionGroupQuery = {
  __typename?: 'Query';
  solutionGroupById?: {
    __typename?: 'SolutionGroup';
    id: string;
    withdrawalDelay?: number | null;
    operationStartBlock: number;
    operationEndBlock: number;
    namespace: string;
    info: {
      __typename?: 'SolutionGroupInfo';
      description: string;
      id: string;
      logoUrl?: string | null;
      name: string;
      publisherInfo: string;
    };
    operatorsConfig: {
      __typename?: 'SolutionGroupOperatorsConfig';
      allowedOperators: number;
      hasOperatorsAllowlist: boolean;
      id: string;
      maxOperatorWorkers: number;
      startBlock: number;
      stakingAmounts: {
        __typename?: 'SolutionGroupStakingAmounts';
        id: string;
        max: any;
        min: any;
      };
    };
    registrar: {
      __typename?: 'RegistrarAccount';
      friendlyName?: string | null;
      id: string;
      isAllowed?: boolean | null;
      legalLocation?: string | null;
    };
    rewardsConfig: {
      __typename?: 'SolutionGroupRewardsConfig';
      id: string;
      subscriptionRewardPerBlock: any;
      topPerformanceBonus: any;
      votingRewardPerBlock: any;
      isNative?: boolean | null;
      assetMetadata?: {
        __typename?: 'AssetMetadata';
        id: string;
        name: string;
        symbol: string;
        decimals: number;
      } | null;
    };
    solutions: Array<{
      __typename?: 'Solution';
      id: string;
      status?: string | null;
      namespace: string;
      additionToExtraneousGroupsAllowed?: boolean | null;
      expirationBlock: any;
      workload: {
        __typename?: 'SolutionWorkload';
        workLogic: string;
        executionEnvironment: string;
      };
      info: { __typename?: 'SolutionInfo'; id: string; description: string; name: string };
    }>;
  } | null;
};

export type GetSubscriptionByIdQueryVariables = Exact<{
  solutionNamespace: Scalars['String']['input'];
  address: Scalars['String']['input'];
}>;

export type GetSubscriptionByIdQuery = {
  __typename?: 'Query';
  operatorAccounts: Array<{
    __typename?: 'OperatorAccount';
    id: string;
    subscriptions: Array<{ __typename?: 'OperatorSubscribedSolutionGroups'; namespace: string }>;
  }>;
};

export type GetLinkedWorkerNodeQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;

export type GetLinkedWorkerNodeQuery = {
  __typename?: 'Query';
  workerAccounts: Array<{ __typename?: 'WorkerAccount'; address: string }>;
};

export type GetUnclaimedRewardsQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;

export type GetUnclaimedRewardsQuery = {
  __typename?: 'Query';
  unclaimedRewards: Array<{
    __typename?: 'UnclaimedRewards';
    subscriptionReward: any;
    participationReward: any;
    solutionGroupId: string;
    address: string;
  }>;
};

export type GetEwtUsdQueryVariables = Exact<{
  currency: Scalars['String']['input'];
}>;

export type GetEwtUsdQuery = {
  __typename?: 'Query';
  ewtPriceById?: { __typename?: 'EwtPrice'; price: number } | null;
};

export type GetSolutionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSolutionsQuery = {
  __typename?: 'Query';
  solutions: Array<{
    __typename?: 'Solution';
    id: string;
    status?: string | null;
    expirationBlock: any;
    additionToExtraneousGroupsAllowed?: boolean | null;
    nominationsEnabled?: boolean | null;
    namespace: string;
    solutionGroup?: { __typename?: 'SolutionGroup'; id: string } | null;
    info: {
      __typename?: 'SolutionInfo';
      description: string;
      id: string;
      logoUrl?: string | null;
      name: string;
      publisherInfo: string;
    };
    workload: {
      __typename?: 'SolutionWorkload';
      workLogic: string;
      id: string;
      executionEnvironment: string;
    };
    consensus: {
      __typename?: 'SolutionConsensus';
      id: string;
      maxWaitingThreshold: number;
      voteThresholdPercent: number;
    };
  }>;
};

export type GetCurrentRewardPeriodQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentRewardPeriodQuery = {
  __typename?: 'Query';
  activeRewardPeriodInfos: Array<{ __typename?: 'ActiveRewardPeriodInfo'; index: number }>;
};

export type GetScheduledUnsubscriptionQueryVariables = Exact<{
  address: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  currentBlockNumber: Scalars['Int']['input'];
}>;

export type GetScheduledUnsubscriptionQuery = {
  __typename?: 'Query';
  unsubscriptionSchedules: Array<{
    __typename?: 'UnsubscriptionSchedule';
    unsubscribeBlock: number;
  }>;
};

export type GetCanOperatorWorkerVoteQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  solutionNamespace: Scalars['String']['input'];
}>;

export type GetCanOperatorWorkerVoteQuery = {
  __typename?: 'Query';
  canOperatorWorkerVote: Array<{ __typename?: 'CanOperatorWorkerVote'; canVote: boolean }>;
};

export type GetCanOperatorWorkersVoteQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;

export type GetCanOperatorWorkersVoteQuery = {
  __typename?: 'Query';
  canOperatorWorkerVote: Array<{
    __typename?: 'CanOperatorWorkerVote';
    solutionGroupId: string;
    canVote: boolean;
  }>;
};

export const SubscriptionsByOperatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubscriptionsByOperator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorAccountById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscribedStakes' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'EnumValue', value: 'rewardPeriodIndex_DESC' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStake' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextStake' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rewardPeriodIndex' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solutionGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solutionGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operationStartBlock' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operationEndBlock' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'withdrawalDelay' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operatorsConfig' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startBlock' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allowedOperators' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'maxOperatorWorkers' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startBlock' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stakingAmounts' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasOperatorsAllowlist' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rewardsConfig' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subscriptionRewardPerBlock' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'votingRewardPerBlock' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'topPerformanceBonus' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'info' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publisherInfo' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'solutions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'additionToExtraneousGroupsAllowed',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'expirationBlock' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'workload' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'workLogic' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'executionEnvironment' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'expirationBlock' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'info' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'description' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scheduledUnsubscriptions' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'orderBy' },
                                  value: {
                                    kind: 'EnumValue',
                                    value: 'unsubscribeBlock_DESC_NULLS_LAST',
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'operator' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'id_eq' },
                                              value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'id' },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'limit' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'unsubscribeBlock' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionsByOperatorQuery, SubscriptionsByOperatorQueryVariables>;
export const GetSubscriptionStakeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubscriptionStake' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queryId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorSubscribedStakeById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queryId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currentStake' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStake' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubscriptionStakeQuery, GetSubscriptionStakeQueryVariables>;
export const GetSubscriptionsStakeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubscriptionsStake' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentRewardPeriod' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorSubscribedSolutionGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'operator' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'operatorId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'solutionGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stakes' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'operator' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id_eq' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'operatorId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'rewardPeriodIndex_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'currentRewardPeriod' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currentStake' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextStake' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubscriptionsStakeQuery, GetSubscriptionsStakeQueryVariables>;
export const GetEarnedRewardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEarnedRewards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupNamespace' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earnedRewards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'account' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'operatorId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'solutionGroup' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'namespace_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'groupNamespace' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionReward' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participationReward' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEarnedRewardsQuery, GetEarnedRewardsQueryVariables>;
export const LowersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Lowers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sender' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avnLowers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sender' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sender' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'lowerId_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'when' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPending' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFinalized' } },
                { kind: 'Field', name: { kind: 'Name', value: 'encodedLowerProof' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lowerPendingProof' } },
                { kind: 'Field', name: { kind: 'Name', value: 'readyToBeClaimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimBlockNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lowerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LowersQuery, LowersQueryVariables>;
export const LiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Lifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'receiver' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avnLifts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'receiver' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'receiver' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'when' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ewcTxHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sender' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'receiver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LiftsQuery, LiftsQueryVariables>;
export const GetPermitLiftAverageGasFeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPermitLiftAverageGasFee' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permitLiftGasFees' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'averageGasFee' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPermitLiftAverageGasFeeQuery,
  GetPermitLiftAverageGasFeeQueryVariables
>;
export const ClaimLowersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClaimLowers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sender' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avnLowers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sender' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sender' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'lowerId_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isFinalized' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPending' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lowerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'when' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lowerPendingProof' } },
                { kind: 'Field', name: { kind: 'Name', value: 'readyToBeClaimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'claimBlockNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClaimLowersQuery, ClaimLowersQueryVariables>;
export const GetSolutionsGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSolutionsGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'solutionGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'withdrawalDelay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationStartBlock' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationEndBlock' } },
                { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publisherInfo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorsConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedOperators' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasOperatorsAllowlist' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxOperatorWorkers' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stakingAmounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startBlock' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registrar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'friendlyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalLocation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptionRewardPerBlock' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'topPerformanceBonus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'votingRewardPerBlock' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNative' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetMetadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'decimals' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSolutionsGroupsQuery, GetSolutionsGroupsQueryVariables>;
export const GetSolutionGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSolutionGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'solutionGroupById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'withdrawalDelay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationStartBlock' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operationEndBlock' } },
                { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publisherInfo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorsConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'allowedOperators' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasOperatorsAllowlist' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxOperatorWorkers' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stakingAmounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startBlock' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registrar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'friendlyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalLocation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptionRewardPerBlock' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'topPerformanceBonus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'votingRewardPerBlock' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNative' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assetMetadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'decimals' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'solutions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionToExtraneousGroupsAllowed' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationBlock' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'workLogic' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'executionEnvironment' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationBlock' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'info' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSolutionGroupQuery, GetSolutionGroupQueryVariables>;
export const GetSubscriptionByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubscriptionById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solutionNamespace' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorAccounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id_eq' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'namespace_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'solutionNamespace' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'namespace' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubscriptionByIdQuery, GetSubscriptionByIdQueryVariables>;
export const GetLinkedWorkerNodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLinkedWorkerNode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workerAccounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'mapping' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'operator' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'operatorId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'address' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLinkedWorkerNodeQuery, GetLinkedWorkerNodeQueryVariables>;
export const GetUnclaimedRewardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUnclaimedRewards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unclaimedRewards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionReward' } },
                { kind: 'Field', name: { kind: 'Name', value: 'participationReward' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solutionGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnclaimedRewardsQuery, GetUnclaimedRewardsQueryVariables>;
export const GetEwtUsdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEwtUsd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currency' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ewtPriceById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currency' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'price' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEwtUsdQuery, GetEwtUsdQueryVariables>;
export const GetSolutionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSolutions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'solutions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'solutionGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publisherInfo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workload' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'workLogic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'executionEnvironment' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consensus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxWaitingThreshold' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voteThresholdPercent' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationBlock' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionToExtraneousGroupsAllowed' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nominationsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'namespace' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSolutionsQuery, GetSolutionsQueryVariables>;
export const GetCurrentRewardPeriodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCurrentRewardPeriod' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeRewardPeriodInfos' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'index_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'index' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentRewardPeriodQuery, GetCurrentRewardPeriodQueryVariables>;
export const GetScheduledUnsubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScheduledUnsubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentBlockNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unsubscriptionSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'operator' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'solutionGroup' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'unsubscribeBlock_gte' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'currentBlockNumber' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'unsubscribeBlock' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetScheduledUnsubscriptionQuery,
  GetScheduledUnsubscriptionQueryVariables
>;
export const GetCanOperatorWorkerVoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCanOperatorWorkerVote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solutionNamespace' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canOperatorWorkerVote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'solutionGroupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'solutionNamespace' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canVote' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCanOperatorWorkerVoteQuery, GetCanOperatorWorkerVoteQueryVariables>;
export const GetCanOperatorWorkersVoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCanOperatorWorkersVote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canOperatorWorkerVote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'operatorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'solutionGroupId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canVote' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCanOperatorWorkersVoteQuery,
  GetCanOperatorWorkersVoteQueryVariables
>;
